(function () {
  var DEFAULT_CLARITY_PROJECT_ID = 'uvskaqorur';
  var eventDedupCache = {};
  var eventDedupTtlMs = 15 * 60 * 1000;
  var SUPPRESS_BROWSER_POPUPS = true;
  var HIDE_COOKIE_BANNER_IN_PREVIEW = true;

  function installUserPromptGuards() {
    if (!SUPPRESS_BROWSER_POPUPS || typeof window === 'undefined') return;

    try {
      window.alert = function () {};
    } catch (_errAlert) {
      // noop
    }

    try {
      window.confirm = function () {
        return false;
      };
    } catch (_errConfirm) {
      // noop
    }

    try {
      window.prompt = function () {
        return null;
      };
    } catch (_errPrompt) {
      // noop
    }

    try {
      if ('Notification' in window && window.Notification && typeof window.Notification.requestPermission === 'function') {
        window.Notification.requestPermission = function (callback) {
          if (typeof callback === 'function') {
            try {
              callback('denied');
            } catch (_errCb) {
              // noop
            }
          }
          return Promise.resolve('denied');
        };
      }
    } catch (_errNotification) {
      // noop
    }

    try {
      document.documentElement.classList.add('nb-suppress-popups');
    } catch (_errHtmlClass) {
      // noop
    }

    if (document.body) {
      try {
        document.body.classList.add('nb-suppress-popups');
      } catch (_errBodyClass) {
        // noop
      }
      return;
    }

    document.addEventListener('DOMContentLoaded', function () {
      if (!document.body) return;
      try {
        document.body.classList.add('nb-suppress-popups');
      } catch (_errBodyReadyClass) {
        // noop
      }
    }, { once: true });
  }

  installUserPromptGuards();

  function cleanEventDedupCache() {
    var now = Date.now();
    Object.keys(eventDedupCache).forEach(function (key) {
      if (now - eventDedupCache[key] > eventDedupTtlMs) {
        delete eventDedupCache[key];
      }
    });
  }

  function buildEventDedupKey(payload) {
    if (!payload || !payload.event_id || !payload.event) return '';
    return String(payload.event) + '::' + String(payload.event_id);
  }

  function markEventSeen(payload) {
    var key = buildEventDedupKey(payload);
    if (!key) return true;
    cleanEventDedupCache();
    if (eventDedupCache[key]) return false;
    eventDedupCache[key] = Date.now();
    return true;
  }

  function createEventId(prefix) {
    return (prefix || 'nb') + '_' + Date.now() + '_' + Math.random().toString(36).slice(2, 10);
  }

  function withEventMeta(payload, prefix) {
    var eventName = payload && payload.event ? String(payload.event) : '';
    if (!eventName) return payload;
    if (!payload.event_id) payload.event_id = createEventId(prefix || eventName);
    if (!payload.event_time) payload.event_time = new Date().toISOString();
    return payload;
  }

  function pushEvent(payload) {
    if (!payload || typeof payload !== 'object') return;
    var attribution = captureAttribution();
    if (attribution && !payload.attribution) {
      payload.attribution = attribution;
    }
    if (!payload.context_path) {
      payload.context_path = window.location.pathname || '';
    }
    if (!payload.page_type) {
      payload.page_type = document.body ? (document.body.getAttribute('data-page-type') || '') : '';
    }
    if (!payload.template_name) {
      payload.template_name = document.body ? (document.body.getAttribute('data-template-name') || '') : '';
    }
    withEventMeta(payload);
    if (!markEventSeen(payload)) return payload.event_id || '';
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    try {
      if (
        window.Shopify &&
        window.Shopify.analytics &&
        typeof window.Shopify.analytics.publish === 'function'
      ) {
        window.Shopify.analytics.publish('nb_custom_tracking', payload);
      }
    } catch (_err) {
      // noop
    }
    document.dispatchEvent(new CustomEvent('nb:tracking', { detail: payload }));
    return payload.event_id || '';
  }

  function toFiniteNumber(value, fallback) {
    if (typeof value === 'number') {
      return Number.isFinite(value) ? value : fallback;
    }
    if (typeof value === 'string') {
      var normalized = value.trim();
      if (!normalized) return fallback;

      // Keep only numeric separators/sign and normalize locale-specific formats.
      normalized = normalized.replace(/\s+/g, '').replace(/[^\d,.\-]/g, '');
      if (!normalized) return fallback;

      var lastComma = normalized.lastIndexOf(',');
      var lastDot = normalized.lastIndexOf('.');

      if (lastComma > -1 && lastDot > -1) {
        if (lastComma > lastDot) {
          normalized = normalized.replace(/\./g, '').replace(',', '.');
        } else {
          normalized = normalized.replace(/,/g, '');
        }
      } else if (lastComma > -1) {
        normalized = normalized.replace(',', '.');
      } else {
        normalized = normalized.replace(/,/g, '');
      }

      var parsedString = Number(normalized);
      return Number.isFinite(parsedString) ? parsedString : fallback;
    }

    if (value && typeof value === 'object') {
      if (Object.prototype.hasOwnProperty.call(value, 'amount')) {
        return toFiniteNumber(value.amount, fallback);
      }
      if (Object.prototype.hasOwnProperty.call(value, 'value')) {
        return toFiniteNumber(value.value, fallback);
      }
    }

    var parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function normalizeCheckoutItems(items) {
    if (!Array.isArray(items)) return [];
    return items
      .map(function (item) {
        var raw = item || {};
        var quantity = toFiniteNumber(raw.quantity, 1);
        if (quantity < 1) quantity = 1;
        var price = toFiniteNumber(raw.price, 0);
        if (price < 0) price = 0;
        var normalized = {
          item_id: raw.item_id ? String(raw.item_id) : '',
          item_name: raw.item_name ? String(raw.item_name) : '',
          item_brand: raw.item_brand ? String(raw.item_brand) : 'Nordbelt',
          item_category: raw.item_category ? String(raw.item_category) : 'Nordic Curl Tool',
          price: Number(price.toFixed(2)),
          quantity: quantity
        };
        if (!normalized.item_id && !normalized.item_name) return null;
        return normalized;
      })
      .filter(function (item) {
        return !!item;
      });
  }

  function contentIdsFromItems(items) {
    return (items || [])
      .map(function (item) {
        if (!item || !item.item_id) return '';
        return String(item.item_id);
      })
      .filter(function (id) {
        return !!id;
      });
  }

  function getRuntimeBridge(name) {
    if (window && window[name]) return window[name];
    if (window.top && window.top !== window) {
      try {
        return window.top[name];
      } catch (_err) {
        return null;
      }
    }
    return null;
  }

  function getTrackingConfig() {
    var cfg = window.NordbeltTrackingConfig || {};
    if (typeof cfg !== 'object' || cfg === null) return {};
    return cfg;
  }

  function inferClarityProjectIdFromScripts() {
    var scripts = document.getElementsByTagName('script');
    for (var i = 0; i < scripts.length; i += 1) {
      var src = scripts[i] && scripts[i].src ? String(scripts[i].src) : '';
      if (!src || src.indexOf('clarity.ms/tag/') === -1) continue;
      var match = src.match(/clarity\.ms\/tag\/(?:shopify\/)?([a-z0-9]+)/i);
      if (match && match[1]) return String(match[1]).trim();
    }
    return '';
  }

  function hasStandardClarityScript(projectId) {
    if (!projectId) return false;
    var needle = 'clarity.ms/tag/' + projectId;
    var scripts = document.getElementsByTagName('script');
    for (var i = 0; i < scripts.length; i += 1) {
      var src = scripts[i] && scripts[i].src ? String(scripts[i].src) : '';
      if (!src || src.indexOf(needle) === -1) continue;
      if (src.indexOf('/tag/shopify/') === -1) return true;
    }
    return false;
  }

  function resolveClarityProjectId() {
    var cfg = getTrackingConfig();
    var configured = cfg && cfg.clarityProjectId ? String(cfg.clarityProjectId).trim() : '';
    if (configured) return configured;
    var inferred = inferClarityProjectIdFromScripts();
    if (inferred) return inferred;
    return DEFAULT_CLARITY_PROJECT_ID;
  }

  function initClarityRuntimeBridge() {
    var cfg = getTrackingConfig();
    if (cfg.clarityBridgeEnabled === false) return;
    var projectId = resolveClarityProjectId();
    if (!projectId) return;
    if (!cfg.clarityProjectId) cfg.clarityProjectId = projectId;

    if (typeof window.clarity !== 'function') {
      window.clarity = function () {
        window.clarity.q = window.clarity.q || [];
        window.clarity.q.push(arguments);
      };
    }

    function loadClarityScript() {
      if (hasStandardClarityScript(projectId)) return;
      if (document.querySelector('script[data-nb-clarity-loader]')) return;

      var script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.clarity.ms/tag/' + projectId;
      script.setAttribute('data-nb-clarity-loader', '1');

      var firstScript = document.getElementsByTagName('script')[0];
      if (firstScript && firstScript.parentNode) {
        firstScript.parentNode.insertBefore(script, firstScript);
      } else if (document.head) {
        document.head.appendChild(script);
      } else {
        document.documentElement.appendChild(script);
      }
    }

    function queueClarityLoad() {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(loadClarityScript, { timeout: 2600 });
      } else {
        window.setTimeout(loadClarityScript, 900);
      }
    }

    if (document.readyState === 'complete') {
      queueClarityLoad();
    } else {
      window.addEventListener('load', queueClarityLoad, { once: true });
    }
  }

  function safeParseJson(value, fallback) {
    try {
      return JSON.parse(value);
    } catch (_err) {
      return fallback;
    }
  }

  var runtimeI18nCache = null;

  function getRuntimeI18n() {
    if (runtimeI18nCache) return runtimeI18nCache;
    if (window.NordbeltI18n && typeof window.NordbeltI18n === 'object') {
      runtimeI18nCache = window.NordbeltI18n;
      return runtimeI18nCache;
    }

    var node = document.getElementById('nb-i18n-runtime');
    if (!node) {
      runtimeI18nCache = {};
      window.NordbeltI18n = runtimeI18nCache;
      return runtimeI18nCache;
    }

    runtimeI18nCache = safeParseJson(node.textContent || '{}', {});
    if (!runtimeI18nCache || typeof runtimeI18nCache !== 'object') {
      runtimeI18nCache = {};
    }
    window.NordbeltI18n = runtimeI18nCache;
    return runtimeI18nCache;
  }

  function getI18nValue(path) {
    if (!path) return '';
    var root = getRuntimeI18n();
    var segments = String(path).split('.');
    var cursor = root;
    for (var index = 0; index < segments.length; index += 1) {
      var segment = segments[index];
      if (!cursor || typeof cursor !== 'object' || !(segment in cursor)) return '';
      cursor = cursor[segment];
    }
    return cursor;
  }

  function interpolateI18n(template, vars) {
    var source = String(template || '');
    if (!vars || typeof vars !== 'object') return source;
    return source.replace(/\{\{\s*([a-zA-Z0-9_]+)\s*\}\}/g, function (_match, token) {
      if (!(token in vars)) return '';
      var value = vars[token];
      return value === null || value === undefined ? '' : String(value);
    });
  }

  function i18n(path, fallback, vars) {
    var fallbackText = fallback === null || fallback === undefined ? '' : String(fallback);
    var resolved = getI18nValue(path);
    var template = typeof resolved === 'string' && resolved ? resolved : fallbackText;
    return interpolateI18n(template, vars);
  }

  function isSwedishLocaleActive() {
    var htmlLang = normalizeLocaleCode(document.documentElement.getAttribute('lang') || '');
    if (htmlLang === 'sv' || localeBaseCode(htmlLang) === 'sv') return true;
    var cfg = window.NordbeltLocaleConfig || {};
    var currentLocale = normalizeLocaleCode(cfg.currentLocale || '');
    return currentLocale === 'sv' || localeBaseCode(currentLocale) === 'sv';
  }

  function normalizeSwedishKronaText(text) {
    var source = String(text || '');
    if (!source) return source;
    return source.replace(/(\d{1,3}(?:[.\s\u00A0]\d{3})*)\.(\d{2})\s*kr\b/gi, function (_match, intPart, decimals) {
      return String(intPart || '').replace(/\u00A0/g, ' ') + ',' + String(decimals || '') + ' kr';
    });
  }

  function shouldSkipSwedishPriceNode(node) {
    if (!node || !node.parentElement) return true;
    var tag = (node.parentElement.tagName || '').toUpperCase();
    if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'NOSCRIPT' || tag === 'TEMPLATE' || tag === 'TEXTAREA') {
      return true;
    }
    return false;
  }

  function normalizeSwedishKronaPricesInScope(scopeNode) {
    if (!isSwedishLocaleActive()) return;
    var scope = scopeNode || document.body;
    if (!scope) return;

    if (scope.nodeType === Node.TEXT_NODE) {
      if (shouldSkipSwedishPriceNode(scope)) return;
      var normalizedSingle = normalizeSwedishKronaText(scope.nodeValue || '');
      if (normalizedSingle !== scope.nodeValue) {
        scope.nodeValue = normalizedSingle;
      }
      return;
    }

    var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT);
    var textNode;
    while ((textNode = walker.nextNode())) {
      if (shouldSkipSwedishPriceNode(textNode)) continue;
      var original = textNode.nodeValue || '';
      if (original.indexOf('kr') === -1 && original.indexOf('KR') === -1) continue;
      var normalized = normalizeSwedishKronaText(original);
      if (normalized !== original) {
        textNode.nodeValue = normalized;
      }
    }
  }

  function initSwedishKronaPriceFormatting() {
    if (!isSwedishLocaleActive() || !window.MutationObserver || !document.body) return;

    var scheduled = false;
    function scheduleNormalize(scope) {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        normalizeSwedishKronaPricesInScope(scope || document.body);
      });
    }

    normalizeSwedishKronaPricesInScope(document.body);

    var observer = new MutationObserver(function (mutations) {
      var target = document.body;
      for (var i = 0; i < mutations.length; i += 1) {
        var mutation = mutations[i];
        if (mutation.type === 'characterData' && mutation.target) {
          target = mutation.target.parentElement || document.body;
          break;
        }
        if (mutation.addedNodes && mutation.addedNodes.length) {
          target = mutation.addedNodes[0];
          break;
        }
      }
      scheduleNormalize(target);
    });

    observer.observe(document.body, {
      subtree: true,
      childList: true,
      characterData: true
    });
  }

  var ATTRIBUTION_STORAGE_KEY = 'nb_attribution_v1';
  var ATTRIBUTION_TTL_MS = 90 * 24 * 60 * 60 * 1000;
  var attributionCache = null;

  function readStorageItem(storage, key) {
    if (!storage || !key) return '';
    try {
      return storage.getItem(key) || '';
    } catch (_err) {
      return '';
    }
  }

  function writeStorageItem(storage, key, value) {
    if (!storage || !key) return;
    try {
      storage.setItem(key, value);
    } catch (_err) {
      // noop
    }
  }

  var RESERVE_PANEL_NOTICE_KEY = 'nb_reserve_panel_notice_v1';

  function armReservePanelNotice() {
    writeStorageItem(window.sessionStorage, RESERVE_PANEL_NOTICE_KEY, '1');
  }

  function clearReservePanelNotice() {
    if (!window.sessionStorage) return;
    try {
      window.sessionStorage.removeItem(RESERVE_PANEL_NOTICE_KEY);
    } catch (_err) {
      // noop
    }
  }

  function consumeReservePanelNotice() {
    if (readStorageItem(window.sessionStorage, RESERVE_PANEL_NOTICE_KEY) !== '1') return false;
    clearReservePanelNotice();
    return true;
  }

  function buildAttributionFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var fields = [
      'utm_source',
      'utm_medium',
      'utm_campaign',
      'utm_term',
      'utm_content',
      'gclid',
      'fbclid',
      'msclkid',
      'ttclid'
    ];
    var source = {};
    var hasValue = false;

    fields.forEach(function (field) {
      var val = String(params.get(field) || '').trim();
      if (!val) return;
      source[field] = val;
      hasValue = true;
    });

    if (!hasValue) return null;

    source.landing_path = window.location.pathname || '';
    source.landing_query = window.location.search || '';
    source.landing_url = window.location.href || '';
    source.first_seen_at = new Date().toISOString();
    source.last_seen_at = source.first_seen_at;
    source.session_id = createEventId('attr');
    return source;
  }

  function readAttribution() {
    if (attributionCache) return attributionCache;
    var raw = readStorageItem(window.localStorage, ATTRIBUTION_STORAGE_KEY) || readStorageItem(window.sessionStorage, ATTRIBUTION_STORAGE_KEY);
    if (!raw) return null;
    var parsed = safeParseJson(raw, null);
    if (!parsed || typeof parsed !== 'object') return null;
    var createdAt = Date.parse(parsed.first_seen_at || '');
    if (!createdAt || (Date.now() - createdAt) > ATTRIBUTION_TTL_MS) {
      return null;
    }
    attributionCache = parsed;
    return parsed;
  }

  function writeAttribution(nextAttribution) {
    if (!nextAttribution || typeof nextAttribution !== 'object') return;
    attributionCache = nextAttribution;
    var payload = JSON.stringify(nextAttribution);
    writeStorageItem(window.localStorage, ATTRIBUTION_STORAGE_KEY, payload);
    writeStorageItem(window.sessionStorage, ATTRIBUTION_STORAGE_KEY, payload);
  }

  function mergeAttribution(existing, incoming) {
    if (!existing) return incoming || null;
    if (!incoming) return existing;

    var merged = {};
    Object.keys(existing).forEach(function (key) {
      merged[key] = existing[key];
    });
    Object.keys(incoming).forEach(function (key) {
      if (incoming[key]) merged[key] = incoming[key];
    });
    merged.last_seen_at = new Date().toISOString();
    if (!merged.session_id) merged.session_id = createEventId('attr');
    if (!merged.first_seen_at) merged.first_seen_at = merged.last_seen_at;
    return merged;
  }

  function captureAttribution() {
    var cfg = getTrackingConfig();
    if (cfg.attributionEnabled === false) return null;
    var existing = readAttribution();
    var fromUrl = buildAttributionFromUrl();
    var next = mergeAttribution(existing, fromUrl);
    if (next) writeAttribution(next);
    return next;
  }

  function isCheckoutPath(pathname) {
    var path = String(pathname || '').toLowerCase();
    return path.indexOf('/checkout') !== -1;
  }

  function trackBeginCheckout(options) {
    var settings = options || {};
    var value = toFiniteNumber(settings.value, 0);
    if (value < 0) value = 0;
    var items = normalizeCheckoutItems(settings.items || []);
    var contentIds = Array.isArray(settings.content_ids) ? settings.content_ids : contentIdsFromItems(items);
    var payload = {
      event: 'begin_checkout',
      event_id: settings.event_id || createEventId('begin_checkout'),
      context_path: settings.context_path || window.location.pathname || '',
      checkout_entrypoint: settings.checkout_entrypoint || 'unknown',
      checkout_redirect_attempt: toFiniteNumber(settings.checkout_redirect_attempt, 1),
      checkout_redirect_result: settings.checkout_redirect_result || 'initiated',
      ecommerce: {
        currency: settings.currency || 'EUR',
        value: Number(value.toFixed(2))
      }
    };
    if (items.length) payload.ecommerce.items = items;
    if (contentIds.length) {
      payload.content_ids = contentIds;
      payload.content_type = settings.content_type || 'product';
    }
    pushEvent(payload);
    return payload.event_id;
  }

  function trackCheckoutRedirectFailure(options) {
    var settings = options || {};
    var payload = {
      event: 'checkout_redirect_failed',
      event_id: settings.event_id || createEventId('checkout_redirect_failed'),
      context_path: settings.context_path || window.location.pathname || '',
      checkout_entrypoint: settings.checkout_entrypoint || 'unknown',
      checkout_redirect_attempt: toFiniteNumber(settings.checkout_redirect_attempt, 1),
      checkout_redirect_result: settings.checkout_redirect_result || 'failed',
      browser_name: navigator.userAgentData && navigator.userAgentData.brands && navigator.userAgentData.brands.length
        ? navigator.userAgentData.brands.map(function (brand) { return brand.brand; }).join(', ')
        : '',
      browser_user_agent: navigator.userAgent || '',
      browser_platform: navigator.platform || '',
      browser_language: navigator.language || '',
      cart_item_count: toFiniteNumber(settings.cart_item_count, 0)
    };
    if (settings.cart_snapshot && typeof settings.cart_snapshot === 'object') {
      payload.cart_snapshot = settings.cart_snapshot;
    }
    var value = toFiniteNumber(settings.value, NaN);
    if (Number.isFinite(value)) {
      payload.ecommerce = {
        currency: settings.currency || 'EUR',
        value: Number(Math.max(0, value).toFixed(2)),
        items: normalizeCheckoutItems(settings.items || [])
      };
    }
    pushEvent(payload);
    return payload.event_id;
  }

  window.NordbeltTheme = window.NordbeltTheme || {};
  window.NordbeltTheme.createEventId = createEventId;
  window.NordbeltTheme.pushEvent = pushEvent;
  window.NordbeltTheme.buildShopifyPathWithPreview = buildShopifyPathWithPreview;
  window.NordbeltTheme.trackBeginCheckout = trackBeginCheckout;
  window.NordbeltTheme.trackCheckoutRedirectFailure = trackCheckoutRedirectFailure;

  function initViewItemTracking() {
    var node = document.querySelector('[data-nb-view-item]');
    if (!node) return;
    var parsed;
    try {
      parsed = JSON.parse(node.textContent || '{}');
    } catch (_err) {
      parsed = null;
    }
    if (parsed) pushEvent(parsed);
  }

  function initCartViewTracking() {
    var form = document.querySelector('[data-nb-cart-form]');
    if (!form) return;
    var itemNodes = Array.prototype.slice.call(form.querySelectorAll('[data-nb-cart-item]'));
    if (!itemNodes.length) return;

    var items = itemNodes
      .map(function (itemNode) {
        var quantity = toFiniteNumber(itemNode.getAttribute('data-item-quantity'), 1);
        if (quantity < 1) quantity = 1;
        var price = toFiniteNumber(itemNode.getAttribute('data-item-price'), 0);
        if (price < 0) price = 0;
        return {
          item_id: itemNode.getAttribute('data-item-id') || '',
          item_name: itemNode.getAttribute('data-item-name') || '',
          item_brand: 'Nordbelt',
          item_category: 'Nordic Curl Tool',
          price: Number(price.toFixed(2)),
          quantity: quantity
        };
      })
      .filter(function (item) {
        return Boolean(item.item_id || item.item_name);
      });
    if (!items.length) return;

    var total = toFiniteNumber(form.getAttribute('data-cart-total'), 0);
    if (total < 0) total = 0;
    pushEvent({
      event: 'view_cart',
      ecommerce: {
        currency: form.getAttribute('data-cart-currency') || 'EUR',
        value: Number(total.toFixed(2)),
        items: items
      },
      content_ids: contentIdsFromItems(items),
      content_type: 'product'
    });
  }

  function initSearchTracking() {
    var body = document.body;
    if (!body || (body.getAttribute('data-page-type') || '') !== 'search') return;
    var params = new URLSearchParams(window.location.search);
    var term = String(params.get('q') || '').trim();
    if (!term) return;
    pushEvent({
      event: 'search',
      search_term: term
    });
  }

  function initPurchaseTrackingFallback() {
    var checkout = window.Shopify && window.Shopify.checkout ? window.Shopify.checkout : null;
    if (!checkout || typeof checkout !== 'object') return;
    var transactionId = checkout.order_id || checkout.order_number || '';
    if (!transactionId) return;

    var dedupeKey = 'nb_purchase_tracked_' + String(transactionId);
    if (readStorageItem(window.sessionStorage, dedupeKey) === '1') return;

    var lineItems = Array.isArray(checkout.line_items) ? checkout.line_items : [];
    var items = lineItems
      .map(function (item) {
        if (!item) return null;
        var quantity = toFiniteNumber(item.quantity, 1);
        if (quantity < 1) quantity = 1;
        var price = toFiniteNumber(item.price, 0);
        if (price < 0) price = 0;
        return {
          item_id: item.product_id ? String(item.product_id) : (item.variant_id ? String(item.variant_id) : ''),
          item_name: item.title ? String(item.title) : '',
          item_brand: item.vendor ? String(item.vendor) : 'Nordbelt',
          item_category: 'Nordic Curl Tool',
          price: Number(price.toFixed(2)),
          quantity: quantity
        };
      })
      .filter(function (item) {
        return !!item;
      });

    var rawCheckoutTotal = checkout.total_price != null ? checkout.total_price : checkout.subtotal_price;
    var value = toFiniteNumber(rawCheckoutTotal, 0);

    if (typeof rawCheckoutTotal === 'string') {
      var totalRawText = rawCheckoutTotal.trim();
      // Shopify payloads without decimal separators are typically minor units (cents).
      if (totalRawText && totalRawText.indexOf('.') === -1 && totalRawText.indexOf(',') === -1) {
        value = value / 100;
      }
    } else if (typeof rawCheckoutTotal === 'number' && Number.isInteger(rawCheckoutTotal) && rawCheckoutTotal >= 1000) {
      value = value / 100;
    }

    if (!(value > 0) && items.length) {
      value = items.reduce(function (sum, item) {
        var price = toFiniteNumber(item && item.price, 0);
        var quantity = toFiniteNumber(item && item.quantity, 1);
        if (quantity < 1) quantity = 1;
        return sum + (price * quantity);
      }, 0);
    }

    pushEvent({
      event: 'purchase',
      transaction_id: String(transactionId),
      ecommerce: {
        currency: checkout.currency || 'EUR',
        value: Number(Math.max(0, value).toFixed(2)),
        items: items
      },
      content_ids: contentIdsFromItems(items),
      content_type: 'product'
    });
    writeStorageItem(window.sessionStorage, dedupeKey, '1');
  }

  function setAtcButtonState(button, state) {
    if (!button) return;
    if (!button.dataset.originalLabel) {
      button.dataset.originalLabel = button.textContent || i18n('atc.default', 'Aan winkelwagen toevoegen');
    }

    if (state === 'loading') {
      button.disabled = true;
      button.textContent = i18n('atc.loading', 'Toevoegen...');
      return;
    }

    if (state === 'success') {
      button.disabled = false;
      button.textContent = i18n('atc.success', 'Toegevoegd');
      window.setTimeout(function () {
        button.textContent = button.dataset.originalLabel;
      }, 1400);
      return;
    }

    if (state === 'error') {
      button.disabled = false;
      button.textContent = i18n('atc.error', 'Probeer opnieuw');
      window.setTimeout(function () {
        button.textContent = button.dataset.originalLabel;
      }, 1800);
      return;
    }

    button.disabled = false;
    button.textContent = button.dataset.originalLabel;
  }

  function updateCartBadge(count) {
    var normalizedCount = Math.max(0, Math.round(toFiniteNumber(count, 0)));
    var cartLinks = document.querySelectorAll('a[href$="/cart"], a[href="/cart"]');
    cartLinks.forEach(function (link) {
      var badge = link.querySelector('.nb-cart-badge');
      if (!badge && normalizedCount > 0) {
        badge = document.createElement('span');
        badge.className = 'nb-cart-badge';
        link.style.position = 'relative';
        link.appendChild(badge);
      }
      if (badge) {
        if (normalizedCount > 0) {
          badge.textContent = String(normalizedCount);
        } else {
          badge.remove();
        }
      }
    });

    var header = document.querySelector('[data-nb-header]');
    if (header) {
      header.setAttribute('data-cart-count', String(normalizedCount));
    }

    document.dispatchEvent(new CustomEvent('nb:cart-count-updated', {
      detail: { count: normalizedCount }
    }));
  }

  function buildShopifyPathWithPreview(pathname) {
    var nextUrl = new URL(pathname, window.location.origin);
    var localizedPath = buildLocalizedStorefrontPath(nextUrl.pathname || '/');
    if (localizedPath) {
      nextUrl.pathname = localizedPath;
    }
    var current = new URL(window.location.href);
    ['preview_theme_id', 'key', 'pb', '_ab', '_fd', '_sc'].forEach(function (key) {
      if (current.searchParams.has(key)) {
        nextUrl.searchParams.set(key, current.searchParams.get(key) || '');
      }
    });
    return nextUrl.toString();
  }

  var LOCALE_CART_TRANSFER_STORAGE_KEY = 'nb_locale_cart_transfer_v1';
  var LOCALE_CART_TRANSFER_TTL_MS = 15 * 60 * 1000;

  function clearLocaleCartTransferSnapshot() {
    if (!window.sessionStorage) return;
    try {
      window.sessionStorage.removeItem(LOCALE_CART_TRANSFER_STORAGE_KEY);
    } catch (_err) {
      // noop
    }
  }

  function normalizeLocaleCartTransferPayloadItem(item) {
    if (!item || typeof item !== 'object') return null;
    var itemId = String(item.id || '').trim();
    if (!itemId) return null;

    var quantity = Math.max(1, Math.round(toFiniteNumber(item.quantity, 1)));
    var normalized = {
      id: itemId,
      quantity: quantity
    };

    if (item.properties && typeof item.properties === 'object') {
      var properties = {};
      Object.keys(item.properties).forEach(function (key) {
        var propKey = String(key || '').trim();
        if (!propKey) return;
        var propValue = item.properties[key];
        if (propValue === null || propValue === undefined) return;
        var valueString = String(propValue).trim();
        if (!valueString) return;
        properties[propKey] = valueString;
      });
      if (Object.keys(properties).length) normalized.properties = properties;
    }

    var sellingPlan = String(item.selling_plan || '').trim();
    if (sellingPlan) normalized.selling_plan = sellingPlan;

    return normalized;
  }

  function normalizeLocaleCartSnapshotItem(item) {
    if (!item || typeof item !== 'object') return null;

    var variantId = String(item.variant_id || item.id || '').trim();
    if (!variantId) return null;

    var quantity = Math.max(1, Math.round(toFiniteNumber(item.quantity, 1)));
    var normalized = {
      id: variantId,
      quantity: quantity
    };

    if (item.properties && typeof item.properties === 'object') {
      var properties = {};
      Object.keys(item.properties).forEach(function (key) {
        var propKey = String(key || '').trim();
        if (!propKey) return;
        var propValue = item.properties[key];
        if (propValue === null || propValue === undefined) return;
        var valueString = String(propValue).trim();
        if (!valueString) return;
        properties[propKey] = valueString;
      });
      if (Object.keys(properties).length) normalized.properties = properties;
    }

    var sellingPlanId = '';
    if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
      sellingPlanId = String(item.selling_plan_allocation.selling_plan.id || '').trim();
    }
    if (!sellingPlanId && item.selling_plan_allocation) {
      sellingPlanId = String(item.selling_plan_allocation.selling_plan_id || '').trim();
    }
    if (!sellingPlanId && item.selling_plan) {
      sellingPlanId = String(item.selling_plan).trim();
    }
    if (sellingPlanId) normalized.selling_plan = sellingPlanId;

    return normalized;
  }

  function readLocaleCartTransferSnapshot() {
    var raw = readStorageItem(window.sessionStorage, LOCALE_CART_TRANSFER_STORAGE_KEY);
    if (!raw) return null;

    var parsed = safeParseJson(raw, null);
    if (!parsed || typeof parsed !== 'object') {
      clearLocaleCartTransferSnapshot();
      return null;
    }

    var createdAt = toFiniteNumber(parsed.createdAt, 0);
    if (!(createdAt > 0)) {
      clearLocaleCartTransferSnapshot();
      return null;
    }

    if (Date.now() - createdAt > LOCALE_CART_TRANSFER_TTL_MS) {
      clearLocaleCartTransferSnapshot();
      return null;
    }

    var items = Array.isArray(parsed.items) ? parsed.items : [];
    if (!items.length) {
      clearLocaleCartTransferSnapshot();
      return null;
    }

    parsed.items = items
      .map(normalizeLocaleCartTransferPayloadItem)
      .filter(function (item) {
        return !!item;
      });

    if (!parsed.items.length) {
      clearLocaleCartTransferSnapshot();
      return null;
    }

    return parsed;
  }

  function snapshotCartForLocaleTransfer() {
    if (!window.fetch) return Promise.resolve(null);
    return fetch('/cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response || !response.ok) return null;
        return response.json();
      })
      .then(function (cart) {
        var items = cart && Array.isArray(cart.items) ? cart.items : [];
        if (!items.length) {
          clearLocaleCartTransferSnapshot();
          return null;
        }

        var normalizedItems = items
          .map(normalizeLocaleCartSnapshotItem)
          .filter(function (item) {
            return !!item;
          });

        if (!normalizedItems.length) {
          clearLocaleCartTransferSnapshot();
          return null;
        }

        var payload = {
          createdAt: Date.now(),
          sourcePath: (window.location.pathname || '/') + (window.location.search || ''),
          itemCount: Math.max(0, Math.round(toFiniteNumber(cart.item_count, normalizedItems.length))),
          currency: String(cart.currency || ''),
          items: normalizedItems
        };

        if (typeof cart.note === 'string' && cart.note.trim()) {
          payload.note = cart.note;
        }

        if (cart.attributes && typeof cart.attributes === 'object') {
          var attributes = {};
          Object.keys(cart.attributes).forEach(function (key) {
            var attrKey = String(key || '').trim();
            if (!attrKey) return;
            var attrValue = cart.attributes[key];
            if (attrValue === null || attrValue === undefined) return;
            var valueString = String(attrValue).trim();
            if (!valueString) return;
            attributes[attrKey] = valueString;
          });
          if (Object.keys(attributes).length) {
            payload.attributes = attributes;
          }
        }

        writeStorageItem(window.sessionStorage, LOCALE_CART_TRANSFER_STORAGE_KEY, JSON.stringify(payload));
        return payload;
      })
      .catch(function () {
        return null;
      });
  }

  function restoreCartAfterLocaleSwitch() {
    if (!window.fetch) return;
    var snapshot = readLocaleCartTransferSnapshot();
    if (!snapshot) return;

    fetch('/cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response || !response.ok) return null;
        return response.json();
      })
      .then(function (cart) {
        var currentCount = Math.max(0, Math.round(toFiniteNumber(cart && cart.item_count, 0)));
        if (currentCount > 0) {
          clearLocaleCartTransferSnapshot();
          updateCartBadge(currentCount);
          return null;
        }

        if (!snapshot.items || !snapshot.items.length) {
          clearLocaleCartTransferSnapshot();
          return null;
        }

        return fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ items: snapshot.items })
        })
          .then(function (addResponse) {
            if (!addResponse || !addResponse.ok) throw new Error('locale-cart-restore-failed');
            return addResponse.json();
          })
          .then(function () {
            var hasNote = typeof snapshot.note === 'string' && snapshot.note.trim();
            var hasAttributes = snapshot.attributes && typeof snapshot.attributes === 'object' && Object.keys(snapshot.attributes).length;
            if (!hasNote && !hasAttributes) return null;
            return fetch('/cart/update.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
              },
              body: JSON.stringify({
                note: hasNote ? snapshot.note : '',
                attributes: hasAttributes ? snapshot.attributes : {}
              })
            }).catch(function () {
              return null;
            });
          })
          .then(function () {
            return fetch('/cart.js', {
              method: 'GET',
              credentials: 'same-origin',
              headers: { Accept: 'application/json' }
            });
          })
          .then(function (finalResponse) {
            if (!finalResponse || !finalResponse.ok) return null;
            return finalResponse.json();
          })
          .then(function (finalCart) {
            clearLocaleCartTransferSnapshot();
            var restoredCount = Math.max(0, Math.round(toFiniteNumber(finalCart && finalCart.item_count, snapshot.itemCount || 0)));
            updateCartBadge(restoredCount);
            if (/\/cart(?:\/|$)/i.test(String(window.location.pathname || ''))) {
              window.location.reload();
            }
          })
          .catch(function () {
            clearLocaleCartTransferSnapshot();
          });
      })
      .catch(function () {
        clearLocaleCartTransferSnapshot();
      });
  }

  function initAtcTracking() {
    var forms = document.querySelectorAll('[data-nb-atc-form]');
    if (!forms.length) return;

    forms.forEach(function (form) {
      form.addEventListener('submit', function (event) {
        if (form.dataset.nbSubmitting === '1') {
          event.preventDefault();
          return;
        }

        var submitter = event.submitter && event.submitter.matches('[data-nb-atc-submit]') ? event.submitter : null;
        var submitButton = submitter || form.querySelector('[data-nb-atc-submit]');
        var redirectTarget = (submitter && submitter.getAttribute('data-nb-atc-redirect')) || form.getAttribute('data-nb-atc-redirect') || '';
        redirectTarget = redirectTarget.trim().toLowerCase();
        var submitMode = (form.getAttribute('data-nb-atc-mode') || 'native').trim().toLowerCase();
        var useAjax = submitMode === 'ajax' && !!window.fetch && !!window.FormData;

        form.dataset.nbSubmitting = '1';
        setAtcButtonState(submitButton, 'loading');

        var quantityInput = form.querySelector('input[name="quantity"]');
        var quantity = Number(quantityInput && quantityInput.value ? quantityInput.value : 1);
        if (!Number.isFinite(quantity) || quantity < 1) quantity = 1;
        var variantInput = form.querySelector('[name="id"]');
        var unitPrice = Number(form.getAttribute('data-product-price') || 0);
        var currency = form.getAttribute('data-product-currency') || '';
        var itemId = variantInput && variantInput.value ? String(variantInput.value) : (form.getAttribute('data-product-id') || '');
        var normalizedUnitPrice = Number(Math.max(0, unitPrice).toFixed(2));
        var addToCartPayload = {
          event: 'add_to_cart',
          context_path: window.location.pathname,
          ecommerce: {
            currency: currency,
            value: Number((normalizedUnitPrice * quantity).toFixed(2)),
            items: [
              {
                item_id: itemId,
                item_name: form.getAttribute('data-product-title') || '',
                item_brand: 'Nordbelt',
                item_category: 'Nordic Curl Tool',
                price: normalizedUnitPrice,
                quantity: quantity
              }
            ]
          },
          content_ids: [itemId],
          content_type: 'product'
        };

        if (!useAjax) {
          armReservePanelNotice();
          // Native Shopify submit path is the most robust for cart/checkout reliability.
          return;
        }

        event.preventDefault();
        var formData = new FormData(form);
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData
        })
          .then(function (res) {
            if (!res.ok) throw new Error('ATC failed');
            return res.json();
          })
          .then(function (_item) {
            armReservePanelNotice();
            pushEvent(addToCartPayload);
            if (redirectTarget === 'checkout') {
              var checkoutEntrypoint = (submitter && submitter.getAttribute('data-nb-checkout-entrypoint')) || form.getAttribute('data-nb-checkout-entrypoint') || 'product_direct';
              var checkoutEventId = trackBeginCheckout({
                checkout_entrypoint: (submitter && submitter.getAttribute('data-nb-checkout-entrypoint')) || form.getAttribute('data-nb-checkout-entrypoint') || 'product_direct',
                checkout_redirect_attempt: 1,
                checkout_redirect_result: 'redirecting',
                value: Number((normalizedUnitPrice * quantity).toFixed(2)),
                currency: currency,
                items: addToCartPayload.ecommerce.items,
                content_ids: addToCartPayload.content_ids,
                content_type: addToCartPayload.content_type
              });
              var checkoutUrl = buildShopifyPathWithPreview('/checkout');
              window.location.assign(checkoutUrl);
              window.setTimeout(function () {
                if (document.visibilityState !== 'visible') return;
                if (isCheckoutPath(window.location.pathname || '')) return;
                trackCheckoutRedirectFailure({
                  event_id: checkoutEventId,
                  checkout_entrypoint: checkoutEntrypoint,
                  checkout_redirect_attempt: 2,
                  checkout_redirect_result: 'not_on_checkout_after_redirect',
                  value: Number((normalizedUnitPrice * quantity).toFixed(2)),
                  currency: currency,
                  items: addToCartPayload.ecommerce.items,
                  cart_item_count: quantity
                });
                window.location.assign(checkoutUrl);
              }, 1200);
              return;
            }

            if (redirectTarget === 'cart') {
              window.location.assign(buildShopifyPathWithPreview('/cart'));
              return;
            }

            // Cart badge refresh is non-critical; avoid breaking flow on redirects/CORS edge cases.
            fetch('/cart.js', { headers: { Accept: 'application/json' } })
              .then(function (res) {
                if (!res.ok) return null;
                return res.json();
              })
              .then(function (cart) {
                if (!cart) return;
                updateCartBadge(Number(cart && cart.item_count ? cart.item_count : 0));
              })
              .catch(function () {
                // noop
              });

            setAtcButtonState(submitButton, 'success');
          })
          .catch(function () {
            setAtcButtonState(submitButton, 'error');
            // Fallback to Shopify native form submit if AJAX add fails for any reason.
            try {
              armReservePanelNotice();
              form.submit();
            } catch (_err) {
              // noop
            }
          })
          .finally(function () {
            form.dataset.nbSubmitting = '0';
          });
      });
    });
  }

  function initBeginCheckoutTracking() {
    var nodes = document.querySelectorAll('a[data-nb-begin-checkout]:not([data-nb-checkout-trigger])');
    nodes.forEach(function (node) {
      node.addEventListener('click', function () {
        trackBeginCheckout({
          checkout_entrypoint: node.getAttribute('data-nb-checkout-entrypoint') || 'generic_link',
          checkout_redirect_attempt: 1,
          checkout_redirect_result: 'tracked_only'
        });
      });
    });
  }

  function initAdPlatformBridges() {
    function isStandardEcommerceEvent(eventName) {
      return eventName === 'view_item' || eventName === 'add_to_cart' || eventName === 'begin_checkout' || eventName === 'purchase' || eventName === 'view_cart' || eventName === 'search';
    }

    function buildGoogleAdsConversionPayload(payload) {
      var ecommerce = payload && payload.ecommerce ? payload.ecommerce : {};
      var value = toFiniteNumber(ecommerce.value, NaN);
      if (!Number.isFinite(value)) {
        value = toFiniteNumber(payload && payload.value, NaN);
      }
      if (!Number.isFinite(value) && Array.isArray(ecommerce.items) && ecommerce.items.length) {
        value = ecommerce.items.reduce(function (sum, item) {
          var itemPrice = toFiniteNumber(item && item.price, 0);
          var itemQuantity = toFiniteNumber(item && item.quantity, 1);
          if (itemQuantity < 1) itemQuantity = 1;
          return sum + (itemPrice * itemQuantity);
        }, 0);
      }
      if (!Number.isFinite(value) || value < 0) value = 0;
      return {
        value: Number(value.toFixed(2)),
        currency: ecommerce.currency || 'EUR',
        transaction_id: payload.transaction_id || payload.event_id || ''
      };
    }

    function resolveGoogleAdsSendTo(eventName) {
      var cfg = getTrackingConfig();
      var map = cfg && cfg.googleAdsSendTo ? cfg.googleAdsSendTo : {};
      var sendTo = map && map[eventName] ? String(map[eventName]).trim() : '';
      return sendTo;
    }

    document.addEventListener('nb:tracking', function (event) {
      var payload = event && event.detail ? event.detail : null;
      if (!payload || !payload.event) return;
      var eventName = String(payload.event || '').trim();
      if (!eventName) return;
      var trackingConfig = getTrackingConfig();
      var allowManualBridge = trackingConfig.manualAdBridgeEnabled === true;
      var allowStandardBridge = allowManualBridge || !isStandardEcommerceEvent(eventName);

      try {
        var gtag = getRuntimeBridge('gtag');
        if (typeof gtag === 'function') {
          if (allowStandardBridge) {
            gtag('event', eventName, payload);
          }
          var googleAdsSendTo = resolveGoogleAdsSendTo(eventName);
          if (googleAdsSendTo) {
            gtag('event', 'conversion', Object.assign({ send_to: googleAdsSendTo }, buildGoogleAdsConversionPayload(payload)));
          }
        }
      } catch (_err) {
        // noop
      }

      try {
        var fbq = getRuntimeBridge('fbq');
        if (typeof fbq === 'function' && allowStandardBridge) {
          var map = {
            view_item: { name: 'ViewContent', method: 'track' },
            add_to_cart: { name: 'AddToCart', method: 'track' },
            begin_checkout: { name: 'InitiateCheckout', method: 'track' },
            purchase: { name: 'Purchase', method: 'track' },
            checkout_redirect_failed: { name: 'CheckoutRedirectFailed', method: 'trackCustom' }
          };
          var mappedMetaEvent = map[eventName];
          if (mappedMetaEvent) {
            var ecommerce = payload.ecommerce || {};
            var itemList = ecommerce.items || [];
            var firstItem = itemList[0] || {};
            fbq(
              mappedMetaEvent.method,
              mappedMetaEvent.name,
              {
                value: ecommerce.value || firstItem.price || 0,
                currency: ecommerce.currency || 'EUR',
                content_type: payload.content_type || 'product',
                content_ids: payload.content_ids || (firstItem.item_id ? [firstItem.item_id] : []),
                num_items: firstItem.quantity || 1,
                checkout_entrypoint: payload.checkout_entrypoint || ''
              },
              { eventID: payload.event_id || createEventId('meta') }
            );
          }
        }
      } catch (_err2) {
        // noop
      }

      try {
        var uetq = getRuntimeBridge('uetq');
        if (uetq && typeof uetq.push === 'function' && allowStandardBridge) {
          var uetEventMap = {
            add_to_cart: 'add_to_cart',
            begin_checkout: 'begin_checkout',
            purchase: 'purchase',
            checkout_redirect_failed: 'checkout_redirect_failed'
          };
          var uetEventName = uetEventMap[eventName];
          if (uetEventName) {
            var uetEcommerce = payload.ecommerce || {};
            uetq.push('event', uetEventName, {
              event_category: 'ecommerce',
              event_label: payload.checkout_entrypoint || payload.context_path || '',
              revenue_value: Number(toFiniteNumber(uetEcommerce.value, 0).toFixed(2)),
              currency: uetEcommerce.currency || 'EUR'
            });
          }
        }
      } catch (_err3) {
        // noop
      }

      try {
        if (trackingConfig.clarityBridgeEnabled === false) return;
        var clarity = getRuntimeBridge('clarity');
        if (typeof clarity !== 'function') return;

        clarity('event', 'nb_' + eventName);
        clarity('set', 'nb_last_event', eventName);
        if (payload.event_id) clarity('set', 'nb_last_event_id', payload.event_id);
        if (payload.page_type) clarity('set', 'nb_page_type', String(payload.page_type));
        if (payload.ecommerce && Number.isFinite(Number(payload.ecommerce.value))) {
          clarity('set', 'nb_last_value', String(Number(payload.ecommerce.value).toFixed(2)));
        }
        if (payload.attribution && payload.attribution.utm_source) {
          clarity('set', 'nb_utm_source', String(payload.attribution.utm_source));
        }
        if (payload.attribution && payload.attribution.utm_campaign) {
          clarity('set', 'nb_utm_campaign', String(payload.attribution.utm_campaign));
        }
      } catch (_err4) {
        // noop
      }
    });
  }

  function normalizeCtaText(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function getConversionCtaRouteTargets() {
    var body = document.body;
    if (!body) {
      return {
        buyNowUrl: '',
        productUrl: ''
      };
    }

    var buyNowUrl = (body.getAttribute('data-nb-buy-now-url') || '').trim();
    var productUrl = (body.getAttribute('data-nb-product-url') || '').trim();

    return {
      buyNowUrl: buyNowUrl ? buildShopifyPathWithPreview(buyNowUrl) : '',
      productUrl: productUrl ? buildShopifyPathWithPreview(productUrl) : ''
    };
  }

  function getCtaNodeText(node) {
    if (!node) return '';
    var tagName = node.tagName ? node.tagName.toUpperCase() : '';
    if (tagName === 'INPUT') return node.value || '';
    return node.textContent || '';
  }

  function applyConversionPreviewPaths(rootNode) {
    var scope = rootNode && rootNode.querySelectorAll ? rootNode : document;
    var links = scope.querySelectorAll('[data-nb-conv-preview-path]');
    if (!links.length) return;
    links.forEach(function (link) {
      if (!link || !link.getAttribute) return;
      var path = String(link.getAttribute('data-nb-conv-preview-path') || '').trim();
      if (!path) return;
      link.setAttribute('href', buildShopifyPathWithPreview(path));
    });
  }

  function applyConversionCtaRoutes(rootNode) {
    var targets = getConversionCtaRouteTargets();
    if (!targets.buyNowUrl && !targets.productUrl) return;
    var buyShortNeedle = normalizeCtaText(i18n('shared.buy_short', 'Koop nu'));
    var buyNowNeedle = normalizeCtaText(i18n('shared.buy_now', 'Koop nu voor [price]')).replace('[price]', '').trim();
    var viewProductNeedle = normalizeCtaText(i18n('shared.view_product', 'Bekijk product'));
    var BUY_NOW_CTA_IDS = {
      header_primary: true,
      header_primary_mobile: true,
      hero_primary: true,
      home_guide_steps_primary: true,
      home_nhc_benefits_primary: true,
      home_guide_showcase_primary: true,
      purpose_primer_primary: true,
      purpose_primer_primary_mobile: true,
      guide_primary_cta: true,
      how_it_works_cta: true,
      feature_split_primary: true,
      global_mobile_buy_now: true,
      home_mobile_sticky_to_product: true
    };
    var STATIC_BUY_NEEDLES = [
      'koop nu',
      'buy now',
      'jetzt kaufen',
      'kauf jetzt',
      'achetez',
      'acheter',
      'køb nu',
      'köp nu',
      'kjøp nå'
    ];

    function textContainsNeedle(text, needle) {
      if (!needle) return false;
      return text.indexOf(needle) !== -1;
    }

    var scope = rootNode && rootNode.querySelectorAll ? rootNode : document;
    var nodes = scope.querySelectorAll('a, button, input[type="button"], input[type="submit"]');
    nodes.forEach(function (node) {
      var text = normalizeCtaText(getCtaNodeText(node));
      if (!text) return;
      var ctaId = String((node.getAttribute && node.getAttribute('data-nb-cta')) || '').trim().toLowerCase();

      var routeUrl = '';
      if (targets.buyNowUrl && ctaId && BUY_NOW_CTA_IDS[ctaId]) {
        routeUrl = targets.buyNowUrl;
      } else if (targets.productUrl && viewProductNeedle && text.indexOf(viewProductNeedle) !== -1) {
        routeUrl = targets.productUrl;
      } else if (
        targets.buyNowUrl &&
        (
          textContainsNeedle(text, buyShortNeedle) ||
          textContainsNeedle(text, buyNowNeedle) ||
          STATIC_BUY_NEEDLES.some(function (needle) { return textContainsNeedle(text, needle); })
        )
      ) {
        routeUrl = targets.buyNowUrl;
      }
      if (!routeUrl) return;

      var tagName = node.tagName ? node.tagName.toUpperCase() : '';
      if (tagName === 'A') {
        node.setAttribute('href', routeUrl);
        return;
      }

      if (node.dataset.nbRouteBound === 'true' && node.dataset.nbRouteTarget === routeUrl) return;
      node.dataset.nbRouteTarget = routeUrl;
      if (node.dataset.nbRouteBound === 'true') return;
      node.dataset.nbRouteBound = 'true';

      node.addEventListener('click', function (event) {
        var targetUrl = node.getAttribute('data-nb-route-target') || '';
        if (!targetUrl || node.disabled) return;
        event.preventDefault();
        window.location.assign(targetUrl);
      });
    });
  }

  function initConversionCtaRoutes() {
    applyConversionCtaRoutes(document);
    applyConversionPreviewPaths(document);
  }

  function initCtaTracking() {
    var ctas = document.querySelectorAll('[data-nb-cta]');
    if (!ctas.length) return;

    ctas.forEach(function (cta) {
      if (cta.dataset.nbCtaBound === 'true') return;
      cta.dataset.nbCtaBound = 'true';
      cta.addEventListener('click', function () {
        pushEvent({
          event: 'cta_click',
          cta_id: cta.getAttribute('data-nb-cta') || '',
          context_path: window.location.pathname
        });
      });
    });
  }

  var blogConversionObserver = null;
  var BLOG_CONVERSION_SESSION_KEY = 'nb_blog_conversion_impressions_v1';

  function readBlogConversionImpressions() {
    var raw = readStorageItem(window.sessionStorage, BLOG_CONVERSION_SESSION_KEY);
    if (!raw) return {};
    var parsed = safeParseJson(raw, {});
    if (!parsed || typeof parsed !== 'object') return {};
    return parsed;
  }

  function writeBlogConversionImpressions(nextValue) {
    if (!nextValue || typeof nextValue !== 'object') return;
    writeStorageItem(window.sessionStorage, BLOG_CONVERSION_SESSION_KEY, JSON.stringify(nextValue));
  }

  function trackBlogConversionImpression(slotNode) {
    if (!slotNode || !slotNode.getAttribute) return;
    var slotId = String(slotNode.getAttribute('data-nb-slot-id') || '').trim();
    var destination = String(slotNode.getAttribute('data-nb-slot-destination') || '').trim().toLowerCase();
    if (!slotId) return;
    if (destination !== 'product' && destination !== 'home') return;

    var contextPath = window.location.pathname || '';
    var dedupeKey = contextPath + '::' + slotId + '::' + destination;
    var impressionMap = readBlogConversionImpressions();
    if (impressionMap[dedupeKey]) return;
    impressionMap[dedupeKey] = Date.now();
    writeBlogConversionImpressions(impressionMap);

    pushEvent({
      event: 'blog_conversion_impression',
      slot_id: slotId,
      destination: destination,
      page_type: document.body ? (document.body.getAttribute('data-page-type') || '') : '',
      context_path: contextPath
    });
  }

  function initBlogConversionTracking(rootNode) {
    var scope = rootNode && rootNode.querySelectorAll ? rootNode : document;
    var slotNodes = [];
    if (scope && scope.nodeType === 1 && scope.matches && scope.matches('[data-nb-conversion-slot]')) {
      slotNodes.push(scope);
    }
    var foundNodes = scope.querySelectorAll('[data-nb-conversion-slot]');
    foundNodes.forEach(function (node) {
      slotNodes.push(node);
    });
    if (!slotNodes.length) return;

    if ('IntersectionObserver' in window && !blogConversionObserver) {
      blogConversionObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting || entry.intersectionRatio < 0.45) return;
            trackBlogConversionImpression(entry.target);
            blogConversionObserver.unobserve(entry.target);
          });
        },
        { threshold: [0, 0.45, 0.72] }
      );
    }

    slotNodes.forEach(function (slotNode) {
      if (!slotNode || !slotNode.getAttribute) return;
      if (slotNode.dataset.nbConversionTracked === 'true') return;
      slotNode.dataset.nbConversionTracked = 'true';
      if (blogConversionObserver) {
        blogConversionObserver.observe(slotNode);
      } else {
        trackBlogConversionImpression(slotNode);
      }
    });
  }

  function createInlineConversionLink(options) {
    var link = document.createElement('a');
    link.className = options.secondary ? 'nb-button nb-button--secondary' : 'nb-button';
    link.setAttribute('href', options.href);
    link.setAttribute('data-nb-conv-preview-path', options.href);
    link.setAttribute('data-nb-cta', options.ctaId);
    link.setAttribute('data-nb-conversion-slot', '');
    link.setAttribute('data-nb-slot-id', options.slotId);
    link.setAttribute('data-nb-slot-destination', options.destination);
    link.textContent = options.label;
    return link;
  }

  function createInlineConversionMedia(config) {
    if (!config || !config.src) return null;
    var media = document.createElement('figure');
    media.className = 'nb-article-inline-conversion__media';

    var image = document.createElement('img');
    image.setAttribute('src', config.src);
    image.setAttribute('alt', config.alt || i18n('article_inline.inline_1.media_alt', 'Nordbelt product'));
    image.setAttribute('loading', 'lazy');
    image.setAttribute('decoding', 'async');
    image.setAttribute('fetchpriority', 'low');
    media.appendChild(image);

    if (config.badge) {
      var badge = document.createElement('span');
      badge.className = 'nb-article-inline-conversion__media-badge';
      badge.textContent = config.badge;
      media.appendChild(badge);
    }

    return media;
  }

  function createInlineConversionBlock(config) {
    var wrapper = document.createElement('section');
    wrapper.className = 'nb-card nb-article-inline-conversion nb-reveal is-visible';
    wrapper.setAttribute('data-nb-inline-slot', config.slotName);

    var media = createInlineConversionMedia(config.media);
    if (media) {
      wrapper.classList.add('has-media');
      wrapper.appendChild(media);
    }

    var body = document.createElement('div');
    body.className = 'nb-article-inline-conversion__body';

    var kicker = document.createElement('p');
    kicker.className = 'nb-article-inline-conversion__kicker';
    kicker.textContent = config.kicker;

    var title = document.createElement('h3');
    title.textContent = config.title;

    var copy = document.createElement('p');
    copy.textContent = config.copy;

    var chips = document.createElement('div');
    chips.className = 'nb-article-inline-conversion__chips';
    config.chips.forEach(function (chipText) {
      var chip = document.createElement('span');
      chip.textContent = chipText;
      chips.appendChild(chip);
    });

    var actions = document.createElement('div');
    actions.className = 'nb-article-inline-conversion__actions';
    actions.appendChild(createInlineConversionLink(config.primaryLink));
    actions.appendChild(createInlineConversionLink(config.secondaryLink));

    body.appendChild(kicker);
    body.appendChild(title);
    body.appendChild(copy);
    body.appendChild(chips);
    body.appendChild(actions);
    wrapper.appendChild(body);
    return wrapper;
  }

  function insertNodeAfter(node, referenceNode) {
    if (!node || !referenceNode || !referenceNode.parentNode) return;
    if (referenceNode.nextSibling) {
      referenceNode.parentNode.insertBefore(node, referenceNode.nextSibling);
      return;
    }
    referenceNode.parentNode.appendChild(node);
  }

  function initArticleInlineConversionBlocks(rootNode) {
    var scope = rootNode && rootNode.querySelectorAll ? rootNode : document;
    var articleRoots = [];
    if (scope && scope.nodeType === 1 && scope.matches && scope.matches('[data-nb-article-conversion]')) {
      articleRoots.push(scope);
    }
    var foundRoots = scope.querySelectorAll('[data-nb-article-conversion]');
    foundRoots.forEach(function (root) {
      articleRoots.push(root);
    });
    if (!articleRoots.length) return;

    articleRoots.forEach(function (articleRoot) {
      if (!articleRoot || articleRoot.dataset.nbInlineBlocksInjected === 'true') return;
      if (String(articleRoot.getAttribute('data-nb-inline-enabled')) !== 'true') return;
      var rte = articleRoot.querySelector('[data-nb-article-rte]');
      if (!rte) return;
      var paragraphs = Array.prototype.slice.call(rte.querySelectorAll('p'));
      if (!paragraphs.length) return;

      var productUrl = String(articleRoot.getAttribute('data-nb-product-url') || '').trim();
      var productImage = String(articleRoot.getAttribute('data-nb-product-image') || '').trim();
      var inlineMediaImage = String(articleRoot.getAttribute('data-nb-inline-media') || '').trim();
      var conversionMediaImage = inlineMediaImage || productImage;
      var homeUrl = String(articleRoot.getAttribute('data-nb-home-url') || '').trim();
      if (!productUrl || !homeUrl) return;

      var firstTargetIndex = paragraphs.length >= 3 ? 2 : paragraphs.length - 1;
      var secondTargetIndex = paragraphs.length >= 8 ? 7 : paragraphs.length - 1;
      if (secondTargetIndex === firstTargetIndex && paragraphs.length > 1) {
        secondTargetIndex = Math.min(paragraphs.length - 1, firstTargetIndex + 1);
      }

      var firstBlock = createInlineConversionBlock({
        slotName: 'inline_1',
        kicker: i18n('article_inline.inline_1.kicker', 'Van kennis naar resultaat'),
        title: i18n('article_inline.inline_1.title', 'Voer de bewezen Nordic Hamstring Curl direct goed uit'),
        copy: i18n('article_inline.inline_1.copy', 'Fixeer je voeten stabiel aan deur, bank of hek en start binnen 1 minuut veilig met je eerste set.'),
        chips: [
          i18n('article_inline.inline_1.chip_1', 'Tot 50% minder blessurerisico*'),
          i18n('article_inline.inline_1.chip_2', '120+ sporters gingen je voor'),
          i18n('article_inline.inline_1.chip_3', '30 dagen bedenktijd')
        ],
        media: {
          src: conversionMediaImage,
          alt: i18n('article_inline.inline_1.media_alt', 'Nordbelt product in gebruik'),
          badge: i18n('article_inline.inline_1.media_badge', 'Nordbelt setup')
        },
        primaryLink: {
          href: productUrl,
          ctaId: 'article_inline_1_to_product',
          slotId: 'article_inline_1_product',
          destination: 'product',
          label: i18n('article_inline.inline_1.primary_label', 'Bekijk Nordbelt'),
          secondary: false
        },
        secondaryLink: {
          href: homeUrl,
          ctaId: 'article_inline_1_to_home',
          slotId: 'article_inline_1_home',
          destination: 'home',
          label: i18n('article_inline.inline_1.secondary_label', 'Ga naar homepage'),
          secondary: true
        }
      });

      var secondBlock = createInlineConversionBlock({
        slotName: 'inline_2',
        kicker: i18n('article_inline.inline_2.kicker', 'Jouw volgende stap'),
        title: i18n('article_inline.inline_2.title', 'Kies direct je route: bewijs bekijken of meteen starten'),
        copy: i18n('article_inline.inline_2.copy', 'Bekijk op de homepage alle voordelen en reviews, of ga direct naar de productpagina voor je bestelling.'),
        chips: [
          i18n('article_inline.inline_2.chip_1', '4.8/5 reviewscore'),
          i18n('article_inline.inline_2.chip_2', '20+ fysiopraktijken'),
          i18n('article_inline.inline_2.chip_3', 'Snelle levering NL')
        ],
        media: {
          src: conversionMediaImage,
          alt: i18n('article_inline.inline_2.media_alt', 'Nordbelt close-up'),
          badge: i18n('article_inline.inline_2.media_badge', 'Direct toepasbaar')
        },
        primaryLink: {
          href: homeUrl,
          ctaId: 'article_inline_2_to_home',
          slotId: 'article_inline_2_home',
          destination: 'home',
          label: i18n('article_inline.inline_2.primary_label', 'Ga naar homepage'),
          secondary: false
        },
        secondaryLink: {
          href: productUrl,
          ctaId: 'article_inline_2_to_product',
          slotId: 'article_inline_2_product',
          destination: 'product',
          label: i18n('article_inline.inline_2.secondary_label', 'Bekijk Nordbelt'),
          secondary: true
        }
      });

      var firstTarget = paragraphs[firstTargetIndex];
      var secondTarget = paragraphs[secondTargetIndex];
      insertNodeAfter(firstBlock, firstTarget);
      if (secondTarget === firstTarget) secondTarget = firstBlock;
      insertNodeAfter(secondBlock, secondTarget);

      articleRoot.dataset.nbInlineBlocksInjected = 'true';
      applyConversionPreviewPaths(articleRoot);
      initCtaTracking();
      initBlogConversionTracking(articleRoot);
    });
  }

  function initArticleMobileStickyCta(rootNode) {
    var scope = rootNode && rootNode.querySelectorAll ? rootNode : document;
    var stickyBars = [];
    if (scope && scope.nodeType === 1 && scope.matches && scope.matches('[data-nb-article-mobile-sticky]')) {
      stickyBars.push(scope);
    }
    var foundBars = scope.querySelectorAll('[data-nb-article-mobile-sticky]');
    foundBars.forEach(function (bar) {
      stickyBars.push(bar);
    });
    if (!stickyBars.length) return;

    stickyBars.forEach(function (stickyBar) {
      if (!stickyBar || stickyBar.dataset.nbStickyBound === 'true') return;
      stickyBar.dataset.nbStickyBound = 'true';

      var articleRoot = stickyBar.closest('[data-nb-article-conversion]');
      if (!articleRoot) return;
      if (String(articleRoot.getAttribute('data-nb-mobile-sticky-enabled')) !== 'true') return;
      var articleContent = articleRoot.querySelector('.nb-article__content') || articleRoot;
      var endSentinel = articleRoot.querySelector('[data-nb-article-end-sentinel]');
      var mobileMq = window.matchMedia('(max-width: 840px)');
      var hideBecauseEndVisible = false;
      var showThreshold = 0;
      var isIdle = false;
      var idleTimer = null;
      var idleDelayMs = 2000;
      var previewBottomInsetPx = 0;

      var productUrl = String(articleRoot.getAttribute('data-nb-product-url') || '').trim();
      var homeUrl = String(articleRoot.getAttribute('data-nb-home-url') || '').trim();
      var productPath = '';
      var homePath = '';

      function normalizePath(path) {
        if (!path) return '/';
        var normalized = path.replace(/\/+$/, '');
        return normalized || '/';
      }

      function toPath(url) {
        if (!url) return '';
        try {
          return normalizePath(new URL(url, window.location.origin).pathname || '/');
        } catch (_err) {
          return '';
        }
      }

      productPath = toPath(productUrl);
      homePath = toPath(homeUrl);

      function isNodeVisibleInViewport(node) {
        if (!node || !node.getBoundingClientRect) return false;
        var style = window.getComputedStyle(node);
        if (!style || style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity || '1') < 0.05) return false;
        var rect = node.getBoundingClientRect();
        if (rect.width <= 0 || rect.height <= 0) return false;
        var viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;
        var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
        var visibleX = Math.min(rect.right, viewportWidth) - Math.max(rect.left, 0);
        var visibleY = Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0);
        return visibleX > Math.min(28, rect.width * 0.35) && visibleY > Math.min(22, rect.height * 0.35);
      }

      function hasInViewCompetingCta() {
        var candidates = articleRoot.querySelectorAll('a, button');
        if (!candidates.length) return false;
        var goHomeNeedle = String(i18n('shared.go_home', 'Ga naar homepage') || '').trim().toLowerCase();
        var viewNordbeltNeedle = String(i18n('shared.view_nordbelt', 'Bekijk Nordbelt') || '').trim().toLowerCase();
        for (var index = 0; index < candidates.length; index += 1) {
          var node = candidates[index];
          if (!node || stickyBar.contains(node)) continue;
          if (!isNodeVisibleInViewport(node)) continue;

          var text = String(node.textContent || '').trim().toLowerCase();
          var hrefPath = node.tagName === 'A' ? toPath(node.getAttribute('href') || '') : '';
          var hasLabelMatch =
            (goHomeNeedle && text.indexOf(goHomeNeedle) !== -1) ||
            (viewNordbeltNeedle && text.indexOf(viewNordbeltNeedle) !== -1);
          var hasHrefMatch =
            node.classList.contains('nb-button') &&
            (hrefPath === productPath || hrefPath === homePath);

          if (hasLabelMatch || hasHrefMatch) return true;
        }
        return false;
      }

      function parseCssPixels(rawValue) {
        if (typeof rawValue !== 'string') return 0;
        var parsed = Number.parseFloat(rawValue.replace('px', '').trim());
        if (!Number.isFinite(parsed) || parsed <= 0) return 0;
        return parsed;
      }

      function detectPreviewBottomInset() {
        var previewFrame = document.getElementById('PBarNextFrame');
        if (!previewFrame) return 0;

        // Try known CSS vars first (if Shopify exposes them).
        var roots = [document.documentElement, document.body].filter(Boolean);
        var cssVarNames = [
          '--shopify-preview-bar-height',
          '--preview-bar-height',
          '--shopify-admin-bar-height'
        ];
        for (var rootIndex = 0; rootIndex < roots.length; rootIndex += 1) {
          var styles = window.getComputedStyle(roots[rootIndex]);
          for (var varIndex = 0; varIndex < cssVarNames.length; varIndex += 1) {
            var cssValue = parseCssPixels(styles.getPropertyValue(cssVarNames[varIndex]));
            if (cssValue > 0 && cssValue < 220) return cssValue;
          }
        }

        var frameRect = previewFrame.getBoundingClientRect();
        var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
        // Shopify preview frame commonly spans the full viewport and draws a bottom toolbar inside.
        if (viewportHeight > 0 && frameRect.height >= viewportHeight - 4) {
          return 64;
        }
        return 0;
      }

      function applyPreviewBottomInset() {
        var inset = detectPreviewBottomInset();
        if (inset === previewBottomInsetPx) return;
        previewBottomInsetPx = inset;
        stickyBar.style.setProperty('--nb-preview-bottom-offset', inset > 0 ? inset + 'px' : '0px');
      }

      function hideSticky(fast) {
        if (fast) {
          stickyBar.classList.add('is-fast-hide');
        } else {
          stickyBar.classList.remove('is-fast-hide');
        }
        stickyBar.classList.remove('is-visible');
        stickyBar.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('has-article-mobile-sticky');
      }

      function showSticky() {
        stickyBar.classList.remove('is-fast-hide');
        stickyBar.classList.add('is-visible');
        stickyBar.setAttribute('aria-hidden', 'false');
        document.body.classList.add('has-article-mobile-sticky');
      }

      function computeThreshold() {
        var rect = articleContent.getBoundingClientRect();
        var scrollTop = window.scrollY || window.pageYOffset || 0;
        showThreshold = Math.max(0, scrollTop + rect.top + Math.max(180, rect.height * 0.35));
      }

      function syncStickyState(options) {
        applyPreviewBottomInset();
        var scrollTop = window.scrollY || window.pageYOffset || 0;
        var hasReachedThreshold = scrollTop >= showThreshold;
        var hasDuplicateInView = hasInViewCompetingCta();
        var shouldShow = mobileMq.matches && hasReachedThreshold && !hideBecauseEndVisible && !hasDuplicateInView && isIdle;
        if (shouldShow) {
          showSticky();
          return;
        }
        hideSticky(Boolean(options && options.fastHide));
      }

      function scheduleIdleCheck() {
        isIdle = false;
        window.clearTimeout(idleTimer);
        idleTimer = window.setTimeout(function () {
          isIdle = true;
          syncStickyState({ fastHide: false });
        }, idleDelayMs);
      }

      stickyBar.hidden = false;
      stickyBar.setAttribute('aria-hidden', 'true');
      computeThreshold();
      applyPreviewBottomInset();
      hideSticky(false);
      scheduleIdleCheck();

      if ('IntersectionObserver' in window && endSentinel) {
        var endObserver = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              hideBecauseEndVisible = entry.isIntersecting;
              syncStickyState({ fastHide: hideBecauseEndVisible });
            });
          },
          { threshold: [0, 0.08, 0.2] }
        );
        endObserver.observe(endSentinel);
      }

      window.addEventListener('scroll', function () {
        hideSticky(true);
        scheduleIdleCheck();
      }, { passive: true });
      window.addEventListener('resize', function () {
        computeThreshold();
        applyPreviewBottomInset();
        hideSticky(true);
        scheduleIdleCheck();
      }, { passive: true });

      if (mobileMq.addEventListener) {
        mobileMq.addEventListener('change', function () {
          computeThreshold();
          applyPreviewBottomInset();
          hideSticky(true);
          scheduleIdleCheck();
        });
      } else if (mobileMq.addListener) {
        mobileMq.addListener(function () {
          computeThreshold();
          applyPreviewBottomInset();
          hideSticky(true);
          scheduleIdleCheck();
        });
      }

      applyConversionPreviewPaths(stickyBar);
      initCtaTracking();
      initBlogConversionTracking(stickyBar);
    });
  }

  function initImageLoadingHints(rootNode) {
    var scope = rootNode && rootNode.querySelectorAll ? rootNode : document;
    var lazyImages = scope.querySelectorAll('img[loading="lazy"]');
    if (!lazyImages.length) return;

    lazyImages.forEach(function (image) {
      if (!image.getAttribute('decoding')) {
        image.setAttribute('decoding', 'async');
      }
      if (!image.getAttribute('fetchpriority')) {
        image.setAttribute('fetchpriority', 'low');
      }
    });
  }

  function initReveal() {
    var revealNodes = document.querySelectorAll('.nb-reveal');
    if (!('IntersectionObserver' in window) || !revealNodes.length) {
      revealNodes.forEach(function (node) {
        node.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.14 }
    );

    revealNodes.forEach(function (node) {
      observer.observe(node);
    });
  }

  function initMobileNav() {
    var toggles = document.querySelectorAll('[data-mobile-nav-toggle]');
    var panel = document.querySelector('[data-mobile-nav]');
    if (!toggles.length || !panel) return;
    var header = panel.closest('[data-nb-header]');
    var defaultMode = panel.getAttribute('data-mobile-nav-default-mode') || 'pages';
    var desktopMq = window.matchMedia('(min-width: 841px)');
    var desktopPanelGlass = null;

    function ensureDesktopPanelGlass() {
      if (desktopPanelGlass && desktopPanelGlass.isConnected) return desktopPanelGlass;
      desktopPanelGlass = document.querySelector('.nb-header__panel-glass-layer');
      if (desktopPanelGlass) return desktopPanelGlass;
      if (!document.body) return null;
      desktopPanelGlass = document.createElement('div');
      desktopPanelGlass.className = 'nb-header__panel-glass-layer';
      desktopPanelGlass.setAttribute('aria-hidden', 'true');
      document.body.appendChild(desktopPanelGlass);
      return desktopPanelGlass;
    }

    function hideDesktopPanelGlass() {
      if (!desktopPanelGlass) return;
      desktopPanelGlass.classList.remove('is-visible');
    }

    function updateDesktopPanelGlass(isOpen) {
      var shouldShow = Boolean(isOpen && desktopMq.matches && header && panel.classList.contains('is-open'));
      if (!shouldShow) {
        hideDesktopPanelGlass();
        return;
      }
      var glass = ensureDesktopPanelGlass();
      if (!glass) return;
      var rect = panel.getBoundingClientRect();
      if (!rect.width || !rect.height) {
        hideDesktopPanelGlass();
        return;
      }
      glass.style.left = rect.left + 'px';
      glass.style.top = rect.top + 'px';
      glass.style.width = rect.width + 'px';
      glass.style.height = rect.height + 'px';
      glass.classList.add('is-visible');
    }

    function queueDesktopPanelGlassUpdate(isOpen) {
      window.requestAnimationFrame(function () {
        updateDesktopPanelGlass(isOpen);
      });
    }

    function setMode(mode) {
      var normalizedMode = mode || defaultMode;
      panel.dataset.mode = normalizedMode;
      panel.classList.toggle('is-mode-pages', normalizedMode === 'pages');
      panel.classList.toggle('is-mode-locale', normalizedMode === 'locale');
      panel.classList.toggle('is-mode-default', normalizedMode !== 'pages' && normalizedMode !== 'locale');
    }

    function setOpenState(isOpen, mode) {
      if (mode) setMode(mode);
      else if (!panel.dataset.mode) setMode(defaultMode);
      panel.classList.toggle('is-open', isOpen);
      if (header) {
        header.classList.toggle('is-nav-panel-open', isOpen);
      }
      toggles.forEach(function (toggle) {
        toggle.setAttribute('aria-expanded', String(isOpen));
        var toggleMode = toggle.getAttribute('data-mobile-nav-mode') || defaultMode;
        toggle.classList.toggle('is-active', isOpen && toggleMode === (panel.dataset.mode || defaultMode));
      });
      queueDesktopPanelGlassUpdate(isOpen);
    }

    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var requestedMode = toggle.getAttribute('data-mobile-nav-mode') || defaultMode;
        var isOpen = panel.classList.contains('is-open');
        var currentMode = panel.dataset.mode || defaultMode;
        if (isOpen && currentMode === requestedMode) {
          setOpenState(false, requestedMode);
          return;
        }
        setOpenState(true, requestedMode);
      });
    });

    panel.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      if (!target.closest('a')) return;
      setOpenState(false);
    });

    document.addEventListener('click', function (event) {
      if (!panel.classList.contains('is-open')) return;
      var clickedToggle = event.target && event.target.closest('[data-mobile-nav-toggle]');
      if (clickedToggle) return;
      if (panel.contains(event.target)) return;
      setOpenState(false);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      if (!panel.classList.contains('is-open')) return;
      setOpenState(false);
    });

    window.addEventListener('resize', function () {
      if (!panel.classList.contains('is-open')) return;
      queueDesktopPanelGlassUpdate(true);
    }, { passive: true });

    window.addEventListener('scroll', function () {
      if (!panel.classList.contains('is-open')) return;
      queueDesktopPanelGlassUpdate(true);
    }, { passive: true });

    function handleDesktopMqChange() {
      queueDesktopPanelGlassUpdate(panel.classList.contains('is-open'));
    }

    if (desktopMq.addEventListener) {
      desktopMq.addEventListener('change', handleDesktopMqChange);
    } else if (desktopMq.addListener) {
      desktopMq.addListener(handleDesktopMqChange);
    }
  }

  function initHeaderCompactState() {
    var header = document.querySelector('[data-nb-header]');
    if (!header) return;

    var threshold = 36;
    var lastCompact = null;
    var lastScrolled = null;
    var ticking = false;

    function applyState() {
      var scrollY = window.scrollY || window.pageYOffset || 0;
      var compact = scrollY > threshold;
      var scrolled = scrollY > 2;
      if (compact === lastCompact && scrolled === lastScrolled) return;
      header.classList.toggle('is-scrolled', scrolled);
      header.classList.toggle('is-compact', compact);
      lastCompact = compact;
      lastScrolled = scrolled;
    }

    function queueState() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        applyState();
        ticking = false;
      });
    }

    applyState();
    window.addEventListener('scroll', queueState, { passive: true });
    window.addEventListener('resize', queueState, { passive: true });
  }

  function initAnnouncementAutoHide() {
    var root = document.documentElement;
    var announcement = document.querySelector('.nb-announcement');
    if (!root || !announcement) return;
    var mobileMq = window.matchMedia('(max-width: 840px)');

    var lastOffset = null;
    var lastProgress = null;
    var ticking = false;
    var announcementHeight = 0;

    function refreshAnnouncementHeight() {
      announcementHeight = Math.max(1, Math.round(announcement.getBoundingClientRect().height));
    }

    function applyState() {
      if (mobileMq.matches) {
        root.style.setProperty('--nb-announcement-offset', '0px');
        root.style.setProperty('--nb-announcement-collapse', '1');
        announcement.classList.add('is-hidden');
        return;
      }
      var scrollY = window.scrollY || window.pageYOffset || 0;
      var height = announcementHeight || 1;
      var progress = Math.max(0, Math.min(1, scrollY / height));
      var offset = -Math.round(height * progress);
      if (offset === lastOffset && progress === lastProgress) return;

      root.style.setProperty('--nb-announcement-offset', offset + 'px');
      root.style.setProperty('--nb-announcement-collapse', progress.toFixed(4));
      announcement.classList.toggle('is-hidden', progress >= 0.995);

      lastOffset = offset;
      lastProgress = progress;
    }

    function queueState() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        applyState();
        ticking = false;
      });
    }

    function handleReflowStateChange() {
      refreshAnnouncementHeight();
      queueState();
    }

    refreshAnnouncementHeight();
    applyState();
    window.addEventListener('scroll', queueState, { passive: true });
    window.addEventListener('resize', handleReflowStateChange, { passive: true });
    if (mobileMq.addEventListener) mobileMq.addEventListener('change', handleReflowStateChange);
    else if (mobileMq.addListener) mobileMq.addListener(handleReflowStateChange);
    if ('ResizeObserver' in window) {
      var sizeObserver = new ResizeObserver(handleReflowStateChange);
      sizeObserver.observe(announcement);
    }
  }

  function initHeaderLocalization() {
    var selects = document.querySelectorAll('[data-localization-select]');
    if (!selects.length) return;
    var MANUAL_LOCALE_STORAGE_KEY = 'nb_locale_manual_v2';

    function enforceSecureLocalizationAction(form) {
      if (!form || !form.setAttribute) return '/localization';
      // Force same-origin localization endpoint to avoid mixed-content form submits.
      form.setAttribute('action', '/localization');
      return '/localization';
    }

    function ensurePreviewReturnTo(form) {
      if (!form) return;
      var current = new URL(window.location.href);
      var returnTo = current.pathname + current.search;
      var field = form.querySelector('input[name="return_to"]');
      if (!field) {
        field = document.createElement('input');
        field.type = 'hidden';
        field.name = 'return_to';
        form.appendChild(field);
      }
      field.value = returnTo;
    }

    function submitLocalizationWithPreviewLock(form) {
      if (!form || !window.fetch || !window.FormData) return false;
      var current = new URL(window.location.href);
      if (!current.searchParams.has('preview_theme_id')) return false;

      var action = enforceSecureLocalizationAction(form);
      var formData = new FormData(form);
      formData.set('return_to', buildShopifyPathWithPreview(window.location.pathname));

      fetch(action, {
        method: 'POST',
        body: formData,
        credentials: 'same-origin'
      })
        .catch(function () {
          // noop
        })
        .finally(function () {
          window.location.assign(buildShopifyPathWithPreview(window.location.pathname));
        });

      return true;
    }

    function submitLocalizationForm(form, changedSelect) {
      if (!form) return;
      syncLocalizationLocaleToCountryPrimary(form, changedSelect);
      enforceSecureLocalizationAction(form);
      ensurePreviewReturnTo(form);
      if (submitLocalizationWithPreviewLock(form)) return;
      form.submit();
    }

    selects.forEach(function (select) {
      select.dataset.initialValue = select.value || '';
      select.addEventListener('change', function () {
        if (!select.form) return;
        if (select.name === 'locale_code' && select.value) {
          var manualLocaleCode = String(select.value || '').trim().toLowerCase();
          if (manualLocaleCode) {
            writeStorageItem(window.localStorage, MANUAL_LOCALE_STORAGE_KEY, manualLocaleCode);
            writeStorageItem(window.sessionStorage, MANUAL_LOCALE_STORAGE_KEY, manualLocaleCode);
            clearCampaignMarketLock();
          }
        }

        if (select.form.dataset.nbLocaleSubmitting === '1') return;
        select.form.dataset.nbLocaleSubmitting = '1';

        var submitTriggered = false;
        var submitNow = function () {
          if (submitTriggered) return;
          submitTriggered = true;
          submitLocalizationForm(select.form, select);
        };

        var timeoutId = window.setTimeout(submitNow, 2200);
        snapshotCartForLocaleTransfer()
          .catch(function () {
            // noop
          })
          .finally(function () {
            window.clearTimeout(timeoutId);
            submitNow();
          });
      });
    });
  }

  function isLocalePreservableStorePath(pathname) {
    var path = String(pathname || '/');
    if (!path) path = '/';
    if (path.charAt(0) !== '/') path = '/' + path;
    if (path === '/') return true;
    return /^\/(products|pages|blogs|collections|search|cart)(\/|$)/i.test(path);
  }

  function buildLocalizedStorefrontPath(pathname) {
    var path = String(pathname || '/');
    if (!path) path = '/';
    if (path.charAt(0) !== '/') path = '/' + path;
    if (!isLocalePreservableStorePath(path)) return '';
    if (isCheckoutPath(path)) return '';
    if (path === '/localization' || path.indexOf('/localization/') === 0) return '';

    var config = window.NordbeltLocaleConfig || {};
    var currentRootUrl = normalizeLocaleRootUrl(config.currentRootUrl || '/');
    if (isNordbeltNlHost(window.location && window.location.hostname ? window.location.hostname : '') && localeBaseCode(config.currentLocale || '') === 'nl') {
      currentRootUrl = '/';
    }
    if (currentRootUrl === '/') return '';

    var locales = sanitizeAvailableLocales(config.availableLocales || []);
    if (!locales.length) {
      var fallbackCode = normalizeLocaleCode(config.currentLocale || document.documentElement.getAttribute('lang') || '');
      if (fallbackCode) {
        locales = [{
          code: fallbackCode,
          base: localeBaseCode(fallbackCode),
          rootUrl: currentRootUrl
        }];
      }
    }

    if (hasExplicitLocalePath(path, locales)) return '';

    var localizedPath = buildLocalizedPath(path, currentRootUrl);
    return localizedPath && localizedPath !== path ? localizedPath : '';
  }

  function localizeInternalAnchors(rootNode) {
    var scope = rootNode && rootNode.querySelectorAll ? rootNode : document;
    var links = scope.querySelectorAll('a[href]');
    if (!links.length) return;

    links.forEach(function (link) {
      if (!link || !link.getAttribute || !link.setAttribute) return;
      var rawHref = String(link.getAttribute('href') || '').trim();
      if (!rawHref || rawHref.charAt(0) === '#') return;

      var lowerHref = rawHref.toLowerCase();
      if (
        lowerHref.indexOf('mailto:') === 0 ||
        lowerHref.indexOf('tel:') === 0 ||
        lowerHref.indexOf('sms:') === 0 ||
        lowerHref.indexOf('javascript:') === 0 ||
        lowerHref.indexOf('data:') === 0
      ) {
        return;
      }

      var parsed;
      try {
        parsed = new URL(rawHref, window.location.origin);
      } catch (_err) {
        return;
      }

      if (parsed.origin !== window.location.origin) return;

      var localizedPath = buildLocalizedStorefrontPath(parsed.pathname || '/');
      if (!localizedPath) return;

      var localizedHref = localizedPath + (parsed.search || '') + (parsed.hash || '');
      link.setAttribute('href', localizedHref);
    });
  }

  function normalizeLocaleRootUrl(rootUrl) {
    var normalized = String(rootUrl || '/').trim();
    if (!normalized) normalized = '/';
    if (normalized.charAt(0) !== '/') normalized = '/' + normalized;
    if (normalized.length > 1 && normalized.charAt(normalized.length - 1) === '/') {
      normalized = normalized.slice(0, -1);
    }
    return normalized || '/';
  }

  function normalizeLocaleCode(code) {
    return String(code || '').trim().toLowerCase().replace(/_/g, '-');
  }

  function localeBaseCode(code) {
    var normalized = normalizeLocaleCode(code);
    return normalized ? normalized.split('-')[0] : '';
  }

  function resolveCountryPrimaryLocale(countryCode) {
    var code = String(countryCode || '').trim().toUpperCase();
    if (!code) return '';
    var COUNTRY_PRIMARY_LOCALE = {
      NL: 'nl',
      BE: 'nl',
      AW: 'nl',
      CW: 'nl',
      SX: 'nl',
      BQ: 'nl',
      SR: 'nl',
      SE: 'sv',
      DK: 'da',
      NO: 'nb',
      DE: 'de',
      AT: 'de',
      LI: 'de',
      FR: 'fr',
      MC: 'fr'
    };
    return COUNTRY_PRIMARY_LOCALE[code] || '';
  }

  function sanitizeAvailableLocales(locales) {
    var list = [];
    var seen = {};
    (locales || []).forEach(function (entry) {
      if (!entry || typeof entry !== 'object') return;
      var code = normalizeLocaleCode(entry.code || entry.iso_code || entry.locale || '');
      if (!code || seen[code]) return;
      seen[code] = true;
      list.push({
        code: code,
        base: localeBaseCode(code),
        rootUrl: normalizeLocaleRootUrl(entry.rootUrl || entry.root_url || '/')
      });
    });
    return list;
  }

  function getBrowserLocaleCandidates() {
    var candidates = [];
    var seen = {};
    var languages = [];

    if (Array.isArray(navigator.languages) && navigator.languages.length) {
      languages = languages.concat(navigator.languages);
    }
    if (navigator.language) languages.push(navigator.language);

    function pushCandidate(value) {
      var normalized = normalizeLocaleCode(value);
      if (!normalized || seen[normalized]) return;
      seen[normalized] = true;
      candidates.push(normalized);
    }

    languages.forEach(function (language) {
      var normalized = normalizeLocaleCode(language);
      if (!normalized) return;
      pushCandidate(normalized);
      pushCandidate(localeBaseCode(normalized));
    });

    return candidates;
  }

  function resolveBrowserRegionCountryHint(preferredBase) {
    var preferred = localeBaseCode(preferredBase);
    var languages = [];
    if (Array.isArray(navigator.languages) && navigator.languages.length) {
      languages = languages.concat(navigator.languages);
    }
    if (navigator.language) languages.push(navigator.language);

    for (var i = 0; i < languages.length; i += 1) {
      var normalized = normalizeLocaleCode(languages[i]);
      if (!normalized) continue;
      var parts = normalized.split('-');
      if (parts.length < 2 || !parts[1] || parts[1].length !== 2) continue;

      var base = localeBaseCode(normalized);
      if (base === 'no') base = 'nb';
      if (preferred && preferred !== base) continue;

      return String(parts[1]).toUpperCase();
    }

    return '';
  }

  function isLikelyCrawlerUserAgent() {
    var ua = String((window.navigator && window.navigator.userAgent) || '').toLowerCase();
    if (!ua) return false;
    return /bot|crawl|spider|slurp|bingpreview|google-structured-data-testing-tool|lighthouse|pagespeed|headlesschrome|facebookexternalhit|whatsapp|telegrambot|linkedinbot|twitterbot/.test(ua);
  }

  function findLocaleByCandidate(locales, candidate) {
    var normalizedCandidate = normalizeLocaleCode(candidate);
    if (!normalizedCandidate) return null;
    for (var i = 0; i < locales.length; i += 1) {
      if (locales[i].code === normalizedCandidate) return locales[i];
    }
    var baseCandidate = localeBaseCode(normalizedCandidate);
    if (!baseCandidate) return null;
    for (var j = 0; j < locales.length; j += 1) {
      if (locales[j].base === baseCandidate) return locales[j];
    }
    return null;
  }

  function stripLocalePrefixFromPath(pathname, locales) {
    var path = String(pathname || '/');
    if (!path) path = '/';
    if (path.charAt(0) !== '/') path = '/' + path;
    var prefixes = locales
      .map(function (locale) { return locale.rootUrl; })
      .filter(function (rootUrl) { return rootUrl && rootUrl !== '/'; })
      .sort(function (a, b) { return b.length - a.length; });

    for (var i = 0; i < prefixes.length; i += 1) {
      var prefix = prefixes[i];
      if (path === prefix) return '/';
      if (path.indexOf(prefix + '/') === 0) {
        var stripped = path.slice(prefix.length);
        return stripped || '/';
      }
    }

    return path;
  }

  function buildLocalizedPath(pathname, targetRootUrl) {
    var cleanPath = String(pathname || '/');
    if (!cleanPath || cleanPath.charAt(0) !== '/') cleanPath = '/' + cleanPath;
    var root = normalizeLocaleRootUrl(targetRootUrl || '/');
    if (root === '/') return cleanPath;
    return cleanPath === '/' ? root : root + cleanPath;
  }

  function isNordbeltNlHost(hostName) {
    var normalized = String(hostName || '').trim().toLowerCase();
    return /(^|\.)nordbelt\.nl$/.test(normalized);
  }

  function sanitizeHostName(hostValue) {
    var normalized = String(hostValue || '').trim().toLowerCase();
    normalized = normalized.replace(/^https?:\/\//, '');
    normalized = normalized.split('/')[0];
    normalized = normalized.replace(/:\d+$/, '');
    return normalized;
  }

  function resolvePreferredNlHost(config, currentHostName) {
    var configuredHost = sanitizeHostName(config && config.preferredNlHost ? config.preferredNlHost : '');
    if (configuredHost) return configuredHost;
    var currentHost = sanitizeHostName(currentHostName);
    if (isNordbeltNlHost(currentHost)) return currentHost;
    return 'www.nordbelt.nl';
  }

  function buildHostSwapUrl(targetHost, currentUrl, targetPathname) {
    if (!targetHost || !currentUrl) return '';
    var path = String(targetPathname || '/');
    if (!path || path.charAt(0) !== '/') path = '/' + path;
    return (
      'https://' +
      sanitizeHostName(targetHost) +
      path +
      (currentUrl.search || '') +
      (currentUrl.hash || '')
    );
  }

  function resolvePrimaryLocaleOption(selectEl, desiredBaseLocale) {
    if (!selectEl || !selectEl.options || !desiredBaseLocale) return '';
    var desiredBase = localeBaseCode(desiredBaseLocale);
    if (!desiredBase) return '';

    for (var i = 0; i < selectEl.options.length; i += 1) {
      var exactCode = normalizeLocaleCode(selectEl.options[i].value || '');
      if (exactCode === desiredBase) return selectEl.options[i].value;
    }

    for (var j = 0; j < selectEl.options.length; j += 1) {
      var optionBase = localeBaseCode(selectEl.options[j].value || '');
      if (optionBase === desiredBase) return selectEl.options[j].value;
    }

    return '';
  }

  function syncLocalizationLocaleToCountryPrimary(form, changedSelect) {
    if (!form || !changedSelect) return;
    if (String(changedSelect.name || '').trim() !== 'country_code') return;

    var countryCode = String(changedSelect.value || '').trim().toUpperCase();
    if (!countryCode) return;

    var primaryLocaleBase = resolveCountryPrimaryLocale(countryCode);
    if (!primaryLocaleBase) return;

    var localeSelect = form.querySelector('select[name="locale_code"]');
    if (!localeSelect) return;

    var targetLocaleValue = resolvePrimaryLocaleOption(localeSelect, primaryLocaleBase);
    if (!targetLocaleValue) return;
    if (String(localeSelect.value || '') === String(targetLocaleValue)) return;

    localeSelect.value = targetLocaleValue;

  }

  function resolveAutoLocaleTarget(config, locales, countryHint) {
    var countryCode = String(countryHint || config.countryCode || '').trim().toUpperCase();
    var countryPrimaryLocale = resolveCountryPrimaryLocale(countryCode);
    var hostName = String(window.location && window.location.hostname ? window.location.hostname : '').toLowerCase();
    var isNlHost = isNordbeltNlHost(hostName);
    var priority = [];
    var seen = {};
    var HARD_NL_COUNTRIES = {
      NL: true
    };
    var FRENCH_DEFAULT_COUNTRIES = {
      FR: true,
      MC: true,
      RE: true,
      GP: true,
      MQ: true,
      GF: true,
      PF: true,
      NC: true,
      BL: true,
      MF: true,
      PM: true,
      WF: true,
      YT: true
    };
    var GERMAN_DEFAULT_COUNTRIES = {
      DE: true,
      AT: true,
      LI: true
    };
    var NORDIC_DEFAULT_LOCALES = {
      SE: 'sv',
      DK: 'da',
      NO: 'nb'
    };

    function pushPriority(candidate) {
      var normalized = normalizeLocaleCode(candidate);
      if (!normalized || seen[normalized]) return;
      seen[normalized] = true;
      priority.push(normalized);
    }

    // Hard rule: Dutch visitors should land on Dutch by default.
    if (HARD_NL_COUNTRIES[countryCode]) pushPriority('nl');

    // User language first for all other markets.
    getBrowserLocaleCandidates().forEach(pushPriority);

    if (countryPrimaryLocale) pushPriority(countryPrimaryLocale);
    if (NORDIC_DEFAULT_LOCALES[countryCode]) pushPriority(NORDIC_DEFAULT_LOCALES[countryCode]);
    if (FRENCH_DEFAULT_COUNTRIES[countryCode]) pushPriority('fr');
    if (GERMAN_DEFAULT_COUNTRIES[countryCode]) pushPriority('de');
    if (isNlHost) pushPriority('nl');
    else pushPriority('en');
    ['nl', 'en', 'de', 'fr', 'sv', 'da', 'nb'].forEach(pushPriority);

    for (var i = 0; i < priority.length; i += 1) {
      var match = findLocaleByCandidate(locales, priority[i]);
      if (match) return match;
    }

    return null;
  }

  function resolvePreferredLocaleBase(countryHint) {
    var countryCode = String(countryHint || '').trim().toUpperCase();
    var SUPPORTED_BASES = {
      nl: true,
      en: true,
      de: true,
      fr: true,
      sv: true,
      da: true,
      nb: true
    };

    if (countryCode === 'NL') return 'nl';

    var browserCandidates = getBrowserLocaleCandidates();
    for (var i = 0; i < browserCandidates.length; i += 1) {
      var browserBase = localeBaseCode(browserCandidates[i]);
      if (browserBase === 'no') browserBase = 'nb';
      if (SUPPORTED_BASES[browserBase]) return browserBase;
    }

    var countryPrimary = resolveCountryPrimaryLocale(countryCode);
    if (countryPrimary === 'no') countryPrimary = 'nb';
    if (SUPPORTED_BASES[countryPrimary]) return countryPrimary;

    if (countryCode === 'SE') return 'sv';
    if (countryCode === 'DK') return 'da';
    if (countryCode === 'NO') return 'nb';
    if (countryCode === 'AT' || countryCode === 'DE' || countryCode === 'LI') return 'de';
    if (countryCode === 'FR' || countryCode === 'MC') return 'fr';

    return 'en';
  }

  function shouldSkipAutoLocale(pathname, searchParams, manualLocaleSet) {
    if (manualLocaleSet) return true;
    if (isCheckoutPath(pathname)) return true;
    if (searchParams && searchParams.has('locale')) return true;
    if (searchParams && searchParams.has('preview_theme_id')) return true;
    var path = String(pathname || '').toLowerCase();
    if (path.indexOf('/account') === 0) return true;
    if (path.indexOf('/challenge') === 0) return true;
    if (path.indexOf('/apps') === 0) return true;
    return false;
  }

  function findExplicitLocalePathMatch(pathname, locales) {
    var path = String(pathname || '/');
    if (!path) path = '/';
    if (path.charAt(0) !== '/') path = '/' + path;

    var matches = [];
    for (var i = 0; i < locales.length; i += 1) {
      var locale = locales[i] || {};
      var root = normalizeLocaleRootUrl(locale.rootUrl || '/');
      if (!root || root === '/') continue;
      if (path === root || path.indexOf(root + '/') === 0) {
        matches.push({
          code: normalizeLocaleCode(locale.code || ''),
          base: localeBaseCode(locale.code || ''),
          rootUrl: root
        });
      }
    }

    if (!matches.length) return null;
    matches.sort(function (a, b) { return b.rootUrl.length - a.rootUrl.length; });
    return matches[0];
  }

  function isDutchLocalePrefixPath(pathname) {
    var path = String(pathname || '/');
    if (!path) path = '/';
    if (path.charAt(0) !== '/') path = '/' + path;
    var firstSegment = String(path.split('/')[1] || '').trim().toLowerCase();
    if (!firstSegment) return false;
    return firstSegment === 'nl' || firstSegment.indexOf('nl-') === 0;
  }

  function stripFirstPathSegment(pathname) {
    var path = String(pathname || '/');
    if (!path) path = '/';
    if (path.charAt(0) !== '/') path = '/' + path;
    var segments = path.split('/');
    if (segments.length <= 2) return '/';
    var remainder = '/' + segments.slice(2).join('/');
    return remainder === '//' ? '/' : remainder.replace(/\/{2,}/g, '/');
  }

  function hasExplicitLocalePath(pathname, locales) {
    return !!findExplicitLocalePathMatch(pathname, locales);
  }

  function resolveUserCountryHint(config) {
    var explicitCountryFromQuery = '';
    try {
      var params = new URLSearchParams(window.location.search || '');
      explicitCountryFromQuery = String(params.get('country') || '').trim().toUpperCase();
    } catch (_errCountryQuery) {
      explicitCountryFromQuery = '';
    }
    if (/^[A-Z]{2}$/.test(explicitCountryFromQuery)) return explicitCountryFromQuery;

    var explicitFromPath = parseMarketLocaleFromPath(window.location.pathname || '/');
    if (explicitFromPath && /^[A-Z]{2}$/.test(explicitFromPath.country || '')) {
      return String(explicitFromPath.country || '').toUpperCase();
    }

    // Prefer Shopify-provided market country before local heuristics such as timezone.
    var shopifyCountry = '';
    try {
      shopifyCountry = String((window.Shopify && window.Shopify.country) || '').trim().toUpperCase();
    } catch (_errShopifyCountry) {
      shopifyCountry = '';
    }
    if (/^[A-Z]{2}$/.test(shopifyCountry)) return shopifyCountry;

    var configCountry = String((config && config.countryCode) || '').trim().toUpperCase();
    if (/^[A-Z]{2}$/.test(configCountry)) return configCountry;

    // User language first (if language includes region), then timezone fallback.
    var locales = [];
    if (Array.isArray(navigator.languages) && navigator.languages.length) {
      locales = locales.concat(navigator.languages);
    }
    if (navigator.language) locales.push(navigator.language);

    for (var i = 0; i < locales.length; i += 1) {
      var normalized = normalizeLocaleCode(locales[i]);
      if (!normalized) continue;
      var parts = normalized.split('-');
      if (parts.length > 1 && parts[1] && parts[1].length === 2) {
        return parts[1].toUpperCase();
      }
    }

    var TZ_COUNTRY_MAP = {
      'Europe/Amsterdam': 'NL',
      'Europe/Brussels': 'BE',
      'Europe/Paris': 'FR',
      'Europe/Vienna': 'AT',
      'Europe/Berlin': 'DE',
      'Europe/Zurich': 'CH',
      'Europe/Copenhagen': 'DK',
      'Europe/Stockholm': 'SE',
      'Europe/Oslo': 'NO'
    };
    var tz = '';
    try {
      tz = String(Intl.DateTimeFormat().resolvedOptions().timeZone || '');
    } catch (_errTz) {
      tz = '';
    }
    if (TZ_COUNTRY_MAP[tz]) return TZ_COUNTRY_MAP[tz];
    return '';
  }

  function isAutoLocaleEntryPath(pathname, locales) {
    var path = String(pathname || '/');
    if (!path) path = '/';
    if (path.charAt(0) !== '/') path = '/' + path;
    if (path.length > 1 && path.charAt(path.length - 1) === '/') path = path.slice(0, -1);
    if (path === '/') return true;

    var explicit = findExplicitLocalePathMatch(path, locales);
    if (!explicit) return false;
    return path === explicit.rootUrl;
  }

  function parseMarketLocaleFromPath(pathname) {
    var path = String(pathname || '/');
    if (!path) path = '/';
    if (path.charAt(0) !== '/') path = '/' + path;
    var segment = String(path.split('/')[1] || '').trim().toLowerCase();
    if (!segment) return null;
    var match = segment.match(/^([a-z]{2})-([a-z]{2})$/i);
    if (!match) return null;
    return {
      language: String(match[1] || '').toLowerCase(),
      country: String(match[2] || '').toUpperCase(),
      rootUrl: '/' + segment
    };
  }

  function countryCodeForLocaleBase(baseLocale) {
    var base = localeBaseCode(baseLocale);
    var map = {
      nl: 'NL',
      de: 'DE',
      fr: 'FR',
      sv: 'SE',
      da: 'DK',
      nb: 'NO'
    };
    return map[base] || '';
  }

  function extractLocaleIntentFromReferrer(locales) {
    var referrer = String(document.referrer || '').trim();
    if (!referrer) return null;

    var refUrl;
    try {
      refUrl = new URL(referrer);
    } catch (_errRefUrl) {
      return null;
    }

    var refHost = sanitizeHostName(refUrl.hostname || '');
    if (!refHost || (refHost.indexOf('nordbelt.com') === -1 && refHost.indexOf('nordbelt.nl') === -1)) return null;

    var refPath = String(refUrl.pathname || '/');
    if (!refPath) refPath = '/';
    if (refPath.charAt(0) !== '/') refPath = '/' + refPath;

    var market = parseMarketLocaleFromPath(refPath);
    if (market) {
      return {
        base: market.language,
        rootUrl: market.rootUrl,
        pathWithoutPrefix: stripFirstPathSegment(refPath) || '/',
        country: market.country
      };
    }

    var explicit = findExplicitLocalePathMatch(refPath, locales || []);
    if (!explicit || !explicit.rootUrl || explicit.rootUrl === '/') return null;

    var pathWithoutPrefix = '/';
    if (refPath !== explicit.rootUrl) {
      pathWithoutPrefix = refPath.slice(explicit.rootUrl.length);
      if (!pathWithoutPrefix) pathWithoutPrefix = '/';
      if (pathWithoutPrefix.charAt(0) !== '/') pathWithoutPrefix = '/' + pathWithoutPrefix;
    }

    var countryParam = String(refUrl.searchParams.get('country') || '').trim().toUpperCase();
    var countryCode = /^[A-Z]{2}$/.test(countryParam) ? countryParam : countryCodeForLocaleBase(explicit.base);

    return {
      base: explicit.base,
      rootUrl: explicit.rootUrl,
      pathWithoutPrefix: pathWithoutPrefix,
      country: countryCode
    };
  }

  function ensureMetaTag(selector, attributes) {
    if (!document || !document.head) return null;
    var node = document.head.querySelector(selector);
    if (!node) {
      node = document.createElement('meta');
      document.head.appendChild(node);
    }
    Object.keys(attributes || {}).forEach(function (key) {
      var value = attributes[key];
      if (value == null) return;
      node.setAttribute(key, String(value));
    });
    return node;
  }

  function ensureCanonicalTag(href) {
    if (!document || !document.head || !href) return null;
    var node = document.head.querySelector('link[rel=\"canonical\"]');
    if (!node) {
      node = document.createElement('link');
      node.setAttribute('rel', 'canonical');
      document.head.appendChild(node);
    }
    node.setAttribute('href', String(href));
    return node;
  }

  function ensureDescriptionTags(content) {
    var value = String(content || '').trim();
    if (!value) return;
    ensureMetaTag('meta[name=\"description\"]', { name: 'description', content: value });
    ensureMetaTag('meta[property=\"og:description\"]', { property: 'og:description', content: value });
    ensureMetaTag('meta[name=\"twitter:description\"]', { name: 'twitter:description', content: value });
  }

  function resolveRuntimeBlogDescription(pathname) {
    var path = String(pathname || '/');
    if (!path) path = '/';
    if (path.charAt(0) !== '/') path = '/' + path;
    var match = path.match(/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?blogs\/([^\/?#]+)/i);
    if (!match || !match[1]) return '';

    var handle = String(match[1] || '').trim().toLowerCase();
    var key = 'seo.blog.description';
    if (handle === 'nieuws') key = 'seo.blog.description_nieuws';
    else if (handle === 'hamstring') key = 'seo.blog.description_hamstring';
    else if (handle === 'blog-posts') key = 'seo.blog.description_blog_posts';

    return i18n(key, '');
  }

  function buildCanonicalPathFromMarketVariant(pathname) {
    var parsed = parseMarketLocaleFromPath(pathname);
    if (!parsed) return String(pathname || '/');
    var remainder = stripFirstPathSegment(pathname) || '/';
    if (parsed.language === 'en') return remainder;
    if (remainder === '/') return '/' + parsed.language;
    return '/' + parsed.language + remainder;
  }

  function hasNoindexQuerySignals(queryString) {
    var query = String(queryString || '').toLowerCase();
    if (!query) return false;

    var needles = [
      'sort_by=',
      'filter.',
      'preview_theme_id=',
      'utm_',
      'gclid=',
      'fbclid=',
      'msclkid=',
      'twclid=',
      'ttclid=',
      'wbraid=',
      'gbraid=',
      'yclid=',
      'epik=',
      '_kx=',
      'mkt_tok=',
      'rb_clickid=',
      'section_id=',
      'view=',
      'constraint=',
      'page=',
      'srsltid=',
      '_pos=',
      '_psq=',
      '_ss=',
      '_v=',
      'pr_prod_strat=',
      'pr_rec_id=',
      'pr_rec_pid=',
      'pr_ref_pid=',
      'pr_seq=',
      'okereviewspagenum=',
      'currency=',
      'country=',
      'locale=',
      'market='
    ];

    for (var i = 0; i < needles.length; i += 1) {
      if (query.indexOf(needles[i]) !== -1) return true;
    }
    return false;
  }

  function initRuntimeSeoGuards() {
    var currentUrl;
    try {
      currentUrl = new URL(window.location.href);
    } catch (_errUrl) {
      return;
    }

    var hostName = sanitizeHostName(currentUrl.hostname || '');
    var isNlHost = isNordbeltNlHost(hostName);
    var path = String(currentUrl.pathname || '/');
    if (!path) path = '/';
    if (path.charAt(0) !== '/') path = '/' + path;
    var pathLower = path.toLowerCase();
    var firstSegment = String(path.split('/')[1] || '').trim().toLowerCase();
    var isDutchPrefixPath = firstSegment === 'nl' || firstSegment.indexOf('nl-') === 0;
    var marketPath = parseMarketLocaleFromPath(path);
    var NON_NL_COM_PREFIXES = {
      en: true,
      fr: true,
      de: true,
      sv: true,
      nb: true,
      da: true
    };

    var canonicalHost = isNlHost ? 'www.nordbelt.nl' : 'www.nordbelt.com';
    var canonicalPath = path;

    if (marketPath) {
      canonicalHost = marketPath.language === 'nl' ? 'www.nordbelt.nl' : 'www.nordbelt.com';
      canonicalPath = buildCanonicalPathFromMarketVariant(path);
    } else if (isDutchPrefixPath) {
      canonicalHost = 'www.nordbelt.nl';
      canonicalPath = stripFirstPathSegment(path) || '/';
    } else if (isNlHost && NON_NL_COM_PREFIXES[firstSegment]) {
      canonicalHost = 'www.nordbelt.com';
      canonicalPath = path;
    }

    if (!canonicalPath) canonicalPath = '/';
    if (canonicalPath.charAt(0) !== '/') canonicalPath = '/' + canonicalPath;
    canonicalPath = canonicalPath.replace(/\/{2,}/g, '/');
    var canonicalUrl = 'https://' + canonicalHost + canonicalPath;

    var pageType = String((document.body && document.body.getAttribute('data-page-type')) || '').toLowerCase();
    var noindex = false;

    if (pageType === 'search' || pageType === 'cart' || pageType === '404') noindex = true;
    if (pathLower.indexOf('/account') === 0 || pathLower.indexOf('/policies/') !== -1) noindex = true;
    if (pathLower.indexOf('/tagged/') !== -1) noindex = true;
    if (pathLower.indexOf('/collections/vendors') !== -1 || pathLower.indexOf('/collections/types') !== -1) noindex = true;
    if (marketPath || isDutchPrefixPath) noindex = true;
    if (hostName && canonicalHost && hostName !== canonicalHost) noindex = true;
    if (hasNoindexQuerySignals(currentUrl.search || '')) noindex = true;

    var robotsValue = noindex
      ? 'noindex,follow'
      : 'index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1';

    if (pageType === 'blog') {
      ensureDescriptionTags(resolveRuntimeBlogDescription(path));
    }

    ensureCanonicalTag(canonicalUrl);
    ensureMetaTag('meta[name=\"robots\"]', { name: 'robots', content: robotsValue });
    ensureMetaTag('meta[name=\"googlebot\"]', { name: 'googlebot', content: robotsValue });
    ensureMetaTag('meta[name=\"bingbot\"]', { name: 'bingbot', content: robotsValue });
    ensureMetaTag('meta[property=\"og:url\"]', { property: 'og:url', content: canonicalUrl });
    ensureMetaTag('meta[name=\"nb-runtime-seo-build\"]', { name: 'nb-runtime-seo-build', content: '2026-03-05-r35' });
  }

  var CAMPAIGN_MARKET_LOCK_STORAGE_KEY = 'nb_campaign_market_lock_v1';

  function clearCampaignMarketLock() {
    if (!window.sessionStorage) return;
    try {
      window.sessionStorage.removeItem(CAMPAIGN_MARKET_LOCK_STORAGE_KEY);
    } catch (_err) {
      // noop
    }
  }

  function readCampaignMarketLock() {
    var raw = readStorageItem(window.sessionStorage, CAMPAIGN_MARKET_LOCK_STORAGE_KEY);
    if (!raw) return null;
    var parsed = safeParseJson(raw, null);
    if (!parsed || typeof parsed !== 'object') return null;
    var rootUrl = normalizeLocaleRootUrl(parsed.rootUrl || '');
    var country = String(parsed.country || '').trim().toUpperCase();
    if (!rootUrl || rootUrl === '/' || !/^[A-Z]{2}$/.test(country)) return null;
    return {
      rootUrl: rootUrl,
      country: country
    };
  }

  function persistCampaignMarketLock(lockContext) {
    if (!lockContext || typeof lockContext !== 'object') return;
    var rootUrl = normalizeLocaleRootUrl(lockContext.rootUrl || '');
    var country = String(lockContext.country || '').trim().toUpperCase();
    if (!rootUrl || rootUrl === '/' || !/^[A-Z]{2}$/.test(country)) return;
    writeStorageItem(
      window.sessionStorage,
      CAMPAIGN_MARKET_LOCK_STORAGE_KEY,
      JSON.stringify({ rootUrl: rootUrl, country: country, ts: Date.now() })
    );
  }

  function shouldSkipCampaignLockEnforcement(pathname, searchParams) {
    if (isCheckoutPath(pathname)) return true;
    if (searchParams && searchParams.has('preview_theme_id')) return true;
    var path = String(pathname || '').toLowerCase();
    if (path.indexOf('/account') === 0) return true;
    if (path.indexOf('/challenge') === 0) return true;
    if (path.indexOf('/apps') === 0) return true;
    return false;
  }

  function enforcePersistedCampaignLock(persistedLock, currentUrl, config, locales) {
    if (!persistedLock || !persistedLock.rootUrl || !currentUrl || !config) return false;
    if (shouldSkipCampaignLockEnforcement(currentUrl.pathname, currentUrl.searchParams)) return false;

    var preferredComHost = sanitizeHostName(config.preferredComHost || 'www.nordbelt.com');
    if (!preferredComHost) return false;

    var canonicalPath = stripLocalePrefixFromPath(currentUrl.pathname, locales || []);
    var targetPath = buildLocalizedPath(canonicalPath || '/', persistedLock.rootUrl);
    var targetUrlValue = buildHostSwapUrl(preferredComHost, currentUrl, targetPath || persistedLock.rootUrl);
    if (!targetUrlValue) return false;

    try {
      var targetUrl = new URL(targetUrlValue);
      targetUrl.searchParams.delete('shpxid');
      if (!targetUrl.searchParams.has('country') && /^[A-Z]{2}$/.test(persistedLock.country || '')) {
        targetUrl.searchParams.set('country', persistedLock.country);
      }
      if (targetUrl.toString() === currentUrl.toString()) return false;
      window.location.replace(targetUrl.toString());
      return true;
    } catch (_errTargetCampaignLock) {
      return false;
    }
  }

  function extractCampaignMarketContext(pathname, searchParams, locales) {
    if (!searchParams || typeof searchParams.get !== 'function') return null;

    var countryParam = String(searchParams.get('country') || '').trim().toUpperCase();
    if (!/^[A-Z]{2}$/.test(countryParam)) return null;

    var explicit = findExplicitLocalePathMatch(pathname, locales || []);
    var marketPath = parseMarketLocaleFromPath(pathname);
    if (!marketPath && explicit && explicit.rootUrl && explicit.rootUrl !== '/') {
      marketPath = parseMarketLocaleFromPath(explicit.rootUrl);
    }
    if (marketPath && marketPath.country === countryParam) {
      return { rootUrl: marketPath.rootUrl, country: countryParam };
    }

    // Fallback lock for explicit locale roots after server normalization (e.g. /de-at -> /de).
    if (explicit && explicit.rootUrl && explicit.rootUrl !== '/') {
      var expectedCountry = countryCodeForLocaleBase(explicit.base);
      if (expectedCountry && expectedCountry === countryParam) {
        return { rootUrl: explicit.rootUrl, country: countryParam };
      }
      if (hasCampaignAttributionSignals(searchParams)) {
        return { rootUrl: explicit.rootUrl, country: countryParam };
      }
    }

    return null;
  }

  function hasCampaignAttributionSignals(searchParams) {
    if (!searchParams || typeof searchParams.has !== 'function') return false;
    var KNOWN_KEYS = [
      'gclid',
      'fbclid',
      'msclkid',
      'twclid',
      'ttclid',
      'wbraid',
      'gbraid',
      'yclid',
      'epik',
      'mkt_tok',
      'rb_clickid'
    ];
    for (var i = 0; i < KNOWN_KEYS.length; i += 1) {
      if (searchParams.has(KNOWN_KEYS[i])) return true;
    }
    if (typeof searchParams.forEach === 'function') {
      var hasUtm = false;
      searchParams.forEach(function (_value, key) {
        if (hasUtm) return;
        if (String(key || '').toLowerCase().indexOf('utm_') === 0) hasUtm = true;
      });
      if (hasUtm) return true;
    }
    return false;
  }

  function isCampaignMarketLocked(pathname, searchParams, locales) {
    var campaignContext = extractCampaignMarketContext(pathname, searchParams, locales);
    if (campaignContext) return true;

    var persistedLock = readCampaignMarketLock();
    if (!persistedLock || !persistedLock.rootUrl) return false;

    var path = String(pathname || '/');
    if (!path) path = '/';
    if (path.charAt(0) !== '/') path = '/' + path;
    return path === persistedLock.rootUrl || path.indexOf(persistedLock.rootUrl + '/') === 0;
  }

  function applyAutoLocaleSelection(targetLocaleCode, countryCode, currentUrl) {
    if (!targetLocaleCode || !document || !document.body) return false;
    var form = document.createElement('form');
    form.method = 'post';
    form.action = '/localization';
    form.style.display = 'none';
    form.setAttribute('accept-charset', 'UTF-8');
    form.enctype = 'multipart/form-data';

    function appendField(name, value) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      form.appendChild(input);
    }

    appendField('form_type', 'localization');
    appendField('utf8', '✓');
    appendField('_method', 'put');
    appendField('locale_code', targetLocaleCode);
    if (countryCode) appendField('country_code', String(countryCode).trim().toUpperCase());
    appendField('return_to', (currentUrl.pathname || '/') + (currentUrl.search || ''));

    document.body.appendChild(form);
    form.submit();
    return true;
  }

  function initAutoLocaleRouting() {
    var AUTO_LOCALE_SESSION_KEY = 'nb_locale_auto_checked_v9';
    var MANUAL_LOCALE_STORAGE_KEY = 'nb_locale_manual_v2';
    var REFERRER_LOCALE_RECOVERY_KEY = 'nb_locale_referrer_recovery_v1';
    var config = window.NordbeltLocaleConfig;
    if (!config || typeof config !== 'object') return;

    var currentUrl;
    try {
      currentUrl = new URL(window.location.href);
    } catch (_err) {
      writeStorageItem(window.sessionStorage, AUTO_LOCALE_SESSION_KEY, '1');
      return;
    }

    var hostName = sanitizeHostName(currentUrl.hostname || config.hostName || window.location.hostname || '');
    var isNlHost = isNordbeltNlHost(hostName);
    var locales = sanitizeAvailableLocales(config.availableLocales || []);
    if (!locales.length) {
      writeStorageItem(window.sessionStorage, AUTO_LOCALE_SESSION_KEY, '1');
      return;
    }
    var campaignContext = extractCampaignMarketContext(currentUrl.pathname, currentUrl.searchParams, locales);
    if (campaignContext) persistCampaignMarketLock(campaignContext);
    var persistedCampaignLock = readCampaignMarketLock();
    if (!campaignContext && persistedCampaignLock && !isLikelyCrawlerUserAgent()) {
      if (enforcePersistedCampaignLock(persistedCampaignLock, currentUrl, config, locales)) {
        writeStorageItem(window.sessionStorage, AUTO_LOCALE_SESSION_KEY, '1');
        return;
      }
    }
    if (isCampaignMarketLocked(currentUrl.pathname, currentUrl.searchParams, locales)) {
      writeStorageItem(window.sessionStorage, AUTO_LOCALE_SESSION_KEY, '1');
      return;
    }

    var hasDutchPrefixPath = isDutchLocalePrefixPath(currentUrl.pathname);
    if (isNlHost && hasDutchPrefixPath) {
      var nlCleanPath = stripFirstPathSegment(currentUrl.pathname) || '/';
      var nlCleanUrl = buildHostSwapUrl(resolvePreferredNlHost(config, hostName), currentUrl, nlCleanPath);
      if (nlCleanUrl && nlCleanUrl !== currentUrl.toString()) {
        writeStorageItem(window.sessionStorage, AUTO_LOCALE_SESSION_KEY, '1');
        window.location.replace(nlCleanUrl);
        return;
      }
    }
    if (!isNlHost && hasDutchPrefixPath) {
      var nlHost = resolvePreferredNlHost(config, hostName);
      var nlHostPath = stripFirstPathSegment(currentUrl.pathname) || '/';
      var nlHostUrl = buildHostSwapUrl(nlHost, currentUrl, nlHostPath);
      if (nlHostUrl && nlHostUrl !== currentUrl.toString()) {
        writeStorageItem(window.sessionStorage, AUTO_LOCALE_SESSION_KEY, '1');
        window.location.replace(nlHostUrl);
        return;
      }
    }

    // Recovery for unexpected server redirects from explicit .com locale paths to .nl.
    if (isNlHost && currentUrl.searchParams.has('shpxid') && !isLikelyCrawlerUserAgent()) {
      var localeRecoveryState = readStorageItem(window.sessionStorage, REFERRER_LOCALE_RECOVERY_KEY);
      if (localeRecoveryState !== '1') {
        var referrerIntent = extractLocaleIntentFromReferrer(locales);
        if (referrerIntent && referrerIntent.base && referrerIntent.base !== 'nl') {
          var recoveryComHost = sanitizeHostName(config.preferredComHost || 'www.nordbelt.com');
          var recoveryRoot = normalizeLocaleRootUrl(referrerIntent.rootUrl || ('/' + referrerIntent.base));
          var recoveryPath = buildLocalizedPath(referrerIntent.pathWithoutPrefix || '/', recoveryRoot);
          var recoveryTarget = buildHostSwapUrl(recoveryComHost, currentUrl, recoveryPath || '/');
          if (recoveryTarget) {
            try {
              var recoveryUrl = new URL(recoveryTarget);
              recoveryUrl.searchParams.delete('shpxid');
              if (referrerIntent.country && !recoveryUrl.searchParams.has('country')) {
                recoveryUrl.searchParams.set('country', referrerIntent.country);
              }
              if (recoveryUrl.toString() !== currentUrl.toString()) {
                writeStorageItem(window.sessionStorage, REFERRER_LOCALE_RECOVERY_KEY, '1');
                writeStorageItem(window.sessionStorage, AUTO_LOCALE_SESSION_KEY, '1');
                window.location.replace(recoveryUrl.toString());
                return;
              }
            } catch (_errRecoveryUrl) {
              // noop
            }
          }
        }
        // Fallback: when no explicit referrer intent exists, prefer browser language over forced .nl.
        if (!referrerIntent) {
          var browserPreferredBase = resolvePreferredLocaleBase('');
          if (browserPreferredBase && browserPreferredBase !== 'nl') {
            var fallbackComHost = sanitizeHostName(config.preferredComHost || 'www.nordbelt.com');
            var fallbackCanonicalPath = stripLocalePrefixFromPath(currentUrl.pathname, locales) || '/';
            var fallbackRoot = browserPreferredBase === 'en' ? '/' : '/' + browserPreferredBase;
            var fallbackPath = buildLocalizedPath(fallbackCanonicalPath, fallbackRoot);
            var fallbackTarget = buildHostSwapUrl(fallbackComHost, currentUrl, fallbackPath || '/');
            if (fallbackTarget) {
              try {
                var fallbackUrl = new URL(fallbackTarget);
                fallbackUrl.searchParams.delete('shpxid');
                if (!fallbackUrl.searchParams.has('country')) {
                  var fallbackCountry = resolveBrowserRegionCountryHint(browserPreferredBase) || countryCodeForLocaleBase(browserPreferredBase);
                  if (fallbackCountry) fallbackUrl.searchParams.set('country', fallbackCountry);
                }
                if (fallbackUrl.toString() !== currentUrl.toString()) {
                  writeStorageItem(window.sessionStorage, REFERRER_LOCALE_RECOVERY_KEY, '1');
                  writeStorageItem(window.sessionStorage, AUTO_LOCALE_SESSION_KEY, '1');
                  window.location.replace(fallbackUrl.toString());
                  return;
                }
              } catch (_errFallbackRecoveryUrl) {
                // noop
              }
            }
          }
        }
      }
    }

    if (readStorageItem(window.sessionStorage, AUTO_LOCALE_SESSION_KEY) === '1') return;
    if (isLikelyCrawlerUserAgent()) {
      writeStorageItem(window.sessionStorage, AUTO_LOCALE_SESSION_KEY, '1');
      return;
    }

    var manualLocale = normalizeLocaleCode(
      readStorageItem(window.localStorage, MANUAL_LOCALE_STORAGE_KEY) ||
      readStorageItem(window.sessionStorage, MANUAL_LOCALE_STORAGE_KEY)
    );
    if (shouldSkipAutoLocale(currentUrl.pathname, currentUrl.searchParams, !!manualLocale)) {
      writeStorageItem(window.sessionStorage, AUTO_LOCALE_SESSION_KEY, '1');
      return;
    }

    if (!isAutoLocaleEntryPath(currentUrl.pathname, locales)) {
      writeStorageItem(window.sessionStorage, AUTO_LOCALE_SESSION_KEY, '1');
      return;
    }

    var canonicalPath = stripLocalePrefixFromPath(currentUrl.pathname, locales);
    var countryHint = resolveUserCountryHint(config);
    var preferredLocaleBase = resolvePreferredLocaleBase(countryHint);
    if (isNlHost && preferredLocaleBase && preferredLocaleBase !== 'nl') {
      var forcedComHost = sanitizeHostName(config.preferredComHost || 'www.nordbelt.com');
      var forcedComRoot = preferredLocaleBase === 'en' ? '/' : '/' + preferredLocaleBase;
      var forcedComPath = buildLocalizedPath(canonicalPath || '/', forcedComRoot);
      var forcedComUrl = buildHostSwapUrl(forcedComHost, currentUrl, forcedComPath || '/');
      if (forcedComUrl && forcedComUrl !== currentUrl.toString()) {
        writeStorageItem(window.sessionStorage, AUTO_LOCALE_SESSION_KEY, '1');
        window.location.replace(forcedComUrl);
        return;
      }
    }

    var targetLocale = resolveAutoLocaleTarget(config, locales, countryHint);
    if (!targetLocale) {
      writeStorageItem(window.sessionStorage, AUTO_LOCALE_SESSION_KEY, '1');
      return;
    }

    var currentLocale = normalizeLocaleCode(config.currentLocale || document.documentElement.getAttribute('lang') || '');
    var currentLocaleBase = localeBaseCode(currentLocale);
    var currentRootUrl = normalizeLocaleRootUrl(config.currentRootUrl || '/');
    var targetRootUrl = normalizeLocaleRootUrl(targetLocale.rootUrl || '/');
    if (isNlHost && targetLocale.base === 'nl') {
      // Keep Dutch on nordbelt.nl at the root URL, never under /nl*.
      targetRootUrl = '/';
    }
    var localizedPath = buildLocalizedPath(canonicalPath, targetRootUrl);
    if (!localizedPath) {
      writeStorageItem(window.sessionStorage, AUTO_LOCALE_SESSION_KEY, '1');
      return;
    }

    if (targetLocale.base === 'nl' && !isNlHost) {
      var preferredNlHost = resolvePreferredNlHost(config, hostName);
      var nlPath = canonicalPath || '/';
      var crossDomainNlUrl = buildHostSwapUrl(preferredNlHost, currentUrl, nlPath);
      if (crossDomainNlUrl && crossDomainNlUrl !== currentUrl.toString()) {
        writeStorageItem(window.sessionStorage, AUTO_LOCALE_SESSION_KEY, '1');
        window.location.replace(crossDomainNlUrl);
        return;
      }
    }

    if (isNlHost && targetLocale.base !== 'nl') {
      var preferredComHost = sanitizeHostName(config.preferredComHost || 'www.nordbelt.com');
      var comPath = targetLocale.base === 'en' ? (canonicalPath || '/') : localizedPath;
      var comUrl = buildHostSwapUrl(preferredComHost, currentUrl, comPath);
      if (comUrl && comUrl !== currentUrl.toString()) {
        writeStorageItem(window.sessionStorage, AUTO_LOCALE_SESSION_KEY, '1');
        window.location.replace(comUrl);
        return;
      }
    }

    var sameLocale = targetLocale.code === currentLocale || targetLocale.base === currentLocaleBase;
    if (sameLocale && targetRootUrl === currentRootUrl && localizedPath === currentUrl.pathname) {
      writeStorageItem(window.sessionStorage, AUTO_LOCALE_SESSION_KEY, '1');
      return;
    }

    if (localizedPath === currentUrl.pathname || targetRootUrl === currentRootUrl) {
      writeStorageItem(window.sessionStorage, AUTO_LOCALE_SESSION_KEY, '1');
      applyAutoLocaleSelection(targetLocale.code, countryHint || config.countryCode, currentUrl);
      return;
    }

    currentUrl.pathname = localizedPath;
    currentUrl.searchParams.delete('locale');
    writeStorageItem(window.sessionStorage, AUTO_LOCALE_SESSION_KEY, '1');
    window.location.replace(currentUrl.toString());
  }

  function initFixedStackOffsets() {
    var root = document.documentElement;
    var header = document.querySelector('[data-nb-header]');
    var announcement = document.querySelector('.nb-announcement');
    if (!root || !header) return;

    var ticking = false;

    function applyOffsets() {
      var announcementHeight = announcement ? Math.round(announcement.getBoundingClientRect().height) : 0;
      var headerHeight = Math.round(header.getBoundingClientRect().height);
      var stackHeight = announcementHeight + headerHeight;
      root.style.setProperty('--nb-announcement-height', announcementHeight + 'px');
      root.style.setProperty('--nb-header-live-height', headerHeight + 'px');
      root.style.setProperty('--nb-fixed-stack-height', stackHeight + 'px');
    }

    function queueOffsets() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        applyOffsets();
        ticking = false;
      });
    }

    applyOffsets();
    window.addEventListener('resize', queueOffsets, { passive: true });

    var observer = new MutationObserver(queueOffsets);
    observer.observe(header, { attributes: true, attributeFilter: ['class', 'style'] });
    if (announcement) observer.observe(announcement, { attributes: true, childList: true, subtree: true });
    if ('ResizeObserver' in window) {
      var sizeObserver = new ResizeObserver(queueOffsets);
      sizeObserver.observe(header);
      if (announcement) sizeObserver.observe(announcement);
    }
  }

  function initFaq() {
    function decodeFaqEntities(value) {
      var probe = document.createElement('textarea');
      var output = value || '';

      for (var i = 0; i < 3; i += 1) {
        probe.innerHTML = output;
        var decoded = probe.value || '';
        if (!decoded || decoded === output) break;
        output = decoded;
      }

      return output
        .replace(/_NBTOK18__/g, '</p><p>')
        .replace(/NBTOK18__/g, '</p><p>')
        .replace(/_NBTOK20__/g, '</p><p>')
        .replace(/NBTOK20__/g, '</p><p>')
        .replace(/__NBTOK21\.__NBTOK21/g, '')
        .replace(/__NBTOK21/g, '')
        .replace(/__NTOK0__/g, 'Nordbelt™');
    }

    document.querySelectorAll('.nb-faq-content').forEach(function (node) {
      var raw = node.innerHTML || '';
      if (!raw) return;
      var normalized = decodeFaqEntities(raw);
      if (!normalized || normalized === raw) return;
      node.innerHTML = normalized;
    });

    document.querySelectorAll('[data-faq-item]').forEach(function (item) {
      var trigger = item.querySelector('[data-faq-trigger]');
      if (!trigger) return;

      trigger.addEventListener('click', function () {
        var open = item.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', String(open));
      });
    });
  }

  function initGallery() {
    var mainMedia = document.querySelector('[data-main-media]');
    if (!mainMedia) return;
    var productSection = mainMedia.closest('.nb-product');
    var galleryPin = productSection ? productSection.querySelector('.nb-product__gallery-pin') : null;
    var galleryMain = productSection ? productSection.querySelector('.nb-gallery-main') : null;
    var thumbsRail = productSection ? productSection.querySelector('.nb-gallery-thumbs') : null;
    var mobileHeroSlot = productSection ? productSection.querySelector('.nb-product__mobile-hero') : null;
    var mobileThumbsSlot = productSection ? productSection.querySelector('[data-mobile-thumbs-slot]') : null;
    var mobileHeroImage = productSection ? productSection.querySelector('.nb-product__mobile-hero-image') : null;
    var mobileTrigger = productSection ? productSection.querySelector('[data-mobile-main-media-trigger]') : null;
    var thumbs = Array.prototype.slice.call(thumbsRail ? thumbsRail.querySelectorAll('[data-gallery-thumb]') : []);
    var items = [];
    var currentIndex = 0;
    var lightbox = null;
    var lightboxImg = null;
    var lightboxCaption = null;
    var lightboxTouchStartX = null;
    var lightboxTouchStartY = null;
    var mobileLayoutMq = window.matchMedia('(max-width: 840px)');

    function collectItems() {
      if (!thumbs.length) {
        items = [{ src: mainMedia.getAttribute('src') || '', alt: mainMedia.getAttribute('alt') || '' }];
        return;
      }

      items = thumbs
        .map(function (thumb) {
          return {
            src: thumb.getAttribute('data-media-url') || '',
            alt: thumb.getAttribute('data-media-alt') || ''
          };
        })
        .filter(function (item) {
          return Boolean(item.src);
        });
    }

    function preloadGalleryImages(limit) {
      var max = Math.max(0, Number(limit) || 0);
      if (!max) return;
      items.slice(1, max + 1).forEach(function (item) {
        if (!item.src) return;
        var image = new Image();
        image.decoding = 'async';
        image.src = item.src;
      });
    }

    function scheduleGalleryPreload() {
      var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      if (connection && (connection.saveData || /2g/i.test(connection.effectiveType || ''))) return;
      var kickoff = function () {
        preloadGalleryImages(2);
      };
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(kickoff, { timeout: 1600 });
      } else {
        window.setTimeout(kickoff, 900);
      }
    }

    function syncThumbState(index) {
      thumbs.forEach(function (thumb, thumbIndex) {
        var isActive = thumbIndex === index;
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    function renderMain(index) {
      if (!items.length || !items[index]) return;
      currentIndex = index;
      mainMedia.setAttribute('src', items[index].src);
      mainMedia.setAttribute('alt', items[index].alt || '');
      if (mobileHeroImage) {
        mobileHeroImage.setAttribute('src', items[index].src);
        mobileHeroImage.setAttribute('alt', items[index].alt || '');
      }
      syncThumbState(index);
    }

    function syncMobileThumbPlacement() {
      if (!thumbsRail || !galleryPin || !galleryMain || !mobileHeroSlot) return;
      var mobileHeroVisible = window.getComputedStyle(mobileHeroSlot).display !== 'none';
      if (mobileLayoutMq.matches && mobileHeroVisible) {
        var mobileTarget = mobileThumbsSlot || mobileHeroSlot;
        if (!mobileTarget.contains(thumbsRail)) {
          mobileTarget.appendChild(thumbsRail);
        }
      } else if (!galleryPin.contains(thumbsRail)) {
        galleryMain.insertAdjacentElement('afterend', thumbsRail);
      }
    }

    function ensureLightbox() {
      if (lightbox) return;

      var lightboxLabel = i18n('gallery.lightbox_label', 'Productafbeelding groot bekijken');
      var backLabel = i18n('gallery.back', 'Terug');
      var prevLabel = i18n('gallery.prev', 'Vorige afbeelding');
      var nextLabel = i18n('gallery.next', 'Volgende afbeelding');

      lightbox = document.createElement('dialog');
      lightbox.className = 'nb-gallery-lightbox';
      lightbox.setAttribute('aria-label', lightboxLabel);
      lightbox.innerHTML =
        '<button type="button" class="nb-gallery-lightbox__back" data-gallery-lightbox-close aria-label="' + backLabel + '">' + backLabel + '</button>' +
        '<button type="button" class="nb-gallery-lightbox__nav nb-gallery-lightbox__nav--prev" data-gallery-lightbox-prev aria-label="' + prevLabel + '">&#8249;</button>' +
        '<figure class="nb-gallery-lightbox__figure">' +
        '  <img class="nb-gallery-lightbox__image" alt="">' +
        '  <figcaption class="nb-gallery-lightbox__caption"></figcaption>' +
        '</figure>' +
        '<button type="button" class="nb-gallery-lightbox__nav nb-gallery-lightbox__nav--next" data-gallery-lightbox-next aria-label="' + nextLabel + '">&#8250;</button>';

      document.body.appendChild(lightbox);
      lightboxImg = lightbox.querySelector('.nb-gallery-lightbox__image');
      lightboxCaption = lightbox.querySelector('.nb-gallery-lightbox__caption');

      var close = lightbox.querySelector('[data-gallery-lightbox-close]');
      var prev = lightbox.querySelector('[data-gallery-lightbox-prev]');
      var next = lightbox.querySelector('[data-gallery-lightbox-next]');

      close.addEventListener('click', function () {
        closeLightbox();
      });

      lightbox.addEventListener('click', function (event) {
        if (event.target === lightbox) closeLightbox();
      });

      prev.addEventListener('click', function (event) {
        event.stopPropagation();
        showLightboxItem(currentIndex - 1);
      });

      next.addEventListener('click', function (event) {
        event.stopPropagation();
        showLightboxItem(currentIndex + 1);
      });

      lightbox.addEventListener('touchstart', function (event) {
        if (!event.touches || !event.touches.length) return;
        lightboxTouchStartX = event.touches[0].clientX;
        lightboxTouchStartY = event.touches[0].clientY;
      }, { passive: true });

      lightbox.addEventListener('touchend', function (event) {
        if (lightboxTouchStartX === null || lightboxTouchStartY === null) return;
        if (!event.changedTouches || !event.changedTouches.length) return;

        var endX = event.changedTouches[0].clientX;
        var endY = event.changedTouches[0].clientY;
        var deltaX = endX - lightboxTouchStartX;
        var deltaY = endY - lightboxTouchStartY;
        var absX = Math.abs(deltaX);
        var absY = Math.abs(deltaY);

        lightboxTouchStartX = null;
        lightboxTouchStartY = null;

        if (absX < 36 || absX <= absY) return;
        if (deltaX < 0) showLightboxItem(currentIndex + 1);
        if (deltaX > 0) showLightboxItem(currentIndex - 1);
      }, { passive: true });
    }

    function showLightboxItem(index) {
      if (!items.length) return;
      if (index < 0) index = items.length - 1;
      if (index >= items.length) index = 0;
      currentIndex = index;
      var item = items[index];
      if (!item) return;
      lightboxImg.setAttribute('src', item.src);
      lightboxImg.setAttribute('alt', item.alt || '');
      lightboxCaption.textContent = item.alt || '';
      syncThumbState(index);
    }

    function openLightbox(index) {
      ensureLightbox();
      showLightboxItem(index);
      if (lightbox.open) return;
      if (typeof lightbox.showModal === 'function') {
        lightbox.showModal();
      } else {
        lightbox.setAttribute('open', 'open');
      }
    }

    function closeLightbox() {
      if (!lightbox || !lightbox.open) return;
      if (typeof lightbox.close === 'function') {
        lightbox.close();
      } else {
        lightbox.removeAttribute('open');
      }
    }

    collectItems();
    scheduleGalleryPreload();

    if (!items.length) return;

    mainMedia.style.cursor = 'zoom-in';
    mainMedia.addEventListener('click', function () {
      openLightbox(currentIndex);
    });

    if (mobileTrigger) {
      mobileTrigger.style.cursor = 'zoom-in';
      mobileTrigger.addEventListener('click', function (event) {
        if (event.target && event.target.closest && event.target.closest('[data-gallery-thumb]')) return;
        openLightbox(currentIndex);
      });
    }

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () {
        renderMain(index);
        openLightbox(index);
      });

      thumb.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        renderMain(index);
        openLightbox(index);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (!lightbox || !lightbox.open) return;
      if (event.key === 'Escape') {
        closeLightbox();
      } else if (event.key === 'ArrowLeft') {
        showLightboxItem(currentIndex - 1);
      } else if (event.key === 'ArrowRight') {
        showLightboxItem(currentIndex + 1);
      }
    });

    syncMobileThumbPlacement();
    window.requestAnimationFrame(syncMobileThumbPlacement);
    setTimeout(syncMobileThumbPlacement, 140);
    window.addEventListener('resize', syncMobileThumbPlacement, { passive: true });
    if (mobileLayoutMq.addEventListener) mobileLayoutMq.addEventListener('change', syncMobileThumbPlacement);
    else if (mobileLayoutMq.addListener) mobileLayoutMq.addListener(syncMobileThumbPlacement);

    renderMain(currentIndex);
  }

  function initMobileStickyCta() {
    var sticky = document.querySelector('[data-mobile-sticky-cta]');
    if (!sticky) return;
    document.body.classList.add('has-mobile-sticky-cta');
  }

  function initScrollTo() {
    var triggers = document.querySelectorAll('[data-scroll-to]');
    if (!triggers.length) return;

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var selector = trigger.getAttribute('data-scroll-target');
        if (!selector) return;
        var target = document.querySelector(selector);
        if (!target) return;
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function initGlobalMobileBuyCta() {
    var cta = document.querySelector('[data-mobile-float-buy]');
    if (!cta) return;
    var buyShortNeedle = normalizeCtaText(i18n('shared.buy_short', 'Koop nu'));

    var media = window.matchMedia('(max-width: 840px)');
    var pathname = (window.location.pathname || '').replace(/\/+$/, '');
    var isHomePage = pathname === '';
    var requiresHomeUnlock = isHomePage;
    var firstMainBuyCta = null;
    var homeUnlocked = !requiresHomeUnlock;
    var lastY = window.scrollY || 0;
    var travel = 0;
    var hidden = false;
    var lastToggleAt = 0;
    var ticking = false;
    var idleTimer = null;
    var competingSelectors = [
      '[data-mobile-sticky-cta]',
      '.nb-mobile-quick-cta'
    ];

    function getFirstMainBuyCta() {
      var candidates = document.querySelectorAll('#MainContent a, #MainContent button');
      for (var i = 0; i < candidates.length; i += 1) {
        var node = candidates[i];
        if (!node || node === cta || cta.contains(node)) continue;
        var text = (node.textContent || '').trim().toLowerCase();
        if (buyShortNeedle && text.indexOf(buyShortNeedle) !== -1) return node;
      }
      return null;
    }

    function hasReachedFirstHomeBuyCta() {
      if (!firstMainBuyCta || !firstMainBuyCta.getBoundingClientRect) return true;
      var rect = firstMainBuyCta.getBoundingClientRect();
      return rect.top <= window.innerHeight;
    }

    function isElementInViewport(element) {
      if (!element || !element.getBoundingClientRect) return false;
      var rect = element.getBoundingClientRect();
      if (rect.width <= 0 || rect.height <= 0) return false;
      var styles = window.getComputedStyle(element);
      if (styles.display === 'none' || styles.visibility === 'hidden' || Number(styles.opacity) === 0) return false;
      return rect.bottom > 0 && rect.top < window.innerHeight;
    }

    function hasCompetingCtaInViewport() {
      for (var i = 0; i < competingSelectors.length; i += 1) {
        var nodes = document.querySelectorAll(competingSelectors[i]);
        for (var j = 0; j < nodes.length; j += 1) {
          if (isElementInViewport(nodes[j])) return true;
        }
      }

      var ctaCandidates = document.querySelectorAll('a, button');
      for (var k = 0; k < ctaCandidates.length; k += 1) {
        var node = ctaCandidates[k];
        if (node === cta || cta.contains(node)) continue;
        var text = (node.textContent || '').trim().toLowerCase();
        if (!text) continue;
        if (!buyShortNeedle || text.indexOf(buyShortNeedle) === -1) continue;
        if (isElementInViewport(node)) return true;
      }
      return false;
    }

    function setHidden(nextHidden, force) {
      if (nextHidden === hidden && !force) return;
      var now = Date.now();
      if (!force && now - lastToggleAt < 120) return;
      hidden = nextHidden;
      lastToggleAt = now;
      cta.classList.toggle('is-hidden', hidden);
    }

    function updateVisibility() {
      ticking = false;
      if (!media.matches) {
        setHidden(false, true);
        return;
      }

      if (requiresHomeUnlock && !homeUnlocked) {
        homeUnlocked = hasReachedFirstHomeBuyCta();
        if (!homeUnlocked) {
          setHidden(true, true);
          return;
        }
      }

      var currentY = window.scrollY || 0;
      var delta = currentY - lastY;
      var absDelta = Math.abs(delta);
      var scrollingDown = delta > 0;
      var nearTop = currentY < 90;
      var competingVisible = hasCompetingCtaInViewport();

      if (absDelta > 1) {
        if ((travel > 0 && !scrollingDown) || (travel < 0 && scrollingDown)) {
          travel = 0;
        }
        travel += delta;
      }

      if (competingVisible) {
        setHidden(true, false);
      } else if (nearTop || travel < -18) {
        setHidden(false, false);
      } else if (travel > 24 && currentY > 120) {
        setHidden(true, false);
      }

      lastY = currentY;
    }

    function scheduleIdleReveal() {
      if (idleTimer) window.clearTimeout(idleTimer);
      idleTimer = window.setTimeout(function () {
        if (!media.matches) return;
        if (requiresHomeUnlock && !homeUnlocked) return;
        if (hasCompetingCtaInViewport()) return;
        travel = Math.min(travel, 0);
        setHidden(false, false);
      }, 500);
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateVisibility);
      scheduleIdleReveal();
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    firstMainBuyCta = getFirstMainBuyCta();
    if (requiresHomeUnlock && firstMainBuyCta == null) {
      homeUnlocked = true;
    }
    updateVisibility();
    scheduleIdleReveal();
  }

  function initProductDescriptionToggle() {
    var wrappers = document.querySelectorAll('[data-product-description]');
    if (!wrappers.length) return;
    var desktopMq = window.matchMedia('(min-width: 841px)');

    wrappers.forEach(function (wrap) {
      var content = wrap.querySelector('[data-product-description-content]');
      var toggle = wrap.querySelector('[data-product-description-toggle]');
      if (!content || !toggle) return;
      var section = wrap.closest('.nb-product');
      var panel = section ? section.querySelector('.nb-product__panel') : null;
      var galleryPin = section ? section.querySelector('.nb-product__gallery-pin') : null;
      var collapsedMaxHeight = 0;
      var desktopExpandedByUser = false;
      var syncRaf = 0;

      function setToggleLabel(isExpanded) {
        toggle.setAttribute('aria-expanded', String(isExpanded));
        toggle.textContent = isExpanded
          ? toggle.getAttribute('data-label-close') || 'Minder tonen'
          : toggle.getAttribute('data-label-open') || 'Lees meer';
      }

      function clearDesktopClamp() {
        collapsedMaxHeight = 0;
        desktopExpandedByUser = false;
        wrap.classList.remove('is-desktop-collapsible');
        content.style.maxHeight = '';
      }

      function applyDesktopClamp() {
        if (!desktopMq.matches || !panel || !galleryPin) {
          clearDesktopClamp();
          setToggleLabel(wrap.classList.contains('is-expanded'));
          updateToggleVisibility();
          return;
        }

        var wasExpanded = desktopExpandedByUser;
        wrap.classList.add('is-expanded');
        wrap.classList.remove('is-desktop-collapsible');
        content.style.maxHeight = '';

        var galleryHeight = Math.ceil(galleryPin.getBoundingClientRect().height);
        var panelHeight = Math.ceil(panel.getBoundingClientRect().height);
        var overflow = panelHeight - galleryHeight;
        var contentFullHeight = Math.ceil(content.scrollHeight);
        var shouldClamp = overflow > 6 && contentFullHeight > 0;

        if (!shouldClamp) {
          clearDesktopClamp();
          wrap.classList.remove('is-expanded');
          setToggleLabel(false);
          updateToggleVisibility();
          return;
        }

        collapsedMaxHeight = Math.max(0, contentFullHeight - overflow - 2);
        if (collapsedMaxHeight >= contentFullHeight - 6) {
          clearDesktopClamp();
          wrap.classList.remove('is-expanded');
          setToggleLabel(false);
          updateToggleVisibility();
          return;
        }

        wrap.classList.add('is-desktop-collapsible');
        content.style.maxHeight = collapsedMaxHeight + 'px';

        if (wasExpanded) {
          wrap.classList.add('is-expanded');
        } else {
          wrap.classList.remove('is-expanded');
        }

        setToggleLabel(wrap.classList.contains('is-expanded'));
        updateToggleVisibility();
      }

      function scheduleDesktopClampSync() {
        if (syncRaf) return;
        syncRaf = window.requestAnimationFrame(function () {
          syncRaf = 0;
          applyDesktopClamp();
        });
      }

      function updateToggleVisibility() {
        var overflows = content.scrollHeight > content.clientHeight + 6;
        if (desktopMq.matches && wrap.classList.contains('is-desktop-collapsible')) {
          overflows = true;
        }
        toggle.hidden = !overflows && !wrap.classList.contains('is-expanded');
      }

      toggle.addEventListener('click', function () {
        var isExpanded = wrap.classList.toggle('is-expanded');
        if (desktopMq.matches && wrap.classList.contains('is-desktop-collapsible')) {
          desktopExpandedByUser = isExpanded;
        }
        setToggleLabel(isExpanded);
        window.requestAnimationFrame(updateToggleVisibility);
      });

      window.requestAnimationFrame(function () {
        scheduleDesktopClampSync();
        updateToggleVisibility();
      });
      window.setTimeout(scheduleDesktopClampSync, 180);
      window.setTimeout(scheduleDesktopClampSync, 520);

      window.addEventListener('resize', scheduleDesktopClampSync);
      if (desktopMq.addEventListener) desktopMq.addEventListener('change', scheduleDesktopClampSync);
      else if (desktopMq.addListener) desktopMq.addListener(scheduleDesktopClampSync);

      if ('ResizeObserver' in window) {
        var resizeObserver = new ResizeObserver(scheduleDesktopClampSync);
        resizeObserver.observe(content);
        if (panel) resizeObserver.observe(panel);
        if (galleryPin) resizeObserver.observe(galleryPin);
      }
    });
  }

  function initMobileProductDetailsToggle() {
    var productSections = document.querySelectorAll('.nb-product');
    if (!productSections.length) return;

    var mobileMq = window.matchMedia('(max-width: 980px)');

    productSections.forEach(function (section) {
      var detailsGroups = section.querySelectorAll('[data-mobile-product-details]');
      var toggles = section.querySelectorAll('[data-mobile-product-details-toggle]');
      if (!detailsGroups.length || !toggles.length) return;

      function setCollapsed(collapsed) {
        detailsGroups.forEach(function (group, index) {
          if (!group) return;
          if (mobileMq.matches && collapsed && index > 0) {
            group.classList.add('is-collapsed');
          } else {
            group.classList.remove('is-collapsed');
          }
        });

        toggles.forEach(function (toggle) {
          if (!toggle) return;
          if (!mobileMq.matches) {
            toggle.hidden = true;
            toggle.setAttribute('aria-expanded', 'true');
            toggle.textContent = toggle.getAttribute('data-label-close') || 'Minder tonen';
            return;
          }
          toggle.hidden = false;
          toggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
          toggle.textContent = collapsed
            ? (toggle.getAttribute('data-label-open') || 'Meer lezen')
            : (toggle.getAttribute('data-label-close') || 'Minder tonen');
        });
      }

      toggles.forEach(function (toggle) {
        toggle.addEventListener('click', function () {
          var expanded = toggle.getAttribute('aria-expanded') === 'true';
          setCollapsed(expanded);
        });
      });

      setCollapsed(true);
      if (mobileMq.addEventListener) mobileMq.addEventListener('change', function () { setCollapsed(true); });
      else if (mobileMq.addListener) mobileMq.addListener(function () { setCollapsed(true); });
    });
  }

  function initFounderStoryMedia() {
    var sections = document.querySelectorAll('.nb-founder-story');
    if (!sections.length) return;

    var desktopMq = window.matchMedia('(min-width: 1061px)');

    sections.forEach(function (section) {
      var copy = section.querySelector('.nb-founder-story__copy');
      var media = section.querySelector('.nb-founder-story__media');
      var videoShell = section.querySelector('.nb-founder-story__video-shell');
      var mediaNode = section.querySelector('[data-founder-video], .nb-founder-story__video');
      var video = mediaNode && mediaNode.tagName && mediaNode.tagName.toLowerCase() === 'video' ? mediaNode : null;
      if (!copy || !media) return;

      var shouldPlay = false;
      var pausingProgrammatically = false;

      function syncDesktopHeights() {
        if (!desktopMq.matches) {
          media.style.height = '';
          if (videoShell) videoShell.style.height = '';
          return;
        }
        var copyHeight = Math.ceil(copy.getBoundingClientRect().height);
        if (copyHeight > 0) {
          media.style.height = copyHeight + 'px';
          if (videoShell) videoShell.style.height = '100%';
        }
      }

      function enforceVideoPolicy() {
        if (!video) return;
        video.muted = true;
        video.defaultMuted = true;
        video.autoplay = true;
        video.loop = true;
        video.playsInline = true;
        video.controls = false;
        video.setAttribute('muted', '');
        video.setAttribute('autoplay', '');
        video.setAttribute('loop', '');
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', 'true');
        video.setAttribute('tabindex', '-1');
        video.setAttribute('aria-hidden', 'true');
        video.setAttribute('disablepictureinpicture', '');
        video.removeAttribute('controls');
        video.style.pointerEvents = 'none';
      }

      function hydrateFounderVideoSource() {
        if (!video || video.dataset.nbSourceHydrated === 'true') return;
        var source = video.querySelector('source[data-src]');
        if (!source) {
          video.dataset.nbSourceHydrated = 'true';
          return;
        }
        var src = source.getAttribute('data-src') || '';
        if (!src) return;
        if (!source.getAttribute('src')) {
          source.setAttribute('src', src);
          if (typeof video.load === 'function') video.load();
        }
        video.dataset.nbSourceHydrated = 'true';
      }

      function playVideo() {
        if (!video) return;
        hydrateFounderVideoSource();
        enforceVideoPolicy();
        var p = video.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      }

      function pauseVideo() {
        if (!video) return;
        pausingProgrammatically = true;
        video.pause();
        window.setTimeout(function () {
          pausingProgrammatically = false;
        }, 0);
      }

      if (video) {
        if ('IntersectionObserver' in window) {
          var observer = new IntersectionObserver(
            function (entries) {
              entries.forEach(function (entry) {
                shouldPlay = entry.isIntersecting && entry.intersectionRatio >= 0.45;
                if (shouldPlay) playVideo();
                else pauseVideo();
              });
            },
            { threshold: [0, 0.25, 0.45, 0.7] }
          );
          observer.observe(section);
        } else {
          shouldPlay = true;
          playVideo();
        }

        video.addEventListener('pause', function () {
          if (pausingProgrammatically) return;
          if (shouldPlay) playVideo();
        });

        video.addEventListener('loadedmetadata', function () {
          enforceVideoPolicy();
          syncDesktopHeights();
        });

        document.addEventListener('visibilitychange', function () {
          if (document.hidden) {
            pauseVideo();
            return;
          }
          if (shouldPlay) playVideo();
        });

        enforceVideoPolicy();
        if (!('IntersectionObserver' in window)) {
          shouldPlay = true;
          playVideo();
        }
      }

      if (window.ResizeObserver) {
        var ro = new ResizeObserver(function () {
          syncDesktopHeights();
        });
        ro.observe(copy);
      }

      syncDesktopHeights();
      window.addEventListener('resize', syncDesktopHeights, { passive: true });
      if (desktopMq.addEventListener) desktopMq.addEventListener('change', syncDesktopHeights);
      else if (desktopMq.addListener) desktopMq.addListener(syncDesktopHeights);
    });
  }

  var mobileVideoViewportController = null;

  function createMobileVideoViewportController() {
    var observedVideos = [];
    var mobileMq = window.matchMedia('(max-width: 1120px), (pointer: coarse)');
    var observer = null;
    var syncRaf = 0;
    var manualSyncBound = false;
    var activationBound = false;
    var iosAutoPlayBoost = /iP(hone|ad|od)/.test(navigator.userAgent || '') ||
      (/Mac/.test(navigator.platform || '') && navigator.maxTouchPoints > 1);

    function isMobileMode() {
      return !!mobileMq.matches;
    }

    function getState(video) {
      if (!video.__nbMobileViewportState) {
        video.__nbMobileViewportState = {
          visible: false,
          retryTimer: 0,
          retryCount: 0
        };
      }
      return video.__nbMobileViewportState;
    }

    function shouldKeepAudio(video) {
      return !!(video && video.dataset && video.dataset.nbUserUnmuted === 'true');
    }

    function isFirstWithin(container, node, selector) {
      if (!container || !node) return false;
      var first = container.querySelector(selector);
      return first === node;
    }

    function isContextAutoplayAllowed(video) {
      if (!video || !video.isConnected) return false;

      var guideStep = video.closest('.nb-guide-pro__step, .nb-home-guide-steps__card, .nb-purpose-primer__step-card');
      if (guideStep) {
        if (guideStep.classList.contains('is-active')) return true;
        var guideRail = guideStep.parentElement;
        return isFirstWithin(guideRail, guideStep, '.nb-guide-pro__step, .nb-home-guide-steps__card, .nb-purpose-primer__step-card');
      }

      var videoCard = video.closest('.nb-video-card');
      if (videoCard) {
        if (videoCard.classList.contains('is-active')) return true;
        var videoGrid = videoCard.parentElement;
        var activeVideoCard = videoGrid ? videoGrid.querySelector('.nb-video-card.is-active') : null;
        if (activeVideoCard) return activeVideoCard === videoCard;
        return isFirstWithin(videoGrid, videoCard, '.nb-video-card');
      }

      return true;
    }

    function applyAutoplayPolicy(video) {
      if (!video) return;
      video.playsInline = true;
      video.autoplay = true;
      video.defaultMuted = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', 'true');
      video.setAttribute('autoplay', '');
      if (video.preload === 'none') video.preload = 'metadata';
      if (!shouldKeepAudio(video)) {
        video.muted = true;
        video.setAttribute('muted', '');
      }
    }

    function hydrateVideoSource(video) {
      if (!video || video.dataset.nbSourceHydrated === 'true') return;
      var source = video.querySelector('source[data-src]');
      if (!source) {
        video.dataset.nbSourceHydrated = 'true';
        return;
      }
      var src = source.getAttribute('data-src') || '';
      if (!src) return;
      if (!source.getAttribute('src')) {
        source.setAttribute('src', src);
        if (typeof video.load === 'function') video.load();
      }
      video.dataset.nbSourceHydrated = 'true';
    }

    function clearRetry(video) {
      var state = getState(video);
      if (!state.retryTimer) return;
      window.clearTimeout(state.retryTimer);
      state.retryTimer = 0;
    }

    function canAttemptPlay(video) {
      if (!video) return false;
      var state = getState(video);
      return state.visible && isMobileMode() && !document.hidden;
    }

    function scheduleRetry(video) {
      var state = getState(video);
      clearRetry(video);
      if (!canAttemptPlay(video)) return;
      var maxRetries = iosAutoPlayBoost ? 36 : 16;
      if (state.retryCount >= maxRetries) return;
      state.retryCount += 1;
      var baseDelay = iosAutoPlayBoost ? 70 : 100;
      var delayStep = iosAutoPlayBoost ? 90 : 120;
      var delayCap = iosAutoPlayBoost ? 1800 : 1500;
      var delay = Math.min(delayCap, baseDelay + state.retryCount * delayStep);
      state.retryTimer = window.setTimeout(function () {
        state.retryTimer = 0;
        if (!canAttemptPlay(video)) return;
        playVideo(video);
      }, delay);
    }

    function playVideo(video) {
      if (!canAttemptPlay(video)) return;
      applyAutoplayPolicy(video);
      hydrateVideoSource(video);
      var state = getState(video);
      var readyState = Number(video.readyState || 0);
      if (readyState < 2) {
        video.addEventListener('loadeddata', function onLoaded() {
          if (canAttemptPlay(video)) playVideo(video);
        }, { once: true });
        video.addEventListener('canplay', function onCanPlay() {
          if (canAttemptPlay(video)) playVideo(video);
        }, { once: true });
      }
      var playPromise = null;
      try {
        playPromise = video.play();
      } catch (_err) {
        scheduleRetry(video);
        return;
      }
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise
          .then(function () {
            clearRetry(video);
            state.retryCount = 0;
          })
          .catch(function () {
            scheduleRetry(video);
          });
      } else {
        clearRetry(video);
        state.retryCount = 0;
      }
    }

    function pauseVideo(video) {
      if (!video) return;
      clearRetry(video);
      if (!video.paused) video.pause();
    }

    function setVideoVisibility(video, ratio, intersecting) {
      if (!video) return;
      var state = getState(video);
      if (!isMobileMode()) {
        return;
      }
      var startThreshold = iosAutoPlayBoost ? 0.24 : 0.55;
      var keepThreshold = iosAutoPlayBoost ? 0.08 : 0.18;
      var nextVisible = state.visible
        ? (intersecting && ratio >= keepThreshold)
        : (intersecting && ratio >= startThreshold);
      if (nextVisible === state.visible) {
        if (nextVisible && video.paused) playVideo(video);
        return;
      }
      state.visible = nextVisible;
      if (nextVisible) playVideo(video);
      else pauseVideo(video);
    }

    function getViewportRatio(node) {
      if (!node || !node.getBoundingClientRect) return 0;
      var rect = node.getBoundingClientRect();
      var viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
      var visibleWidth = Math.max(0, Math.min(rect.right, viewportWidth) - Math.max(rect.left, 0));
      var visibleHeight = Math.max(0, Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0));
      var visibleArea = visibleWidth * visibleHeight;
      var totalArea = Math.max(1, rect.width * rect.height);
      return visibleArea / totalArea;
    }

    function syncAllVideos() {
      syncRaf = 0;
      observedVideos = observedVideos.filter(function (video) {
        if (!video) return false;
        if (!video.isConnected) {
          if (observer) observer.unobserve(video);
          return false;
        }
        return true;
      });
      observedVideos.forEach(function (video) {
        var ratio = getViewportRatio(video);
        setVideoVisibility(video, ratio, ratio > 0.01);
      });
    }

    function requestSync() {
      if (syncRaf) return;
      syncRaf = window.requestAnimationFrame(syncAllVideos);
    }

    function bindManualSync() {
      if (manualSyncBound) return;
      manualSyncBound = true;
      window.addEventListener('scroll', requestSync, { passive: true });
      window.addEventListener('resize', requestSync, { passive: true });
      window.addEventListener('orientationchange', requestSync, { passive: true });
      window.addEventListener('pageshow', requestSync);
    }

    function bindActivationFallback() {
      if (activationBound) return;
      activationBound = true;
      var forceSync = function () {
        requestSync();
      };
      document.addEventListener('touchstart', forceSync, { once: true, passive: true });
      document.addEventListener('click', forceSync, { once: true, passive: true });
    }

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            setVideoVisibility(entry.target, entry.intersectionRatio || 0, !!entry.isIntersecting);
          });
        },
        { threshold: [0, 0.08, 0.18, 0.35, 0.55, 0.75] }
      );
    } else {
      bindManualSync();
    }

    document.addEventListener('visibilitychange', function () {
      if (!isMobileMode()) return;
      if (document.hidden) {
        observedVideos.forEach(function (video) {
          var state = getState(video);
          state.visible = false;
          pauseVideo(video);
        });
        return;
      }
      requestSync();
    });

    if (mobileMq.addEventListener) {
      mobileMq.addEventListener('change', requestSync);
    } else if (mobileMq.addListener) {
      mobileMq.addListener(requestSync);
    }

    return {
      register: function (videos) {
        if (!videos || !videos.length) return;
        videos.forEach(function (video) {
          if (!video || video.__nbMobileViewportManaged) return;
          if (video.hasAttribute('data-nb-mobile-video-ignore')) return;
          if (
            video.hasAttribute('data-nb-home-guide-video') ||
            video.hasAttribute('data-nb-primer-video') ||
            video.hasAttribute('data-nb-guide-video') ||
            video.hasAttribute('data-nb-proof-video') ||
            video.hasAttribute('data-founder-video') ||
            video.hasAttribute('data-nb-guide-showcase-home-video')
          ) {
            return;
          }
          video.__nbMobileViewportManaged = true;
          observedVideos.push(video);
          if (observer) observer.observe(video);
        });
        bindActivationFallback();
        if (!observer) bindManualSync();
      },
      sync: requestSync
    };
  }

  function initMobileVideoViewportAutoplay(rootNode) {
    var scope = rootNode && rootNode.querySelectorAll ? rootNode : document;
    var videos = Array.prototype.slice.call(scope.querySelectorAll('video'));
    if (!videos.length) return;
    if (!mobileVideoViewportController) {
      mobileVideoViewportController = createMobileVideoViewportController();
    }
    mobileVideoViewportController.register(videos);
    mobileVideoViewportController.sync();
  }

  function initHomeGuideStepsRuntimePatch(rootNode) {
    var ENGINE_VERSION = '2026-03-04-r1-runtime';
    var compactMq = window.matchMedia('(max-width: 1120px)');
    var scope = rootNode && rootNode.querySelectorAll ? rootNode : document;
    var sections = Array.prototype.slice.call(
      scope.querySelectorAll('[id^="nb-home-guide-steps-"].nb-guide-pro--home-steps')
    );
    if (
      rootNode &&
      rootNode.matches &&
      rootNode.matches('[id^="nb-home-guide-steps-"].nb-guide-pro--home-steps')
    ) {
      sections.unshift(rootNode);
    }
    if (!sections.length) return;

    sections.forEach(function (initialRoot) {
      var sectionRoot = initialRoot;
      if (!sectionRoot) return;
      if (sectionRoot.getAttribute('data-nb-runtime-steps-patched') === 'true') return;

      // Detach all legacy inline listeners by replacing the section subtree once.
      if (sectionRoot.getAttribute('data-nb-runtime-steps-cloned') !== 'true') {
        if (!sectionRoot.parentNode) return;
        var replacement = sectionRoot.cloneNode(true);
        sectionRoot.parentNode.replaceChild(replacement, sectionRoot);
        sectionRoot = replacement;
        sectionRoot.setAttribute('data-nb-runtime-steps-cloned', 'true');
      }

      var stepsWrap = sectionRoot.querySelector('[data-nb-home-guide-steps-wrap]');
      var stepsRail = sectionRoot.querySelector('[data-nb-home-guide-steps]');
      var stepsIndicator = sectionRoot.querySelector('[data-nb-home-guide-steps-indicator]');
      if (!stepsWrap || !stepsRail) return;

      var cards = Array.prototype.slice.call(stepsRail.querySelectorAll('.nb-guide-pro__step'));
      if (!cards.length) return;

      var videoCards = cards.filter(function (card) {
        return !!card.querySelector('[data-nb-home-guide-video]');
      });
      var videos = videoCards.map(function (card) {
        return card.querySelector('[data-nb-home-guide-video]');
      });
      if (!videos.length) return;

      sectionRoot.setAttribute('data-nb-runtime-steps-patched', 'true');
      sectionRoot.setAttribute('data-nb-steps-engine', ENGINE_VERSION);

      var activeIndex = 0;
      var sectionVisible = false;
      var progressRaf = 0;
      var scrollSyncRaf = 0;
      var refreshRaf = 0;
      var gestureKickTs = 0;

      function clamp01(value) {
        return Math.max(0, Math.min(1, Number(value || 0)));
      }

      function setCardProgress(card, ratio) {
        if (!card) return;
        card.style.setProperty('--nb-guide-progress', String(clamp01(ratio)));
      }

      function resolvePlaybackRate(video, fallbackIndex) {
        if (!video) return 1;
        var attrValue = Number.parseFloat(video.getAttribute('data-nb-step-playback-rate') || '');
        if (Number.isFinite(attrValue) && attrValue > 0) return attrValue;

        var card = video.closest ? video.closest('.nb-guide-pro__step') : null;
        var stepIndex = Number.parseInt(card ? card.getAttribute('data-nb-step-index') : '', 10);
        if (!Number.isFinite(stepIndex) || stepIndex < 1) stepIndex = Number(fallbackIndex || 0) + 1;
        return stepIndex === 3 ? 1.5 : 1;
      }

      function applyPlaybackRate(video, fallbackIndex) {
        if (!video) return 1;
        var targetRate = resolvePlaybackRate(video, fallbackIndex);
        try {
          if (Math.abs(Number(video.defaultPlaybackRate || 1) - targetRate) > 0.001) {
            video.defaultPlaybackRate = targetRate;
          }
        } catch (_errDefaultRate) {}
        try {
          if (Math.abs(Number(video.playbackRate || 1) - targetRate) > 0.001) {
            video.playbackRate = targetRate;
          }
        } catch (_errRate) {}
        return targetRate;
      }

      function setVideoPreload(video, mode) {
        if (!video) return;
        var nextMode = mode === 'metadata' ? 'metadata' : 'none';
        if (video.preload !== nextMode) video.preload = nextMode;
        if (video.getAttribute('preload') !== nextMode) {
          video.setAttribute('preload', nextMode);
        }
      }

      function ensureVideo(video, fallbackIndex) {
        if (!video) return;
        video.autoplay = true;
        video.loop = false;
        video.playsInline = true;
        video.defaultMuted = true;
        video.muted = true;
        video.controls = false;
        video.setAttribute('autoplay', '');
        video.removeAttribute('loop');
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', 'true');
        video.setAttribute('muted', '');
        video.removeAttribute('controls');
        video.setAttribute('disablepictureinpicture', '');
        var preloadMode = Number(fallbackIndex) === Number(activeIndex) ? 'metadata' : 'none';
        setVideoPreload(video, preloadMode);
        applyPlaybackRate(video, fallbackIndex);
      }

      function hydrateVideo(video, forceReload, fallbackIndex) {
        if (!video) return;
        ensureVideo(video, fallbackIndex);
        var source = video.querySelector('source');
        var targetSrc = '';
        if (source) {
          targetSrc =
            source.getAttribute('src') ||
            source.getAttribute('data-src') ||
            video.getAttribute('data-nb-step-video-url') ||
            '';
        } else {
          targetSrc = video.getAttribute('src') || video.getAttribute('data-nb-step-video-url') || '';
        }
        if (!targetSrc) return;

        var changed = false;
        if (source) {
          if (source.getAttribute('src') !== targetSrc) {
            source.setAttribute('src', targetSrc);
            changed = true;
          }
        } else if (video.getAttribute('src') !== targetSrc) {
          video.setAttribute('src', targetSrc);
          changed = true;
        }

        if (forceReload === true || changed || video.dataset.nbSourceHydrated !== 'true') {
          try {
            if (typeof video.load === 'function') video.load();
          } catch (_errLoad) {}
        }
        video.dataset.nbSourceHydrated = 'true';
      }

      function playVideo(video, restart, fallbackIndex) {
        if (!video) return;
        setVideoPreload(video, 'metadata');
        hydrateVideo(video, false, fallbackIndex);
        if (restart === true) {
          try {
            video.currentTime = 0;
          } catch (_errCurrentTime) {}
        }

        var tryPlay = function () {
          applyPlaybackRate(video, fallbackIndex);
          var playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(function () {});
          }
        };

        if (video.readyState >= 2) {
          applyPlaybackRate(video, fallbackIndex);
          tryPlay();
          return;
        }

        var onReady = function () {
          if (!sectionVisible || document.hidden) return;
          tryPlay();
        };
        video.addEventListener('loadeddata', onReady, { once: true });
        video.addEventListener('canplay', onReady, { once: true });
      }

      function pauseVideo(video) {
        if (!video) return;
        try {
          video.pause();
        } catch (_errPause) {}
      }

      function stopProgressLoop() {
        if (!progressRaf) return;
        cancelAnimationFrame(progressRaf);
        progressRaf = 0;
      }

      function startProgressLoop() {
        stopProgressLoop();
        var tick = function () {
          if (!sectionVisible || document.hidden) {
            stopProgressLoop();
            return;
          }
          var currentVideo = videos[activeIndex];
          var currentCard = videoCards[activeIndex];
          if (currentVideo && currentCard) {
            var duration = Number(currentVideo.duration || 0);
            var ratio = duration > 0 ? Number(currentVideo.currentTime || 0) / duration : 0;
            setCardProgress(currentCard, ratio);
          }
          progressRaf = requestAnimationFrame(tick);
        };
        progressRaf = requestAnimationFrame(tick);
      }

      function markActiveCard(cardToActivate) {
        cards.forEach(function (card) {
          var isActive = card === cardToActivate;
          card.classList.toggle('is-active', isActive);
          if (!isActive) setCardProgress(card, 0);
        });
      }

      function centerCard(card) {
        if (!compactMq.matches || !card || !stepsRail) return;
        try {
          var left = card.offsetLeft - Math.max(0, (stepsRail.clientWidth - card.clientWidth) / 2);
          stepsRail.scrollTo({ left: left, behavior: 'smooth' });
        } catch (_errScroll) {}
      }

      function getCenteredVideoIndex() {
        if (!stepsRail || !videoCards.length) return -1;
        var railCenter = stepsRail.getBoundingClientRect().left + stepsRail.clientWidth / 2;
        var bestIndex = 0;
        var bestDistance = Infinity;
        videoCards.forEach(function (card, index) {
          var rect = card.getBoundingClientRect();
          var cardCenter = rect.left + rect.width / 2;
          var distance = Math.abs(cardCenter - railCenter);
          if (distance < bestDistance) {
            bestDistance = distance;
            bestIndex = index;
          }
        });
        return bestIndex;
      }

      function isNodeVisibleInViewport(node) {
        if (!node) return false;
        var rect = node.getBoundingClientRect();
        if (rect.width <= 0 || rect.height <= 0) return false;
        var vw = window.innerWidth || document.documentElement.clientWidth || 0;
        var vh = window.innerHeight || document.documentElement.clientHeight || 0;
        var visibleWidth = Math.max(0, Math.min(rect.right, vw) - Math.max(rect.left, 0));
        var visibleHeight = Math.max(0, Math.min(rect.bottom, vh) - Math.max(rect.top, 0));
        var visibleRatio = (visibleWidth * visibleHeight) / Math.max(1, rect.width * rect.height);
        return visibleRatio > 0.08;
      }

      function ensureRailDots() {
        if (!stepsIndicator) return;
        if (stepsIndicator.children.length === videoCards.length) return;
        stepsIndicator.innerHTML = '';
        for (var i = 0; i < videoCards.length; i += 1) {
          var dot = document.createElement('span');
          dot.className = 'nb-guide-pro__rail-dot';
          stepsIndicator.appendChild(dot);
        }
      }

      function updateRailState() {
        var maxLeft = Math.max(0, stepsRail.scrollWidth - stepsRail.clientWidth);
        var isScrollable = compactMq.matches && maxLeft > 8;
        stepsWrap.classList.toggle('is-scrollable', isScrollable);
        stepsWrap.classList.toggle('is-at-start', !isScrollable || stepsRail.scrollLeft <= 8);
        stepsWrap.classList.toggle('is-at-end', !isScrollable || stepsRail.scrollLeft >= maxLeft - 8);

        ensureRailDots();
        if (!stepsIndicator) return;
        stepsIndicator.style.display = isScrollable ? '' : 'none';
        if (!isScrollable) return;

        var dotIndex = compactMq.matches ? getCenteredVideoIndex() : activeIndex;
        if (dotIndex < 0) dotIndex = activeIndex;
        Array.prototype.forEach.call(stepsIndicator.children, function (dot, index) {
          dot.classList.toggle('is-active', index === dotIndex);
        });
      }

      function syncPlayback(options) {
        var settings = options || {};
        if (!sectionVisible || document.hidden) {
          videos.forEach(function (video) {
            setVideoPreload(video, 'none');
            pauseVideo(video);
          });
          stopProgressLoop();
          updateRailState();
          return;
        }

        var activeCard = videoCards[activeIndex];
        var activeVideo = videos[activeIndex];
        if (!activeCard || !activeVideo) {
          updateRailState();
          return;
        }

        markActiveCard(activeCard);

        videos.forEach(function (video, index) {
          if (index === activeIndex) {
            setVideoPreload(video, 'metadata');
            playVideo(video, settings.restart === true, index);
          } else {
            setVideoPreload(video, 'none');
            pauseVideo(video);
            if (settings.resetOthers === true) {
              try {
                video.currentTime = 0;
              } catch (_errReset) {}
            }
            setCardProgress(videoCards[index], 0);
          }
        });

        var nextIndex = (activeIndex + 1) % videos.length;
        var nextVideo = videos[nextIndex];
        if (nextVideo && nextIndex !== activeIndex) {
          setVideoPreload(nextVideo, 'metadata');
          hydrateVideo(nextVideo, false, nextIndex);
        }

        startProgressLoop();
        updateRailState();
      }

      function goTo(index, options) {
        var settings = options || {};
        activeIndex = (index + videos.length) % videos.length;
        syncPlayback({ restart: settings.restart === true, resetOthers: true });
        if (settings.center === true) centerCard(videoCards[activeIndex]);
      }

      function syncFromScroll() {
        scrollSyncRaf = 0;
        if (!compactMq.matches || !sectionVisible || document.hidden) return;
        var centered = getCenteredVideoIndex();
        if (centered < 0 || centered === activeIndex) return;
        activeIndex = centered;
        syncPlayback({ restart: true, resetOthers: true });
      }

      function refreshViewportState() {
        if (refreshRaf) cancelAnimationFrame(refreshRaf);
        refreshRaf = requestAnimationFrame(function () {
          refreshRaf = 0;
          sectionVisible = isNodeVisibleInViewport(stepsRail);
          syncPlayback();
        });
      }

      function kickPlaybackFromGesture() {
        var now = Date.now();
        if (now - gestureKickTs < 140) return;
        gestureKickTs = now;
        if (!sectionVisible || document.hidden) return;
        var current = videos[activeIndex] || videos[0];
        if (!current || !current.paused) return;
        playVideo(current, false, activeIndex);
      }

      videos.forEach(function (video, index) {
        ensureVideo(video, index);
        var shouldPrime = index === activeIndex || index === ((activeIndex + 1) % videos.length);
        if (shouldPrime) hydrateVideo(video, false, index);

        video.addEventListener('loadedmetadata', function () {
          applyPlaybackRate(video, index);
          if (index !== activeIndex) return;
          setCardProgress(videoCards[index], 0);
        });

        video.addEventListener('timeupdate', function () {
          if (index !== activeIndex) return;
          var duration = Number(video.duration || 0);
          var ratio = duration > 0 ? Number(video.currentTime || 0) / duration : 0;
          setCardProgress(videoCards[index], ratio);
        });

        video.addEventListener('ended', function () {
          if (index !== activeIndex) return;
          setCardProgress(videoCards[index], 1);
          goTo(activeIndex + 1, { restart: true, center: compactMq.matches });
        });

        video.addEventListener('waiting', function () {
          if (index !== activeIndex || !sectionVisible || document.hidden) return;
          playVideo(video, false, index);
        });

        video.addEventListener('stalled', function () {
          if (index !== activeIndex || !sectionVisible || document.hidden) return;
          playVideo(video, false, index);
        });

        video.addEventListener('error', function () {
          if (video.dataset.nbRetryAttempted === 'true') return;
          video.dataset.nbRetryAttempted = 'true';
          hydrateVideo(video, true, index);
          if (index === activeIndex) playVideo(video, true, index);
        });
      });

      videoCards.forEach(function (card, index) {
        card.addEventListener('click', function () {
          goTo(index, { restart: true, center: compactMq.matches });
        });
      });

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            var entry = entries[0];
            sectionVisible = !!(entry && entry.isIntersecting && entry.intersectionRatio > 0.08);
            syncPlayback();
          },
          { threshold: [0, 0.08, 0.2, 0.45] }
        );
        observer.observe(stepsRail);
      } else {
        sectionVisible = isNodeVisibleInViewport(stepsRail);
      }

      document.addEventListener('visibilitychange', function () {
        if (!document.hidden) {
          sectionVisible = isNodeVisibleInViewport(stepsRail);
        }
        syncPlayback();
      });

      var onCompactChange = function () {
        if (compactMq.matches) {
          var centered = getCenteredVideoIndex();
          if (centered >= 0) activeIndex = centered;
        }
        syncPlayback();
      };
      if (compactMq.addEventListener) compactMq.addEventListener('change', onCompactChange);
      else if (compactMq.addListener) compactMq.addListener(onCompactChange);

      window.addEventListener('pageshow', function () {
        sectionVisible = isNodeVisibleInViewport(stepsRail);
        syncPlayback();
      });

      stepsRail.addEventListener(
        'scroll',
        function () {
          updateRailState();
          if (scrollSyncRaf) cancelAnimationFrame(scrollSyncRaf);
          scrollSyncRaf = requestAnimationFrame(syncFromScroll);
        },
        { passive: true }
      );

      document.addEventListener('touchstart', kickPlaybackFromGesture, { passive: true });
      document.addEventListener('touchmove', kickPlaybackFromGesture, { passive: true });
      document.addEventListener('click', kickPlaybackFromGesture, { passive: true });
      window.addEventListener('resize', refreshViewportState, { passive: true });
      window.addEventListener('orientationchange', refreshViewportState, { passive: true });
      window.addEventListener('scroll', refreshViewportState, { passive: true });

      sectionVisible = isNodeVisibleInViewport(stepsRail);
      syncPlayback({ restart: true, resetOthers: true });
      window.setTimeout(updateRailState, 220);
    });
  }

  var heroTitleThreeLineFitRaf = 0;
  var heroTitleThreeLineFitTimeout = 0;
  var heroTitleThreeLineFitBootstrapped = false;

  function getElementLineHeightPx(node) {
    if (!node) return 0;
    var computed = window.getComputedStyle(node);
    var lineHeight = toFiniteNumber(computed.lineHeight, 0);
    if (lineHeight > 0) return lineHeight;
    var fontSize = toFiniteNumber(computed.fontSize, 16);
    return fontSize * 1.12;
  }

  function measureElementLineCount(node) {
    if (!node) return 1;
    if (document.createRange) {
      try {
        var range = document.createRange();
        range.selectNodeContents(node);
        var rects = range.getClientRects();
        if (rects && rects.length) {
          var uniqueTops = [];
          for (var i = 0; i < rects.length; i += 1) {
            var rect = rects[i];
            if (!rect || rect.height < 0.5 || rect.width < 0.5) continue;
            var normalizedTop = Math.round(rect.top * 2) / 2;
            var known = false;
            for (var j = 0; j < uniqueTops.length; j += 1) {
              if (Math.abs(uniqueTops[j] - normalizedTop) <= 0.7) {
                known = true;
                break;
              }
            }
            if (!known) uniqueTops.push(normalizedTop);
          }
          if (uniqueTops.length) return uniqueTops.length;
        }
      } catch (_err) {}
    }
    var lineHeight = getElementLineHeightPx(node);
    if (lineHeight <= 0) return 1;
    return Math.max(1, node.scrollHeight / lineHeight);
  }

  function fitHeroTitleToMaxLines(title, maxLines) {
    if (!title || !maxLines || maxLines < 1) return;
    var width = Math.ceil(title.getBoundingClientRect().width || 0);
    if (width < 8) return;

    title.style.removeProperty('font-size');
    var baseFontSize = toFiniteNumber(window.getComputedStyle(title).fontSize, 0);
    if (baseFontSize <= 0) return;

    var lineCount = measureElementLineCount(title);
    if (lineCount <= maxLines + 0.02) return;

    var minFontSize = Math.max(8.5, Math.min(baseFontSize - 0.1, baseFontSize * 0.52));
    var low = minFontSize;
    var high = baseFontSize;
    var best = minFontSize;

    for (var i = 0; i < 20; i += 1) {
      var mid = (low + high) / 2;
      title.style.setProperty('font-size', mid.toFixed(3) + 'px', 'important');
      lineCount = measureElementLineCount(title);
      if (lineCount <= maxLines + 0.02) {
        best = mid;
        low = mid + 0.05;
      } else {
        high = mid - 0.05;
      }
      if (low > high) break;
    }

    title.style.setProperty('font-size', best.toFixed(3) + 'px', 'important');
    var guard = 0;
    while (measureElementLineCount(title) > maxLines + 0.02 && best > 8.5 && guard < 28) {
      best = Math.max(8.5, best - 0.35);
      title.style.setProperty('font-size', best.toFixed(3) + 'px', 'important');
      guard += 1;
    }
  }

  function applyHeroTitleMaxLines(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var titles = root.querySelectorAll('[data-nb-hero-title]');
    if (!titles.length && root !== document) return;
    if (!titles.length) titles = document.querySelectorAll('[data-nb-hero] .nb-title');

    titles.forEach(function (title) {
      var maxLines = Math.round(toFiniteNumber(title.getAttribute('data-nb-max-lines'), 3));
      if (maxLines < 1) maxLines = 3;
      fitHeroTitleToMaxLines(title, maxLines);
    });
  }

  function scheduleHeroTitleMaxLines(scope) {
    var scopedRoot = scope && scope.querySelectorAll ? scope : null;
    if (scopedRoot) {
      window.requestAnimationFrame(function () {
        applyHeroTitleMaxLines(scopedRoot);
      });
    }

    if (heroTitleThreeLineFitRaf) cancelAnimationFrame(heroTitleThreeLineFitRaf);
    heroTitleThreeLineFitRaf = requestAnimationFrame(function () {
      heroTitleThreeLineFitRaf = 0;
      applyHeroTitleMaxLines(document);
    });

    if (heroTitleThreeLineFitTimeout) clearTimeout(heroTitleThreeLineFitTimeout);
    heroTitleThreeLineFitTimeout = window.setTimeout(function () {
      heroTitleThreeLineFitTimeout = 0;
      applyHeroTitleMaxLines(document);
    }, 180);
  }

  function initHeroTitleMaxLines(scope) {
    if (scope && scope.querySelectorAll) {
      scheduleHeroTitleMaxLines(scope);
    }

    if (heroTitleThreeLineFitBootstrapped) return;
    heroTitleThreeLineFitBootstrapped = true;

    var scheduleAll = function () {
      scheduleHeroTitleMaxLines(document);
    };

    window.addEventListener('resize', scheduleAll, { passive: true });
    window.addEventListener('orientationchange', scheduleAll, { passive: true });
    window.addEventListener('pageshow', scheduleAll);
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) scheduleAll();
    });

    if (document.fonts && typeof document.fonts.addEventListener === 'function') {
      document.fonts.addEventListener('loadingdone', scheduleAll);
    } else if (document.fonts && document.fonts.ready && typeof document.fonts.ready.then === 'function') {
      document.fonts.ready.then(scheduleAll).catch(function () {});
    }

    if ('MutationObserver' in window) {
      var heroRoot = document.querySelector('[data-nb-hero]');
      if (heroRoot) {
        var mutationObserver = new MutationObserver(function (mutations) {
          var shouldRefit = false;
          for (var i = 0; i < mutations.length; i += 1) {
            var mutation = mutations[i];
            if (!mutation) continue;
            if (mutation.type === 'characterData') {
              var parentNode = mutation.target && mutation.target.parentElement;
              if (parentNode && parentNode.closest && parentNode.closest('[data-nb-hero-title]')) {
                shouldRefit = true;
                break;
              }
            } else if (mutation.target && mutation.target.closest && mutation.target.closest('[data-nb-hero-title]')) {
              shouldRefit = true;
              break;
            }
          }
          if (shouldRefit) scheduleAll();
        });
        mutationObserver.observe(heroRoot, { childList: true, subtree: true, characterData: true });
      }
    }

    scheduleHeroTitleMaxLines(document);
  }

  function initHeroAbRuntimeFix() {
    var root = document.querySelector('[data-nb-hero]');
    if (!root) return;
    if (root.getAttribute('data-nb-hero-runtime-ab-patched') === 'true') return;

    var desktopImage = root.querySelector('[data-nb-hero-media-desktop]');
    var mobileImage = root.querySelector('[data-nb-hero-media-mobile]');
    if (!desktopImage || !mobileImage) return;

    var variantASrc = desktopImage.getAttribute('data-variant-a-src') || '';
    var variantBSrc = desktopImage.getAttribute('data-variant-b-src') || '';
    if (!variantASrc || !variantBSrc) return;

    var currentTestName = String(root.getAttribute('data-nb-hero-test-name') || '').trim();
    var stickyRaw = root.getAttribute('data-nb-hero-sticky-assignment');
    var needsFix = currentTestName !== 'hero_image_v2' || stickyRaw === null || stickyRaw === '';
    if (!needsFix) return;

    var testSignature = String(root.getAttribute('data-nb-hero-test-signature') || '');
    function hashSignature(value) {
      var hash = 5381;
      var str = String(value || '');
      for (var i = 0; i < str.length; i += 1) {
        hash = ((hash << 5) + hash) + str.charCodeAt(i);
      }
      return (hash >>> 0).toString(36);
    }

    function writeCookie(name, value, days) {
      var maxAge = Math.max(1, Math.floor((Number(days) || 365) * 24 * 60 * 60));
      document.cookie = name + '=' + encodeURIComponent(value) + '; path=/; max-age=' + maxAge + '; SameSite=Lax';
    }

    function readCookie(name) {
      var escaped = String(name || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      var match = document.cookie.match(new RegExp('(?:^|; )' + escaped + '=([^;]*)'));
      return match ? decodeURIComponent(match[1]) : '';
    }

    var signatureHash = testSignature ? hashSignature(testSignature) : '';
    var v2TestKey = signatureHash ? ('hero_image_v2__' + signatureHash) : 'hero_image_v2';
    var v2StorageKey = 'nb_hero_ab_' + v2TestKey;

    function readV2Variant() {
      var local = '';
      try {
        local = window.localStorage ? window.localStorage.getItem(v2StorageKey) : '';
      } catch (_err) {
        local = '';
      }
      if (local === 'A' || local === 'B') return local;
      var fromCookie = readCookie(v2StorageKey);
      if (fromCookie === 'A' || fromCookie === 'B') return fromCookie;
      return '';
    }

    function persistV2Variant(variant) {
      try {
        if (window.localStorage) window.localStorage.setItem(v2StorageKey, variant);
      } catch (_err) {}
      writeCookie(v2StorageKey, variant, 365);
    }

    var splitA = toFiniteNumber(root.getAttribute('data-nb-hero-split-a'), 50);
    splitA = Math.max(0, Math.min(100, splitA));
    var variant = readV2Variant();
    if (variant !== 'A' && variant !== 'B') {
      variant = String(root.getAttribute('data-nb-hero-variant') || '').toUpperCase();
    }
    if (variant !== 'A' && variant !== 'B') {
      variant = String(desktopImage.getAttribute('data-active-variant') || '').toUpperCase();
    }
    if (variant !== 'A' && variant !== 'B') {
      var currentDesktopSrc = desktopImage.getAttribute('src') || '';
      if (currentDesktopSrc === variantBSrc) variant = 'B';
      else if (currentDesktopSrc === variantASrc) variant = 'A';
    }
    if (variant !== 'A' && variant !== 'B') {
      variant = Math.random() * 100 < splitA ? 'A' : 'B';
    }

    var nextDesktopSrc = variant === 'B' ? variantBSrc : variantASrc;
    var nextMobileSrc = variant === 'B'
      ? (mobileImage.getAttribute('data-variant-b-src') || '')
      : (mobileImage.getAttribute('data-variant-a-src') || '');
    if (nextDesktopSrc) desktopImage.setAttribute('src', nextDesktopSrc);
    if (nextMobileSrc) mobileImage.setAttribute('src', nextMobileSrc);

    root.setAttribute('data-nb-hero-test-name', 'hero_image_v2');
    root.setAttribute('data-nb-hero-sticky-assignment', 'true');
    root.setAttribute('data-nb-hero-variant', variant);
    desktopImage.setAttribute('data-active-variant', variant);
    mobileImage.setAttribute('data-active-variant', variant);
    root.setAttribute('data-nb-hero-runtime-ab-patched', 'true');
    persistV2Variant(variant);

    var abApi = window.NordbeltAB && typeof window.NordbeltAB.recordExposure === 'function' ? window.NordbeltAB : null;
    if (abApi) {
      abApi.recordExposure({
        namespace: 'hero_image',
        testName: 'hero_image_v2',
        testSignature: testSignature,
        variant: variant,
        sectionId: root.id || '',
        source: 'v2-hero-runtime-fix'
      });
    }
  }

  function initCookieMiniBanner() {
    var banner = document.querySelector('[data-nb-cookie-banner]');
    if (!banner) return;
    var STORAGE_KEY = 'nb_cookie_consent_v1';

    function isPreviewThemeSession() {
      var role = '';
      try {
        role = String((window.Shopify && window.Shopify.theme && window.Shopify.theme.role) || '').toLowerCase();
      } catch (_err) {
        role = '';
      }

      var hasPreviewParam = false;
      try {
        hasPreviewParam = new URLSearchParams(window.location.search).has('preview_theme_id');
      } catch (_err2) {
        hasPreviewParam = false;
      }

      var hasPreviewBar =
        !!document.querySelector('#OnlineStorePreviewBarNextData') ||
        !!document.querySelector('[id*="OnlineStorePreviewBar"]') ||
        !!document.querySelector('[data-shopify-preview-bar]');

      return role === 'unpublished' || hasPreviewParam || hasPreviewBar;
    }

    if (!isPreviewThemeSession()) {
      writeSavedChoice('essential');
      applyShopifyConsent('essential');
      banner.hidden = true;
      banner.classList.remove('is-visible');
      if (document.body) document.body.classList.remove('nb-cookie-mini-active');
      return;
    }

    if (HIDE_COOKIE_BANNER_IN_PREVIEW && isPreviewThemeSession()) {
      document.documentElement.classList.add('nb-preview-theme');
      if (document.body) document.body.classList.add('nb-preview-theme');
      banner.hidden = true;
      banner.classList.remove('is-visible');
      document.body.classList.remove('nb-cookie-mini-active');
      return;
    }
    var acceptButton = banner.querySelector('[data-nb-cookie-accept]');
    var essentialButton = banner.querySelector('[data-nb-cookie-essential]');
    if (!acceptButton || !essentialButton) return;

    var hideTimer = null;
    var scrollDismissArmed = false;
    var scrollStartY = 0;
    var scrollListener = null;
    var SCROLL_DISMISS_DELTA = 10;

    function readSavedChoice() {
      var raw = readStorageItem(window.localStorage, STORAGE_KEY) || readStorageItem(window.sessionStorage, STORAGE_KEY);
      if (!raw) return '';
      if (raw === 'accepted' || raw === 'essential') return raw;
      var parsed = safeParseJson(raw, null);
      if (!parsed || typeof parsed !== 'object') return '';
      var choice = String(parsed.choice || '').toLowerCase();
      return (choice === 'accepted' || choice === 'essential') ? choice : '';
    }

    function writeSavedChoice(choice) {
      if (choice !== 'accepted' && choice !== 'essential') return;
      var payload = JSON.stringify({
        choice: choice,
        updated_at: new Date().toISOString()
      });
      writeStorageItem(window.localStorage, STORAGE_KEY, payload);
      writeStorageItem(window.sessionStorage, STORAGE_KEY, payload);
    }

    function clearScrollDismissListener() {
      scrollDismissArmed = false;
      if (!scrollListener) return;
      window.removeEventListener('scroll', scrollListener);
      scrollListener = null;
    }

    function armScrollDismissListener() {
      clearScrollDismissListener();
      scrollStartY = toFiniteNumber(window.scrollY, toFiniteNumber(window.pageYOffset, 0));
      scrollDismissArmed = true;
      scrollListener = function () {
        if (!scrollDismissArmed) return;
        var currentY = toFiniteNumber(window.scrollY, toFiniteNumber(window.pageYOffset, 0));
        if (Math.abs(currentY - scrollStartY) < SCROLL_DISMISS_DELTA) return;
        clearScrollDismissListener();
        // On passive scroll intent, treat as essential-only and close permanently.
        setChoice('essential');
      };
      window.addEventListener('scroll', scrollListener, { passive: true });
    }

    function applyShopifyConsent(choice) {
      var privacyApi = window.Shopify && window.Shopify.customerPrivacy;
      if (!privacyApi || typeof privacyApi.setTrackingConsent !== 'function') return;
      var allowTracking = choice === 'accepted';
      var payload = {
        analytics: allowTracking,
        marketing: allowTracking,
        preferences: allowTracking,
        sale_of_data: allowTracking
      };
      try {
        privacyApi.setTrackingConsent(payload, function () {});
      } catch (_err) {
        try {
          privacyApi.setTrackingConsent(allowTracking, function () {});
        } catch (_innerErr) {
          // noop
        }
      }
    }

    function readShopifyConsentChoice() {
      var privacyApi = window.Shopify && window.Shopify.customerPrivacy;
      if (!privacyApi || typeof privacyApi.currentVisitorConsent !== 'function') return '';
      try {
        var consent = privacyApi.currentVisitorConsent();
        if (!consent || typeof consent !== 'object') return '';
        var keys = ['analytics', 'marketing', 'preferences', 'sale_of_data'];
        var hasExplicit = keys.some(function (key) {
          return typeof consent[key] === 'boolean';
        });
        if (!hasExplicit) return '';
        var hasAccepted = !!(consent.analytics || consent.marketing || consent.preferences || consent.sale_of_data);
        return hasAccepted ? 'accepted' : 'essential';
      } catch (_err) {
        return '';
      }
    }

    function showBanner() {
      if (hideTimer) {
        window.clearTimeout(hideTimer);
        hideTimer = null;
      }
      banner.hidden = false;
      document.body.classList.add('nb-cookie-mini-active');
      window.requestAnimationFrame(function () {
        banner.classList.add('is-visible');
      });
      armScrollDismissListener();
    }

    function hideBanner() {
      clearScrollDismissListener();
      if (hideTimer) {
        window.clearTimeout(hideTimer);
        hideTimer = null;
      }
      banner.classList.remove('is-visible');
      document.body.classList.remove('nb-cookie-mini-active');
      hideTimer = window.setTimeout(function () {
        banner.hidden = true;
      }, 240);
    }

    function setChoice(choice) {
      writeSavedChoice(choice);
      applyShopifyConsent(choice);
      hideBanner();
    }

    acceptButton.addEventListener('click', function () {
      setChoice('accepted');
    });

    essentialButton.addEventListener('click', function () {
      setChoice('essential');
    });

    var savedChoice = readSavedChoice();
    if (savedChoice) {
      applyShopifyConsent(savedChoice);
      hideBanner();
      return;
    }

    var shopifyChoice = readShopifyConsentChoice();
    if (shopifyChoice) {
      writeSavedChoice(shopifyChoice);
      hideBanner();
      return;
    }

    showBanner();
  }

  function initGlobalReserveTimer() {
    var header = document.querySelector('[data-nb-header]');
    if (!header) return;

    var timerLink = header.querySelector('[data-nb-reserve-header]');
    var timeNode = header.querySelector('[data-nb-reserve-header-time]');
    var ringNode = header.querySelector('[data-nb-reserve-header-ring]');
    var modal = document.querySelector('[data-nb-reserve-expiry-modal]');
    var modalDialog = modal ? modal.querySelector('.nb-reserve-modal__dialog') : null;
    var modalDismissButtons = modal ? Array.prototype.slice.call(modal.querySelectorAll('[data-nb-reserve-dismiss]')) : [];
    var reservePanel = document.querySelector('[data-nb-reserve-panel]');
    var reservePanelStatus = reservePanel ? reservePanel.querySelector('.nb-cart-form__status') : null;
    var reservePanelHint = reservePanel ? reservePanel.querySelector('.nb-cart-reserve__hint') : null;
    var reservePanelResetButton = reservePanel ? reservePanel.querySelector('[data-nb-reserve-reset]') : null;
    var resetButtons = Array.prototype.slice.call(document.querySelectorAll('[data-nb-reserve-reset]'));
    var previewPathLinks = Array.prototype.slice.call(document.querySelectorAll('[data-nb-reserve-preview-path]'));
    var modalCheckoutLink = modal ? modal.querySelector('[data-nb-reserve-checkout]') : null;
    var modalCartLink = modal ? modal.querySelector('[data-nb-reserve-go-cart]') : null;

    var STORAGE_KEY = 'nb_reserve_timer_v3';
    var LAST_CART_COUNT_KEY = 'nb_reserve_last_cart_count_v1';
    var DEFAULT_SECONDS = 600;
    var DEFAULT_DELAY_MS = 3000;
    var CART_THRESHOLD_FOR_TIMER = 1;
    var timerId = null;
    var panelHideTimer = null;
    var panelHideFinalizeTimer = null;
    var PANEL_HIDE_DELAY_MS = 5000;
    var PANEL_COLLAPSE_MS = 420;
    var titleFlashId = null;
    var modalOpen = false;
    var baseTitle = document.title || 'Nordbelt';
    var notifiedCycleId = '';
    var cartCount = Math.max(0, Math.round(toFiniteNumber(header.getAttribute('data-cart-count'), 0)));
    var state = readState();

    function readState() {
      try {
        var raw = window.localStorage.getItem(STORAGE_KEY);
        if (!raw) return null;
        var parsed = JSON.parse(raw);
        if (!parsed || typeof parsed !== 'object') return null;
        if (!Number.isFinite(parsed.endAt) || !Number.isFinite(parsed.duration) || !Number.isFinite(parsed.delayUntil)) return null;
        parsed.duration = Math.max(60, Math.round(parsed.duration));
        parsed.endAt = Math.round(parsed.endAt);
        parsed.delayUntil = Math.round(parsed.delayUntil);
        parsed.expired = parsed.expired === true;
        parsed.cycleId = parsed.cycleId ? String(parsed.cycleId) : createEventId('reserve');
        return parsed;
      } catch (_err) {
        return null;
      }
    }

    function persistState(nextState) {
      state = nextState;
      try {
        if (!nextState) {
          window.localStorage.removeItem(STORAGE_KEY);
        } else {
          window.localStorage.setItem(STORAGE_KEY, JSON.stringify(nextState));
        }
      } catch (_err) {
        // noop
      }
      return state;
    }

    function clearState() {
      persistState(null);
    }

    function readLastCartCount() {
      try {
        var raw = window.localStorage.getItem(LAST_CART_COUNT_KEY);
        if (raw == null) return null;
        var parsed = parseInt(raw, 10);
        return Number.isFinite(parsed) ? Math.max(0, parsed) : null;
      } catch (_err) {
        return null;
      }
    }

    function writeLastCartCount(count) {
      try {
        window.localStorage.setItem(LAST_CART_COUNT_KEY, String(Math.max(0, Math.round(toFiniteNumber(count, 0)))));
      } catch (_err) {
        // noop
      }
    }

    function applyPreviewPaths() {
      previewPathLinks.forEach(function (link) {
        if (!link || !link.getAttribute) return;
        var path = link.getAttribute('data-nb-reserve-preview-path') || '';
        if (!path) return;
        link.setAttribute('href', buildShopifyPathWithPreview(path));
      });
    }

    function formatTime(seconds) {
      var safe = Math.max(0, Math.round(seconds));
      var mins = Math.floor(safe / 60);
      var secs = safe % 60;
      return String(mins).padStart(2, '0') + ':' + String(secs).padStart(2, '0');
    }

    function setRingProgress(progress) {
      if (!ringNode) return;
      var clamped = Math.max(0, Math.min(100, toFiniteNumber(progress, 0)));
      ringNode.style.setProperty('--nb-reserve-progress', clamped.toFixed(2));
    }

    function clearPanelHideTimers() {
      if (panelHideTimer) {
        window.clearTimeout(panelHideTimer);
        panelHideTimer = null;
      }
      if (panelHideFinalizeTimer) {
        window.clearTimeout(panelHideFinalizeTimer);
        panelHideFinalizeTimer = null;
      }
    }

    function collapseReservePanelAnimated() {
      if (!reservePanel || reservePanel.hidden || reservePanel.classList.contains('is-collapsing')) return;
      if (state && state.expired) return;
      clearPanelHideTimers();
      reservePanel.classList.add('is-collapsing');
      panelHideFinalizeTimer = window.setTimeout(function () {
        reservePanel.hidden = true;
        reservePanel.classList.remove('is-collapsing');
        reservePanel.classList.add('is-collapsed');
      }, PANEL_COLLAPSE_MS);
    }

    function showReservePanelTemporarily() {
      if (!reservePanel) return;
      if (state && state.expired) {
        reservePanel.hidden = true;
        reservePanel.classList.remove('is-collapsing', 'is-expired');
        reservePanel.classList.add('is-collapsed');
        return;
      }
      clearPanelHideTimers();
      reservePanel.hidden = false;
      reservePanel.classList.remove('is-collapsing', 'is-collapsed');
      // Force layout so collapse animation starts reliably.
      reservePanel.offsetHeight;
      panelHideTimer = window.setTimeout(function () {
        collapseReservePanelAnimated();
      }, PANEL_HIDE_DELAY_MS);
    }

    function maybeShowReservePanelForFreshAdd() {
      if (!reservePanel) return;
      if (cartCount < CART_THRESHOLD_FOR_TIMER) return;
      if (!state || state.expired) return;
      if (!consumeReservePanelNotice()) return;
      showReservePanelTemporarily();
    }

    function setModalOpen(nextOpen) {
      if (!modal) return;
      if (nextOpen === modalOpen) return;
      modalOpen = nextOpen;
      modal.hidden = !nextOpen;
      modal.setAttribute('aria-hidden', nextOpen ? 'false' : 'true');
      document.body.classList.toggle('nb-reserve-modal-open', nextOpen);
      if (nextOpen) {
        window.requestAnimationFrame(function () {
          modal.classList.add('is-open');
        });
      } else {
        modal.classList.remove('is-open');
      }
    }

    function dismissExpiredModal() {
      clearState();
      stopTicking();
      clearPanelHideTimers();
      stopTitleFlash();
      if (reservePanel) {
        reservePanel.hidden = true;
        reservePanel.classList.remove('is-collapsing', 'is-expired');
        reservePanel.classList.add('is-collapsed');
      }
      setModalOpen(false);
      render();
    }

    function stopTitleFlash() {
      if (titleFlashId) {
        window.clearInterval(titleFlashId);
        titleFlashId = null;
      }
      document.title = baseTitle;
    }

    function maybeStartTitleFlash() {
      if (document.visibilityState !== 'hidden') return;
      if (titleFlashId) return;
      titleFlashId = window.setInterval(function () {
        document.title = document.title === baseTitle
          ? i18n('reserve.expired_title', '⏱️ Reservering verlopen - Nordbelt')
          : baseTitle;
      }, 1200);
    }

    function requestNotificationPermissionOnIntent() {
      if (SUPPRESS_BROWSER_POPUPS) return;
      if (!('Notification' in window)) return;
      if (Notification.permission !== 'default') return;

      var asked = false;
      function askPermission() {
        if (asked) return;
        asked = true;
        try {
          Notification.requestPermission();
        } catch (_err) {
          // noop
        }
      }

      document.addEventListener('pointerdown', askPermission, { once: true, passive: true });
      document.addEventListener('keydown', askPermission, { once: true });
    }

    function maybeSendExpiryNotification() {
      if (!state || !state.expired) return;
      if (notifiedCycleId === state.cycleId) return;
      notifiedCycleId = state.cycleId;

      if (document.visibilityState === 'hidden') {
        maybeStartTitleFlash();
      }

      if (SUPPRESS_BROWSER_POPUPS) return;

      if (!('Notification' in window)) return;
      if (Notification.permission !== 'granted') return;

      if (document.visibilityState === 'hidden') {
        try {
          var notificationIcon = '';
          try {
            notificationIcon = (window.NordbeltThemeAssets && window.NordbeltThemeAssets.notificationIcon) || '';
          } catch (_iconErr) {
            notificationIcon = '';
          }
          if (notificationIcon && notificationIcon.indexOf('//') === 0) {
            notificationIcon = window.location.protocol + notificationIcon;
          }
          var notificationOptions = {
            body: i18n('reserve.notification_body', 'Je product staat nog in je winkelwagen. Rond direct af of reserveer opnieuw 10 minuten.')
          };
          if (notificationIcon) {
            notificationOptions.icon = notificationIcon;
          }
          var notice = new Notification(i18n('reserve.notification_title', 'Je Nordbelt reservering is verlopen'), notificationOptions);
          notice.onclick = function () {
            try {
              window.focus();
            } catch (_err) {
              // noop
            }
            setModalOpen(true);
          };
        } catch (_err) {
          // noop
        }
      }
    }

    function syncReservePanel(isExpired) {
      if (!reservePanel) return;
      reservePanel.classList.toggle('is-expired', isExpired);
      if (reservePanelResetButton) reservePanelResetButton.hidden = true;
      if (reservePanelStatus) {
        reservePanelStatus.textContent = i18n('reserve.panel_active', 'Reservering actief');
      }
      if (reservePanelHint) {
        reservePanelHint.textContent = i18n('reserve.panel_hint', 'Timer loopt in de header naast je winkelwagen.');
      }
    }

    function getSecondsLeft(now) {
      if (!state) return 0;
      if (state.expired) return 0;
      if (now < state.delayUntil) return state.duration;
      return Math.max(0, Math.ceil((state.endAt - now) / 1000));
    }

    function getProgress(now) {
      if (!state) return 0;
      if (state.expired) return 100;
      if (now <= state.delayUntil) return 0;
      var elapsed = (now - state.delayUntil) / 1000;
      return Math.max(0, Math.min(100, (elapsed / state.duration) * 100));
    }

    function startTicking() {
      if (timerId) return;
      timerId = window.setInterval(function () {
        render();
      }, 250);
    }

    function stopTicking() {
      if (!timerId) return;
      window.clearInterval(timerId);
      timerId = null;
    }

    function startCycle(options) {
      if (cartCount < CART_THRESHOLD_FOR_TIMER) return;
      var now = Date.now();
      var duration = Math.max(60, Math.round(toFiniteNumber(options && options.duration, DEFAULT_SECONDS)));
      var startDelayMs = Math.max(0, Math.round(toFiniteNumber(options && options.startDelayMs, DEFAULT_DELAY_MS)));
      var delayUntil = now + startDelayMs;
      persistState({
        version: 3,
        duration: duration,
        delayUntil: delayUntil,
        endAt: delayUntil + duration * 1000,
        expired: false,
        cycleId: createEventId('reserve')
      });
      writeLastCartCount(cartCount);
      notifiedCycleId = '';
      stopTitleFlash();
      setModalOpen(false);
      startTicking();
      render();
    }

    function ensureState() {
      if (cartCount < CART_THRESHOLD_FOR_TIMER) {
        clearState();
        return;
      }
      if (!state) {
        startCycle({ startDelayMs: DEFAULT_DELAY_MS });
      }
    }

    function setCartCount(nextCount) {
      var previousCount = cartCount;
      cartCount = Math.max(0, Math.round(toFiniteNumber(nextCount, 0)));
      header.setAttribute('data-cart-count', String(cartCount));
      writeLastCartCount(cartCount);

      if (cartCount < CART_THRESHOLD_FOR_TIMER) {
        clearReservePanelNotice();
        clearState();
        stopTicking();
        clearPanelHideTimers();
        stopTitleFlash();
        setModalOpen(false);
        if (reservePanel) {
          reservePanel.hidden = true;
          reservePanel.classList.add('is-collapsed');
        }
        render();
        return;
      }

      if (cartCount > previousCount) {
        armReservePanelNotice();
        startCycle({ duration: DEFAULT_SECONDS, startDelayMs: 0 });
        maybeShowReservePanelForFreshAdd();
        return;
      }

      ensureState();
      startTicking();
      render();
    }

    function render() {
      var now = Date.now();
      var hasCart = cartCount >= CART_THRESHOLD_FOR_TIMER;
      var hasTimer = hasCart && !!state;

      header.classList.toggle('has-reserve-timer', hasTimer);
      if (timerLink) timerLink.hidden = !hasTimer;

      if (!hasTimer) {
        if (timerLink) timerLink.classList.remove('is-expiring', 'is-expired');
        clearPanelHideTimers();
        if (reservePanel) {
          reservePanel.hidden = true;
          reservePanel.classList.remove('is-collapsing', 'is-expired');
          reservePanel.classList.add('is-collapsed');
        }
        syncReservePanel(false);
        return;
      }

      if (!state.expired && now >= state.endAt) {
        state.expired = true;
        state.expiredAt = now;
        persistState(state);
      }

      var secondsLeft = getSecondsLeft(now);
      var progress = getProgress(now);

      if (timeNode) timeNode.textContent = formatTime(secondsLeft);
      setRingProgress(progress);

      if (state.expired) {
        if (timerLink) {
          timerLink.classList.add('is-expired');
          timerLink.classList.remove('is-expiring');
        }
        clearPanelHideTimers();
        if (reservePanel) {
          reservePanel.hidden = true;
          reservePanel.classList.remove('is-collapsing', 'is-expired');
          reservePanel.classList.add('is-collapsed');
        }
        syncReservePanel(false);
        setModalOpen(true);
        maybeSendExpiryNotification();
        return;
      }

      var isExpiring = secondsLeft <= 120 && now >= state.delayUntil;
      if (timerLink) {
        timerLink.classList.toggle('is-expiring', isExpiring);
        timerLink.classList.remove('is-expired');
      }
      syncReservePanel(false);
      setModalOpen(false);
    }

    function handleReset(event) {
      var fromReservePanel = !!(event && event.target && reservePanel && reservePanel.contains(event.target));
      if (event && typeof event.preventDefault === 'function') {
        event.preventDefault();
      }
      startCycle({ startDelayMs: 0 });
      if (fromReservePanel) {
        showReservePanelTemporarily();
      }
    }

    resetButtons.forEach(function (button) {
      button.addEventListener('click', handleReset);
    });

    modalDismissButtons.forEach(function (button) {
      button.addEventListener('click', function (event) {
        if (event && typeof event.preventDefault === 'function') event.preventDefault();
        if (event && typeof event.stopPropagation === 'function') event.stopPropagation();
        dismissExpiredModal();
      });
    });

    if (modal && modalDialog) {
      modal.addEventListener('click', function (event) {
        if (!modalOpen) return;
        if (!event || !event.target) return;
        if (modalDialog.contains(event.target)) return;
        dismissExpiredModal();
      });
    }

    document.addEventListener('keydown', function (event) {
      if (!modalOpen) return;
      if (!event || event.key !== 'Escape') return;
      dismissExpiredModal();
    });

    if (modalCheckoutLink) {
      modalCheckoutLink.addEventListener('click', function () {
        setModalOpen(false);
      });
    }

    if (modalCartLink) {
      modalCartLink.addEventListener('click', function (event) {
        if (event && typeof event.preventDefault === 'function') event.preventDefault();
        startCycle({ duration: DEFAULT_SECONDS, startDelayMs: 0 });
        setModalOpen(false);
        var targetHref = modalCartLink.getAttribute('href') || '/cart';
        window.location.assign(targetHref);
      });
    }

    document.addEventListener('nb:cart-count-updated', function (event) {
      var detail = event && event.detail ? event.detail : {};
      setCartCount(detail.count);
    });

    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') {
        stopTitleFlash();
        if (state && state.expired && cartCount >= CART_THRESHOLD_FOR_TIMER) {
          setModalOpen(true);
        }
      }
    });

    window.addEventListener('storage', function (event) {
      if (!event || event.key !== STORAGE_KEY) return;
      state = readState();
      if (!state) {
        clearPanelHideTimers();
        setModalOpen(false);
        if (timerLink) timerLink.hidden = true;
        header.classList.remove('has-reserve-timer');
        stopTicking();
      } else {
        startTicking();
      }
      render();
    });

    applyPreviewPaths();
    requestNotificationPermissionOnIntent();
    var lastCartCount = readLastCartCount();
    if (cartCount >= CART_THRESHOLD_FOR_TIMER && lastCartCount !== null && cartCount > lastCartCount) {
      armReservePanelNotice();
      startCycle({ duration: DEFAULT_SECONDS, startDelayMs: 0 });
    } else {
      ensureState();
    }
    writeLastCartCount(cartCount);
    if (state && cartCount >= CART_THRESHOLD_FOR_TIMER) startTicking();
    render();
    maybeShowReservePanelForFreshAdd();

    window.NordbeltTheme = window.NordbeltTheme || {};
    window.NordbeltTheme.reserveTimer = {
      reset: function () {
        startCycle({ startDelayMs: 0 });
      },
      start: function (seconds, delayMs) {
        startCycle({ duration: seconds, startDelayMs: delayMs });
      },
      clear: function () {
        clearState();
        render();
      },
      getState: function () {
        return state ? Object.assign({}, state) : null;
      }
    };
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCookieMiniBanner();
    initImageLoadingHints();
    localizeInternalAnchors(document);
    initSwedishKronaPriceFormatting();
    initConversionCtaRoutes();
    initArticleInlineConversionBlocks(document);
    initClarityRuntimeBridge();
    initViewItemTracking();
    initAtcTracking();
    initBeginCheckoutTracking();
    initAdPlatformBridges();
    initCtaTracking();
    initBlogConversionTracking(document);
    initReveal();
    initMobileNav();
    initRuntimeSeoGuards();
    initAutoLocaleRouting();
    initAnnouncementAutoHide();
    initHeaderCompactState();
    initHeaderLocalization();
    restoreCartAfterLocaleSwitch();
    initFixedStackOffsets();
    initFaq();
    initGallery();
    initMobileStickyCta();
    initScrollTo();
    initGlobalMobileBuyCta();
    initArticleMobileStickyCta(document);
    initProductDescriptionToggle();
    initMobileProductDetailsToggle();
    initFounderStoryMedia();
    initHeroAbRuntimeFix();
    initHeroTitleMaxLines(document);
    initHomeGuideStepsRuntimePatch(document);
    initMobileVideoViewportAutoplay(document);
    initGlobalReserveTimer();
  });

  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;
    initImageLoadingHints(event.target);
    localizeInternalAnchors(event.target);
    normalizeSwedishKronaPricesInScope(event.target);
    applyConversionCtaRoutes(event.target);
    applyConversionPreviewPaths(event.target);
    initArticleInlineConversionBlocks(event.target);
    initCtaTracking();
    initBlogConversionTracking(event.target);
    initArticleMobileStickyCta(event.target);
    initHeroAbRuntimeFix();
    initHeroTitleMaxLines(event.target);
    initHomeGuideStepsRuntimePatch(event.target);
    initMobileVideoViewportAutoplay(event.target);
  });
})();
